(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7509,1674,2945,4557,2948,3066,258],{

/***/ 455695:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/[pid]/[pname]",
      function () {
        return __webpack_require__(577412);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 285946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ BackArrow; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);



function BackArrow(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        height: props.height || 24,
        width: props.width || 24,
        viewBox: "0 0 447.243 447.243"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: "#000000",
            d: "M420.361 192.229a31.967 31.967 0 00-5.535-.41H99.305l6.88-3.2a63.998 63.998 0 0018.08-12.8l88.48-88.48c11.653-11.124 13.611-29.019 4.64-42.4-10.441-14.259-30.464-17.355-44.724-6.914a32.018 32.018 0 00-3.276 2.754l-160 160c-12.504 12.49-12.515 32.751-.025 45.255l.025.025 160 160c12.514 12.479 32.775 12.451 45.255-.063a32.084 32.084 0 002.745-3.137c8.971-13.381 7.013-31.276-4.64-42.4l-88.32-88.64a64.002 64.002 0 00-16-11.68l-9.6-4.32h314.24c16.347.607 30.689-10.812 33.76-26.88 2.829-17.445-9.019-33.88-26.464-36.71z"
        })
    }));
}


/***/ }),

/***/ 273467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ CloseIconGrey; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);

function CloseIconGrey() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M11.8346 1.34102L10.6596 0.166016L6.0013 4.82435L1.34297 0.166016L0.167969 1.34102L4.8263 5.99935L0.167969 10.6577L1.34297 11.8327L6.0013 7.17435L10.6596 11.8327L11.8346 10.6577L7.1763 5.99935L11.8346 1.34102Z",
            fill: "#B9B9B9"
        })
    });
}


/***/ }),

/***/ 72084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ TickFill; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);



function TickFill(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || 29.25,
        height: props.height || 29.25,
        viewBox: "0 0 29.25 29.25"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M14.625 0A14.625 14.625 0 1029.25 14.625 14.623 14.623 0 0014.625 0zm7.488 10.582l-9.4 9.443h-.008a1.27 1.27 0 01-.816.387 1.231 1.231 0 01-.823-.4l-3.941-3.939a.28.28 0 010-.4l1.256-1.248a.272.272 0 01.394 0l3.122 3.122 8.578-8.641a.278.278 0 01.2-.084.255.255 0 01.2.084l1.23 1.273a.277.277 0 01.008.403z",
            fill: props.color || "#000000"
        })
    }));
}


/***/ }),

/***/ 106541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ColorVariant_ColorVariant; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(414924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(999534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(721023);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(690948);
;// CONCATENATED MODULE: ./src/assets/svgExports/ColorCircle.js

var WHITE_COLORS = [
    "white",
    "#fff",
    "#ffffff"
];
function ColorCircle(param) {
    var color = param.color, _borderColor = param.borderColor, borderColor = _borderColor === void 0 ? "#fff" : _borderColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "36",
        height: "36",
        viewBox: "0 0 36 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.75",
                y: "0.75",
                width: "34.5",
                height: "34.5",
                rx: "17.25",
                stroke: borderColor,
                "stroke-width": "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "4",
                y: "4",
                width: "28",
                height: "28",
                rx: "14",
                fill: color,
                stroke: WHITE_COLORS.includes(color === null || color === void 0 ? void 0 : color.toLowerCase()) ? "#e2e2e2" : "#fff"
            })
        ]
    });
}
function DisabledColorCircle(param) {
    var color = param.color, _borderColor = param.borderColor, borderColor = _borderColor === void 0 ? "#fff" : _borderColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "36",
        height: "36",
        viewBox: "0 0 36 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.75",
                y: "0.75",
                width: "34.5",
                height: "34.5",
                rx: "17.25",
                stroke: borderColor,
                "stroke-width": "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                "clip-path": "url(#clip0_138_1543)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "4",
                        y: "4",
                        width: "28",
                        height: "28",
                        rx: "14",
                        fill: color,
                        "fill-opacity": "0.15"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "4.5",
                        y: "4.5",
                        width: "27",
                        height: "27",
                        rx: "13.5",
                        stroke: "black",
                        "stroke-opacity": "0.1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                        x1: "8.3625",
                        y1: "8.65563",
                        x2: "27.3625",
                        y2: "28.6556",
                        stroke: "#BDBDBD"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_138_1543",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "28",
                        height: "28",
                        fill: "white",
                        transform: "translate(4 4)"
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/assets/svgExports/ColorEllipse.js

function ColorEllipse(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "7.99957",
                cy: "7.99957",
                r: "6.22222",
                fill: (props === null || props === void 0 ? void 0 : props.color) ? props === null || props === void 0 ? void 0 : props.color : "#FFFFFF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "8",
                cy: "8",
                r: "7.5",
                stroke: (props === null || props === void 0 ? void 0 : props.isFirst) ? (props === null || props === void 0 ? void 0 : props.color) === "#FFFFFF" ? "#000000" : props === null || props === void 0 ? void 0 : props.color : "#FFFFFF"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/assets/svgExports/ColoredSquare.js

function ColoredSquare(param) {
    var color = param.color, borderColor = param.borderColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "36",
        height: "36",
        viewBox: "0 0 36 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.5 0.5H35.5V35.5H0.5V0.5Z",
                stroke: borderColor || "#fff"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "4",
                y: "4",
                width: "28",
                height: "28",
                fill: color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "3.5",
                y: "3.5",
                width: "29",
                height: "29",
                stroke: "black",
                "stroke-opacity": "0.1"
            })
        ]
    });
}
function DisabledSquare(param) {
    var color = param.color, _borderColor = param.borderColor, borderColor = _borderColor === void 0 ? "#fff" : _borderColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "36",
        height: "36",
        viewBox: "0 0 36 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.75",
                y: "0.75",
                width: "34.5",
                height: "34.5",
                stroke: borderColor,
                "stroke-width": "1.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                "clip-path": "url(#clip0_138_1456)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "4",
                        y: "4",
                        width: "28",
                        height: "28",
                        fill: color,
                        "fill-opacity": "0.15"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "4.5",
                        y: "4.5",
                        width: "27",
                        height: "27",
                        stroke: "black",
                        "stroke-opacity": "0.1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                        x1: "2.35355",
                        y1: "2.64645",
                        x2: "32.3536",
                        y2: "32.6465",
                        stroke: "#BDBDBD"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_138_1456",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "28",
                        height: "28",
                        fill: "white",
                        transform: "translate(4 4)"
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
;// CONCATENATED MODULE: ./src/components/ColorVariant/ColorVariant.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 12px;\n  margin-top: 8px;\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 9px;\n  margin-top: 8px;\n  cursor: pointer;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 4px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var ColoredRectangleElementContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ColoredRectangleElementContainer",
    componentId: "sc-9f0f1e13-0"
})(_templateObject());
var ColoredCircleElementContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ColoredCircleElementContainer",
    componentId: "sc-9f0f1e13-1"
})(_templateObject1());
var ColoredEllipseElementContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ColoredEllipseElementContainer",
    componentId: "sc-9f0f1e13-2"
})(_templateObject2());

;// CONCATENATED MODULE: ./src/components/ColorVariant/ColorVariant.js












var BlackTooltip = (0,styled/* default */.ZP)(function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(Tooltip/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        classes: {
            popper: className
        }
    }));
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {}, (0,_define_property/* default */.Z)(_obj, "& .MuiTooltip-tooltip", {
        backgroundColor: "#000",
        color: "#fff",
        fontSize: 12,
        padding: "6px 8px",
        fontFamily: "montserrat",
        fontWeight: 500
    }), (0,_define_property/* default */.Z)(_obj, "& .MuiTooltip-arrow", {
        color: "#000"
    }), _obj;
});
/**
 * This Component is UI for showing products Color of Variant option throughout code base
 * @param {*} props
 * @return {JSX.Element} Button UI component
 */ function ColorVariant(props) {
    var renderColoredRectancle = /** renders Colored Squares  */ function renderColoredRectancle() {
        var ref, ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ColoredRectangleElementContainer, {
            onClick: function() {
                handleVariantBtnClick(rowIndex, variantName, isVisible);
            },
            onMouseEnter: function() {
                return setIsHovered(true);
            },
            onMouseLeave: function() {
                return setIsHovered(false);
            },
            children: !isAvailable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DisabledSquare, {
                color: color,
                borderColor: isSelected ? "#999999" : "#fff"
            }) : isSelected ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ColoredSquare, {
                color: color,
                borderColor: props === null || props === void 0 ? void 0 : props.themeColor
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ColoredSquare, {
                color: color,
                borderColor: isHovered ? props === null || props === void 0 ? void 0 : (ref = props.storeTheme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color : null
            })
        });
    };
    var renderColoredEllipse = /** returns a colored ellipses */ function renderColoredEllipse() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ColoredEllipseElementContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorEllipse, {
                isFirst: isFirst ? isFirst : false,
                color: color
            })
        });
    };
    var renderColoredCircle = function renderColoredCircle() {
        var ref, ref1, ref2, ref3;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ColoredCircleElementContainer, {
            onClick: function() {
                handleVariantBtnClick(rowIndex, variantName, isVisible);
            },
            onMouseEnter: function() {
                return setIsHovered(true);
            },
            onMouseLeave: function() {
                return setIsHovered(false);
            },
            children: !isAvailable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DisabledColorCircle, {
                color: color,
                borderColor: isSelected ? "#999999" : "#fff"
            }) : isSelected ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorCircle, {
                color: color,
                borderColor: props === null || props === void 0 ? void 0 : (ref = props.storeTheme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorCircle, {
                color: color,
                borderColor: isHovered ? props === null || props === void 0 ? void 0 : (ref2 = props.storeTheme) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.colors) === null || ref3 === void 0 ? void 0 : ref3.primary_color : null
            })
        });
    };
    var renderPdpColorVariant = function renderPdpColorVariant() {
        var ref;
        if (!isVisible) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlackTooltip, {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "tw-text-[12px] tw-font-light",
                children: variantName
            }),
            placement: "top",
            arrow: true,
            children: (props === null || props === void 0 ? void 0 : (ref = props.storeTheme) === null || ref === void 0 ? void 0 : ref.roundness) ? renderColoredCircle() : renderColoredRectancle()
        });
    };
    var color = props.color, variantName = props.variantName, activeVariantOption = props.activeVariantOption, isSelectedOption = props.isSelectedOption, rowIndex = props.rowIndex, returnIsVariantVisible = props.returnIsVariantVisible, returnIsVariantAvailable = props.returnIsVariantAvailable, outOfVisbleInfo = props.outOfVisbleInfo, outOfStockInfo = props.outOfStockInfo, toggleClick = props.toggleClick, handleVariantBtnClick = props.handleVariantBtnClick, isFirst = props.isFirst, _isPdp = props.isPdp, isPdp = _isPdp === void 0 ? false : _isPdp;
    /** checks if the UI Button is in Selected state */ var ref = (0,react.useState)(false), isSelected = ref[0], setIsSelected = ref[1];
    /** Checks if a Color is hidden or not in current variant configuration*/ var ref1 = (0,react.useState)(false), isVisible = ref1[0], setIsVisible = ref1[1];
    var ref2 = (0,react.useState)(true), isAvailable = ref2[0], setIsAvailable = ref2[1];
    var ref3 = (0,react.useState)(false), isHovered = ref3[0], setIsHovered = ref3[1];
    (0,react.useEffect)(function() {
        if (isPdp) {
            if (variantName === activeVariantOption) {
                setIsSelected(true);
            } else setIsSelected(false);
        }
    }, [
        isSelectedOption,
        activeVariantOption,
        toggleClick
    ]);
    (0,react.useEffect)(function() {
        if (isPdp) {
            setIsVisible(returnIsVariantVisible(variantName, rowIndex));
            setIsAvailable(returnIsVariantAvailable(variantName, rowIndex));
        }
    }, [
        variantName,
        rowIndex,
        outOfVisbleInfo,
        toggleClick,
        outOfStockInfo
    ]);
    return isPdp ? renderPdpColorVariant() : renderColoredEllipse();
}
/* harmony default export */ var ColorVariant_ColorVariant = (ColorVariant);


/***/ }),

/***/ 379062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(307297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(667294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(150066);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(100%);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  overflow: hidden;\n  background: #eee;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(\n      90deg,\n      transparent,\n      rgba(255, 255, 255, 0.6),\n      transparent\n    );\n    animation: ",
        " 1.5s infinite;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  aspect-ratio: 1 / 1;\n  border-radius: 10px;\n  margin-bottom: 25px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  border-radius: 6px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  gap: 10px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var CardSkeleton = function(param) {
    var _type = param.type, type = _type === void 0 ? "product" : _type, customStyles = param.customStyles;
    if (type === "product") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SkeletonContainer, {
            customStyles: customStyles,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImagePlaceholder, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(RowGroup, {
                    className: "tw-mb-8",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Row, {
                            width: "60px",
                            height: "27px"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Row, {
                            width: "40px",
                            height: "27px"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(RowGroup, {
                    className: "tw-flex-col tw-gap-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Row, {
                            width: "100%",
                            height: "14px"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Row, {
                            width: "50%",
                            height: "14px"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Row, {
                            width: "60%",
                            height: "14px"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Row, {
                            width: "90%",
                            height: "14px"
                        })
                    ]
                })
            ]
        });
    }
    return null;
};
/* harmony default export */ __webpack_exports__["Z"] = (CardSkeleton);
var shimmer = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .keyframes */ .F4)(_templateObject());
var ShimmerWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ShimmerWrapper",
    componentId: "sc-95c11a38-0"
})(_templateObject1(), shimmer);
var SkeletonContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "SkeletonContainer",
    componentId: "sc-95c11a38-1"
})(_templateObject2(), function(props) {
    var ref;
    return ((ref = props.customStyles) === null || ref === void 0 ? void 0 : ref.width) || "100%";
});
var ImagePlaceholder = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(ShimmerWrapper).withConfig({
    displayName: "ImagePlaceholder",
    componentId: "sc-95c11a38-2"
})(_templateObject3());
var Row = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(ShimmerWrapper).withConfig({
    displayName: "Row",
    componentId: "sc-95c11a38-3"
})(_templateObject4(), function(props) {
    return props.width;
}, function(props) {
    return props.height || "20px";
});
var RowGroup = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "RowGroup",
    componentId: "sc-95c11a38-4"
})(_templateObject5());


/***/ }),

/***/ 950258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Card": function() { return /* binding */ Card; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/redux/actions/logs.js
var logs = __webpack_require__(467936);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var common = __webpack_require__(731024);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/redux/actions/cart.js
var cart = __webpack_require__(666162);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/index.js + 2 modules
var AtomicComponents = __webpack_require__(438855);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Card/Card.styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  position: relative;\n  box-sizing: border-box;\n  border: ",
        ";\n  padding: ",
        ";\n  border-radius: ",
        ";\n  cursor: pointer;\n  ",
        ";\n\n  @media screen and (min-width: 767px) {\n    max-width: ",
        ";\n  }\n\n  @media screen and (max-width: 766px) {\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  flex: 1;\n  /* height: 100%; */\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  position: relative;\n  object-fit: cover;\n  display: flex;\n  aspect-ratio: 1;\n\n  @media screen and (min-width: 767px) {\n    ",
        "; //As max-width of the box is set to 200px\n  }\n\n  @media screen and (max-width: 766px) {\n    ",
        ";\n  }\n\n  & > img {\n    width: 100%;\n    object-fit: cover;\n    object-position: center center;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  box-sizing: border-box;\n  padding: ",
        ";\n  position: relative;\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  flex-shrink: 1;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n  font-size: 12px;\n  margin: 0 0 12px 0;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-flow: row wrap;\n  padding: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 0 0 auto;\n  align-items: center;\n  padding: 2px 4px;\n  margin-bottom: 4px;\n  border-radius: 4px;\n  color: #ffffff;\n  font-size: 11px;\n  background-color: ",
        ";\n  white-space: nowrap;\n  margin-right: 10px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 500;\n  margin: 0.5rem 0;\n  display: -webkit-box;\n  -webkit-line-clamp:",
        ";\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 5px;\n  line-height: 1.5;\n  ",
        "\n  font-size: 12px;\n  word-break: break-word;\n  color: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  color: ",
        ";\n  letter-spacing: 1.5px;\n  font-size: 16px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  text-decoration: line-through;\n  color: ",
        ";\n  letter-spacing: 1.3px;\n  margin-left: 10px;\n  font-size: 13px;\n  word-break: break-all;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  position: absolute;\n  background-color: #3ea200;\n  color: #ffffff;\n  font-size: 11px;\n  text-transform: uppercase;\n  z-index: 2;\n  padding: 2px 3px;\n  left: 0px;\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 0;\n  flex-direction: column;\n\n  @media screen and (min-width: 401px) {\n    margin-left: ",
        ";\n    margin-top: 0.5rem;\n  }\n\n  @media screen and (max-width: 400px) {\n    margin-top: 10px;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (min-width: 767px) {\n    width: 100%;\n    font-size: 22px;\n  }\n\n  @media screen and (max-width: 766px) {\n    width: 100%;\n    font-size: 18px;\n    ",
        "\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  font-weight: 400;\n  letter-spacing: 0.26px;\n  margin-top: 20px;\n  color: ",
        ";\n\n  ",
        ";\n\n  @media screen and (min-width: 767px) {\n    font-size: 14px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 11px;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 2px;\n  display: inline-block;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}


var CardContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CardContainer",
    componentId: "sc-b135d119-0"
})(_templateObject(), function(props) {
    return !props.cardWidth ? "100%" : "".concat(props.cardWidth, "px");
}, function(props) {
    return !props.imageUrl && "0.4px solid #C7C7C7;";
}, function(props) {
    return !props.imageUrl && "20px;";
}, function(props) {
    return !props.imageUrl && "4px;";
}, function(props) {
    return !!props.isAvailable || props.isB2bStore ? null : "filter: grayscale(1);";
}, function(props) {
    return !props.cardWidth ? "200px" : "".concat(props.cardWidth, "px");
}, function(props) {
    return !props.imageUrl ? "grid-column: 1 / -1;" : "max-width: 200px;\n           width: ".concat(function(props) {
        return !props.cardWidth ? "calc((100vw - 60px) / 2)" : "".concat(props.cardWidth, "px");
    }, ";");
});
var CardBody = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "CardBody",
    componentId: "sc-b135d119-1"
})(_templateObject1());
var CardImage = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "CardImage",
    componentId: "sc-b135d119-2"
})(_templateObject2(), function(props) {
    return props.imageWidth || "100%";
}, function(props) {
    return props.imageHeight || "100%";
}, function(props) {
    return props.imageUrl ? "height: calc(200px/".concat(props.product_aspect_ratio !== 0 ? props.product_aspect_ratio : 1, ");") : "height: 180px;";
}, function(props) {
    return props.imageUrl ? "height: calc(((100vw - 60px) / 2)/".concat(props.product_aspect_ratio !== 0 ? props.product_aspect_ratio : 1, ");") : "height: auto";
});
var CardMain = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "CardMain",
    componentId: "sc-b135d119-3"
})(_templateObject3(), function(param) {
    var padding = param.padding;
    return padding;
}, function(props) {
    return props.imageUrl && "\n    @media screen and (max-width: 400px) {\n      flex-direction: column;\n    }\n  ";
});
var CardData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CardData",
    componentId: "sc-b135d119-4"
})(_templateObject4());
var CardInventory = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "CardInventory",
    componentId: "sc-b135d119-5"
})(_templateObject5());
var CardTags = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CardTags",
    componentId: "sc-b135d119-6"
})(_templateObject6(), function(param) {
    var padding = param.padding;
    return padding;
});
var CardTag = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "CardTag",
    componentId: "sc-b135d119-7"
})(_templateObject7(), function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor;
});
var CardTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    displayName: "CardTitle",
    componentId: "sc-b135d119-8"
})(_templateObject8(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.isWishlistCard) ? 2 : 3;
}, function(props) {
    return props.categoryCard && "text-align: center;";
}, function(props) {
    return props.fontColor;
});
var CardPrice = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CardPrice",
    componentId: "sc-b135d119-9"
})(_templateObject9());
var AmountDiscounted = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "AmountDiscounted",
    componentId: "sc-b135d119-10"
})(_templateObject10(), function(props) {
    return props.fontColor;
});
var AmountActual = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "AmountActual",
    componentId: "sc-b135d119-11"
})(_templateObject11(), function(props) {
    return props.fontColor;
});
var CardDiscount = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "CardDiscount",
    componentId: "sc-b135d119-12"
})(_templateObject12(), function(props) {
    return props.imageUrl ? "bottom: 0px;" : "top: -25px;";
});
var ButtonContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "ButtonContainer",
    componentId: "sc-b135d119-13"
})(_templateObject13(), function(props) {
    return props.isWishlistCard ? "0" : "10px";
});
var Button = (0,styled_components_browser_esm/* default */.ZP)(AtomicComponents/* CartButton */.WE).withConfig({
    displayName: "Button",
    componentId: "sc-b135d119-14"
})(_templateObject14(), function(props) {
    return !props.hasVariant && "margin-bottom: 22px;";
});
var CardDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "CardDescription",
    componentId: "sc-b135d119-15"
})(_templateObject15(), function(props) {
    return props.fontColor;
}, function(props) {
    return props.isAvailable && "\n      display: -webkit-box;\n      -webkit-line-clamp: 3;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n      text-overflow: ellipsis;    \n    ";
});
var CardDescriptionMock = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "CardDescriptionMock",
    componentId: "sc-b135d119-16"
})(_templateObject16());

// EXTERNAL MODULE: ./src/utils/checkForLimitedQuantity.js
var checkForLimitedQuantity = __webpack_require__(427994);
// EXTERNAL MODULE: ./src/utils/itemQuantityValueComparison.js
var itemQuantityValueComparison = __webpack_require__(973175);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(186812);
// EXTERNAL MODULE: ./src/utils/scrollItemAndRemoveDetails.js
var scrollItemAndRemoveDetails = __webpack_require__(104286);
// EXTERNAL MODULE: ./src/utils/getStoreType.js
var getStoreType = __webpack_require__(66871);
// EXTERNAL MODULE: ./src/utils/getDiscountPercentage.js
var getDiscountPercentage = __webpack_require__(153716);
// EXTERNAL MODULE: ./src/components/Common/Toast/index.jsx
var Toast = __webpack_require__(40804);
// EXTERNAL MODULE: ./src/components/RatingBox/index.js
var RatingBox = __webpack_require__(18468);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.ts
var useFeatureLocks = __webpack_require__(482516);
// EXTERNAL MODULE: ./src/hooks/useSetWishlistState.tsx
var useSetWishlistState = __webpack_require__(106531);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
// EXTERNAL MODULE: ./src/utils/compressedImagesHelpers.ts
var compressedImagesHelpers = __webpack_require__(940619);
// EXTERNAL MODULE: ./src/utils/mutateItemObjectWithCartData.js
var mutateItemObjectWithCartData = __webpack_require__(822787);
// EXTERNAL MODULE: ./src/components/Link/index.tsx + 1 modules
var Link = __webpack_require__(573409);
// EXTERNAL MODULE: ./src/hooks/useItemClick.js + 1 modules
var useItemClick = __webpack_require__(780058);
// EXTERNAL MODULE: ./src/utils/canShowPDPSystem.js
var canShowPDPSystem = __webpack_require__(813051);
// EXTERNAL MODULE: ./src/hooks/useCartHandler.js
var useCartHandler = __webpack_require__(491240);
// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/OfferAvailableTag/index.tsx
var OfferAvailableTag = __webpack_require__(933761);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/common.js + 9 modules
var utils_common = __webpack_require__(720901);
// EXTERNAL MODULE: ./src/utils/checkRenderEnv.js
var checkRenderEnv = __webpack_require__(506337);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
// EXTERNAL MODULE: ./src/components/ProductMediaRenderer/MediaContainer.tsx
var MediaContainer = __webpack_require__(748577);
// EXTERNAL MODULE: ./src/hooks/useGetDeviceType.tsx
var useGetDeviceType = __webpack_require__(662946);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts
var WidgetDndContext = __webpack_require__(474151);
// EXTERNAL MODULE: ./src/components/DesignSystem/NextImage/index.ts + 1 modules
var NextImage = __webpack_require__(527941);
;// CONCATENATED MODULE: ./src/assets/svgExports/CloseIconWhiteBackground.js

var CloseIconWhiteBackground = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "23",
        height: "23",
        viewBox: "0 0 23 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "11.4706",
                cy: "11.4704",
                r: "8.5646",
                fill: "white",
                stroke: "#E0E0E0",
                "stroke-width": "0.444444"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "mask0_279_3763",
                "mask-type": "alpha",
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "23",
                height: "23",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: "11.4706",
                    width: "16.2218",
                    height: "16.2218",
                    transform: "rotate(45 11.4706 0)",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                mask: "url(#mask0_279_3763)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M11.5 12.5519L9.28142 14.7705C9.14117 14.9107 8.96266 14.9809 8.7459 14.9809C8.52914 14.9809 8.35064 14.9107 8.21038 14.7705C8.07013 14.6302 8 14.4517 8 14.235C8 14.0182 8.07013 13.8397 8.21038 13.6995L10.429 11.4809L8.21038 9.28142C8.07013 9.14117 8 8.96266 8 8.7459C8 8.52914 8.07013 8.35064 8.21038 8.21038C8.35064 8.07013 8.52914 8 8.7459 8C8.96266 8 9.14117 8.07013 9.28142 8.21038L11.5 10.429L13.6995 8.21038C13.8397 8.07013 14.0182 8 14.235 8C14.4517 8 14.6302 8.07013 14.7705 8.21038C14.9235 8.36339 15 8.54508 15 8.75546C15 8.96585 14.9235 9.14117 14.7705 9.28142L12.5519 11.4809L14.7705 13.6995C14.9107 13.8397 14.9809 14.0182 14.9809 14.235C14.9809 14.4517 14.9107 14.6302 14.7705 14.7705C14.6175 14.9235 14.4358 15 14.2254 15C14.015 15 13.8397 14.9235 13.6995 14.7705L11.5 12.5519Z",
                    fill: "#1C1B1F"
                })
            })
        ]
    });
};
/* harmony default export */ var svgExports_CloseIconWhiteBackground = (CloseIconWhiteBackground);

// EXTERNAL MODULE: ./src/components/Wishlist/WishlistHeartButton.tsx + 2 modules
var WishlistHeartButton = __webpack_require__(406632);
// EXTERNAL MODULE: ./src/constants/wishlist.js
var wishlist = __webpack_require__(298627);
// EXTERNAL MODULE: ./src/utils/isNotifyProductEnabled.js
var isNotifyProductEnabled = __webpack_require__(532953);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Card/index.tsx





































var Card = function(props) {
    var removeTagsAndReturn = // function to remove all anchor tags from string
    function removeTagsAndReturn(str) {
        if (checkRenderEnv/* IS_SERVER */.W6) return str;
        var tmp = document.createElement("div");
        // add string to created div as html
        tmp.innerHTML = str;
        // get all anchor tags added to created element
        var anchor_tag_collection = tmp.getElementsByTagName("a");
        // iterate over all the tags and remove them from the HTML collection
        if (anchor_tag_collection.length) {
            // convert HTML collection to array
            Array.from(anchor_tag_collection).forEach(function(tag) {
                // remove the tags
                if (tag) {
                    tag.parentNode.removeChild(tag);
                }
            });
        }
        return tmp.textContent || tmp.innerText || "";
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29;
    var _data = props.data, data = _data === void 0 ? {} : _data, _showCategoryCard = props.// productCard = false,
    showCategoryCard, showCategoryCard = _showCategoryCard === void 0 ? false : _showCategoryCard, _imageUrl = props.imageUrl, imageUrl = _imageUrl === void 0 ? "https://picsum.photos/300/300" : _imageUrl, tmp = props.noTags, noTagsFromProps = tmp === void 0 ? true : tmp, _noTagsReadState = props.noTagsReadState, noTagsReadState = _noTagsReadState === void 0 ? "fromProp" : _noTagsReadState, skeleton = props.skeleton, skeletonImage = props.skeletonImage, _cardWidth = props.cardWidth, cardWidth = _cardWidth === void 0 ? undefined : _cardWidth, _isWishlistCard = props.isWishlistCard, isWishlistCard = _isWishlistCard === void 0 ? false : _isWishlistCard, _onWishlistDeleteClick = props.onWishlistDeleteClick, onWishlistDeleteClick = _onWishlistDeleteClick === void 0 ? undefined : _onWishlistDeleteClick;
    var ref30 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), _widgetContextState = ref30.widgetContextState, previewDevice = _widgetContextState.previewDevice, isBuilder = _widgetContextState.isBuilder;
    var deviceType = (0,useGetDeviceType/* useGetDeviceType */.n)().deviceType;
    var isMobile = isBuilder ? previewDevice === "mobile" : deviceType === "mobile";
    var ref31 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer.store;
    }), theme = ref31.theme, store_id = ref31.store_id, services = ref31.services, premium = ref31.premium;
    var ref32 = (0,_sliced_to_array/* default */.Z)((0,useItemClick/* useItemClick */.M)(), 2), onItemClick = ref32[0], getLink = ref32[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var cartData = (0,es/* useSelector */.v9)(function(state) {
        return state.cartReducer;
    });
    var ref33 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        var ref;
        var storeData = state.storeReducer.store;
        return {
            storeInfo: storeData,
            storeData: storeData,
            oosStatus: (ref = storeData === null || storeData === void 0 ? void 0 : storeData.services) === null || ref === void 0 ? void 0 : ref.hide_out_of_stock
        };
    }), storeInfo = ref33.storeInfo, oosStatus = ref33.oosStatus, storeData = ref33.storeData;
    var ref34 = (0,es/* useSelector */.v9)(function(state) {
        return {
            userData: state.userReducer,
            reviewSettings: state.catalogReducer.reviewSettings
        };
    }), userData = ref34.userData, reviewSettings = ref34.reviewSettings;
    var ref35 = (0,react.useState)(0), discountPercent = ref35[0], setDiscountPercent = ref35[1];
    var ref36 = (0,react.useState)(data === null || data === void 0 ? void 0 : data.item_whislisted), isItemWishlisted = ref36[0], setIsItemWishlisted = ref36[1];
    var crrFeatureStatus = (0,useFeatureLocks/* useFeatureLocks */.r)().crrFeatureStatus;
    var setWishlistState = (0,useSetWishlistState/* useSetWishlistState */.X)().setWishlistState;
    var isB2bStore = (0,getStoreType/* getStoreType */.K)(storeData) === constants/* STORE_CUSTOMIZATION.B2B */.DO.B2B;
    var ref37 = (0,useCartHandler/* useCartHandlers */.u)(), handleSetProductCustomizationCount = ref37.handleSetProductCustomizationCount, handleSetProductData = ref37.handleSetProductData, handleIncreamentClick = ref37.handleIncreamentClick, handleDecreamentClick = ref37.handleDecreamentClick;
    var hasVariant = ((ref = props.data) === null || ref === void 0 ? void 0 : ref.variants_count) > 0;
    var itemIndexInCart = cartData === null || cartData === void 0 ? void 0 : (ref1 = cartData.items) === null || ref1 === void 0 ? void 0 : ref1.findIndex(function(el) {
        return (el.id || el.item_id) === (data === null || data === void 0 ? void 0 : data.id);
    });
    var hasScheduler = !!((ref2 = props.data) === null || ref2 === void 0 ? void 0 : ref2.item_schedule);
    (0,react.useEffect)(function() {
        if (data && (data === null || data === void 0 ? void 0 : data.is_active) !== constants/* ITEM_ACTIVE_STATUS.HIDDEN */.p4.HIDDEN) {
            var percent = (0,getDiscountPercentage/* getDiscountPercentage */.$)(data === null || data === void 0 ? void 0 : data.price, data === null || data === void 0 ? void 0 : data.discounted_price);
            setDiscountPercent(percent ? percent : 0);
            (0,scrollItemAndRemoveDetails/* scrollItemAndRemoveDetails */.f)(data, cardRef);
            setIsItemWishlisted(data === null || data === void 0 ? void 0 : data.item_whislisted);
        }
    }, [
        data
    ]);
    var noTags = function() {
        switch(noTagsReadState){
            case "fromProp":
                return noTagsFromProps;
            case "fromLength":
                var ref;
                return !(data === null || data === void 0 ? void 0 : (ref = data.tags) === null || ref === void 0 ? void 0 : ref.length);
            default:
                return noTagsFromProps;
        }
    }();
    var cardRef = (0,react.useRef)(null);
    var product_aspect_ratio = theme && theme.product_aspect_ratio !== 0 ? parseFloat((theme === null || theme === void 0 ? void 0 : theme.product_aspect_ratio) / 100 || 0).toFixed(3) : 1;
    if (skeleton) {
        var ref38, ref39;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContainer, {
            imageUrl: "skeleton",
            children: [
                skeletonImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* NextImage */.o, {
                    src: skeletonImage,
                    height: isMobile ? (data === null || data === void 0 ? void 0 : data.thumbnail_url) ? "calc(((100vw - 60px) / 2)/".concat(props.product_aspect_ratio !== 0 ? props.product_aspect_ratio : 1, ");") : "auto" : (data === null || data === void 0 ? void 0 : data.thumbnail_url) ? "calc(200px/".concat(product_aspect_ratio !== "0" || product_aspect_ratio == 0 ? product_aspect_ratio : 1, ")") : "180px",
                    width: cardWidth,
                    layout: "fill",
                    quality: isMobile ? 40 : 100,
                    loading: "lazy",
                    decoding: "async"
                }),
                !skeletonImage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardBody, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardImage, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    width: "100%",
                                    height: "100%"
                                },
                                className: "skeleton br3"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMain, {
                            imageUrl: "skeleton",
                            padding: "4px 0 0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardData, {
                                children: [
                                    !noTags && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardTags, {
                                        padding: "8px 0 0px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTag, {
                                                className: "skeleton",
                                                children: "Tag Name"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTag, {
                                                className: "skeleton",
                                                children: "Tag"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardTitle, {
                                        categoryCard: showCategoryCard,
                                        isWishlistCard: isWishlistCard,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardDescriptionMock, {
                                                className: "skeleton br3",
                                                children: "Loading Product Name Mock"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardDescriptionMock, {
                                                className: "skeleton br3",
                                                children: "Product Name"
                                            })
                                        ]
                                    }),
                                    !showCategoryCard && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardPrice, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AmountDiscounted, {
                                            fontColor: ((ref38 = props.builderOverrideStyles) === null || ref38 === void 0 ? void 0 : ref38.textColor) || (theme === null || theme === void 0 ? void 0 : (ref39 = theme.colors) === null || ref39 === void 0 ? void 0 : ref39.primary_color),
                                            className: "skeleton br3",
                                            children: "₹ 0"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: premium === 0 && "ph2 pb2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardDescription, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardDescriptionMock, {
                                        className: "skeleton br3",
                                        children: "Description Demo"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardDescriptionMock, {
                                        className: "skeleton br3",
                                        children: "Description Demo Content"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardDescriptionMock, {
                                        className: "skeleton br3",
                                        children: "Description"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    }
    if ((data === null || data === void 0 ? void 0 : data.is_active) === constants/* ITEM_ACTIVE_STATUS.HIDDEN */.p4.HIDDEN) return null;
    var handleAddRemoveItem = function(type) {
        var ref, ref1;
        if ((type === "OOS" || hasScheduler) && isWishlistCard) {
            onItemClick(data);
            return;
        }
        dispatch((0,logs/* pushEventsLog */.U)({
            event_name: "Cx_ATC",
            data: {
                store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id,
                domain: storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.domain,
                page: window.location.href,
                device: deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf ? "Mobile" : "Desktop",
                cx_number: userData === null || userData === void 0 ? void 0 : (ref1 = userData.data) === null || ref1 === void 0 ? void 0 : ref1.phone
            }
        }));
        var productItem = cartData.items[itemIndexInCart];
        // managed_inventory !== 0. available_quantity !== 0.
        // don't proceed to control flow if available_quantity is 0
        if (type === "inc" && (0,itemQuantityValueComparison/* itemQuantityValueComparison */.i)(productItem)) {
            (0,Toast/* toastNotifyInfo */.lU)("No more units available for purchase");
            return;
        }
        /** Check if variant present in this item */ if (hasVariant) {
            var ref2;
            dispatch((0,common/* saveProductLoaderId */.XG)((ref2 = props.data) === null || ref2 === void 0 ? void 0 : ref2.id));
            dispatch((0,catalog/* savePDPData */.zP)(props === null || props === void 0 ? void 0 : props.data));
            /** check if item exist in cart */ if (itemIndexInCart !== -1) {
                switch(type){
                    case "inc":
                        dispatch((0,common/* setVariantModalVisibility */.VZ)(true));
                        break;
                    case "dec":
                        dispatch((0,common/* setSelectedVariantModalVisibility */.rV)(true));
                        break;
                }
            } else {
                var ref3;
                /** get the details item for this item id */ dispatch((0,catalog/* fetchCatalogItemById */.eP)({
                    store_id: store_id,
                    item_id: (ref3 = props.data) === null || ref3 === void 0 ? void 0 : ref3.id,
                    src: "design_system_card"
                }, true, function(data) {
                    handleSetProductData(data);
                }));
            }
        } else {
            if (data === null || data === void 0 ? void 0 : data.product_personalization) {
                handleSetProductCustomizationCount(data);
                dispatch((0,catalog/* savePDPData */.zP)(data));
                handleSetProductData(data);
                switch(type){
                    case "add":
                        dispatch((0,catalog/* openProductPersonalizationPopUp */.w4)());
                        break;
                    case "inc":
                        handleIncreamentClick(type, data);
                        break;
                    case "dec":
                        handleDecreamentClick(type, data);
                        break;
                    default:
                        break;
                }
            } else {
                var newState = (0,mutateItemObjectWithCartData/* mutateItemObjectWithCartData */.L)(type, data, cartData);
                dispatch((0,cart/* saveCart */.FP)(newState));
            }
        }
    };
    var handleToggleWishlistClick = function(id) {
        var payload = {
            item_id: id,
            status: isItemWishlisted ? wishlist/* ITEM_WISHLIST_STATE.REMOVE_FROM_WISHLIST */.U.REMOVE_FROM_WISHLIST : wishlist/* ITEM_WISHLIST_STATE.ITEM_WISHLISTED */.U.ITEM_WISHLISTED
        };
        setWishlistState(payload, function(status) {
            if (status) {
                setIsItemWishlisted(function(prev) {
                    return !prev;
                });
            }
        });
    };
    var hasRating = !(crrFeatureStatus === null || crrFeatureStatus === void 0 ? void 0 : crrFeatureStatus.isLocked) && (reviewSettings === null || reviewSettings === void 0 ? void 0 : reviewSettings.status) && (data === null || data === void 0 ? void 0 : (ref3 = data.store_item_review_rating) === null || ref3 === void 0 ? void 0 : ref3.review_rating) && ((ref5 = data === null || data === void 0 ? void 0 : (ref4 = data.store_item_review_rating) === null || ref4 === void 0 ? void 0 : ref4.review_rating[0]) === null || ref5 === void 0 ? void 0 : ref5.avg_rating);
    var cardImageUrl = (theme === null || theme === void 0 ? void 0 : theme.custom_theme_flag) ? data === null || data === void 0 ? void 0 : data.image_url : data === null || data === void 0 ? void 0 : data.thumbnail_url;
    var compressedImages = Array.isArray(data === null || data === void 0 ? void 0 : data.images) && (data === null || data === void 0 ? void 0 : data.images.length) > 0 && ((ref6 = data === null || data === void 0 ? void 0 : data.images[0]) === null || ref6 === void 0 ? void 0 : ref6.compressed_images);
    var renderCard = function() {
        var showDiscount = !showCategoryCard && discountPercent > 0 && !isB2bStore;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MediaContainer/* MediaContainer */.X, {
            width: "100%",
            children: [
                showDiscount && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardDiscount, {
                    imageUrl: data === null || data === void 0 ? void 0 : data.thumbnail_url,
                    children: "".concat(discountPercent, "% OFF")
                }),
                (data === null || data === void 0 ? void 0 : data.thumbnail_url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-relative tw-h-full tw-w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* NextImage */.o, {
                        className: "tw-h-full tw-w-full tw-object-contain",
                        property: "image",
                        loading: "lazy",
                        decoding: "async",
                        src: (0,compressedImagesHelpers/* getImageUrlFromCompressedImages */.vb)(compressedImages, cardImageUrl, {
                            maxImgSize: (0,compressedImagesHelpers/* getMaxImgSizeForComponent */.N7)(compressedImagesHelpers/* componentTypeEnums.CARD */.Xx.CARD)
                        }),
                        layout: "fill",
                        quality: isMobile ? 75 : 100,
                        alt: "Image ".concat((data === null || data === void 0 ? void 0 : data.name) || "available Items")
                    })
                })
            ]
        });
    };
    return oosStatus === 0 || (data === null || data === void 0 ? void 0 : data.available) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContainer, {
        cardWidth: cardWidth,
        isAvailable: data === null || data === void 0 ? void 0 : data.available,
        isB2bStore: isB2bStore,
        reactSlick: props.reactSlick,
        categoryCard: showCategoryCard,
        imageUrl: data === null || data === void 0 ? void 0 : data.thumbnail_url,
        // style={{
        //   boxShadow:
        //     premium === 0 && theme.is_demo === 0 ? '0 2px 6px #4a4a4a' : '',
        // }}
        onClick: function(e) {
            var func = (props === null || props === void 0 ? void 0 : props.onItemClick) || onItemClick;
            func(data);
        },
        ref: cardRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardBody, {
            children: [
                (0,canShowPDPSystem/* canShowPDPSystem */.R)(theme === null || theme === void 0 ? void 0 : theme.theme_class) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                    href: getLink(data, routes.getRoute),
                    children: renderCard()
                }) : renderCard(),
                !isWishlistCard && !noTags && (data === null || data === void 0 ? void 0 : (ref7 = data.tags) === null || ref7 === void 0 ? void 0 : ref7.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTags, {
                    padding: premium === 0 ? "4px 6px" : "8px 0 0px",
                    children: data === null || data === void 0 ? void 0 : (ref8 = data.tags) === null || ref8 === void 0 ? void 0 : ref8.map(function(tag) {
                        return tag.is_active !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTag, {
                            backgroundColor: tag.tag_color,
                            children: tag.name
                        }, tag.id);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-absolute tw-top-[7px] tw-right-[4px] tw-z-1 tw-rounded-[100%]",
                    onClick: function(e) {
                        e.stopPropagation();
                        if (onWishlistDeleteClick) onWishlistDeleteClick(data === null || data === void 0 ? void 0 : data.id);
                        else handleToggleWishlistClick(data === null || data === void 0 ? void 0 : data.id);
                    },
                    children: isWishlistCard ? /*#__PURE__*/ (0,jsx_runtime.jsx)(svgExports_CloseIconWhiteBackground, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(WishlistHeartButton/* default */.Z, {
                        isActive: isItemWishlisted
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardMain, {
                    imageUrl: data === null || data === void 0 ? void 0 : data.thumbnail_url,
                    padding: (theme === null || theme === void 0 ? void 0 : theme.custom_theme_flag) ? "12px 0 0" : premium === 0 ? "4px 6px" : "4px 0 0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardData, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTitle, {
                                    fontColor: ((ref9 = props.builderOverrideStyles) === null || ref9 === void 0 ? void 0 : ref9.textColor) || "#000",
                                    categoryCard: showCategoryCard,
                                    property: "name",
                                    isWishlistCard: isWishlistCard,
                                    children: (data === null || data === void 0 ? void 0 : data.name) || "Available Items"
                                }),
                                !!(data === null || data === void 0 ? void 0 : data.available) && (0,checkForLimitedQuantity/* checkForLimitedQuantity */.U)(data) && !isB2bStore && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardInventory, {
                                    className: "highlighter-red-color",
                                    children: "Limited Stock Left"
                                }),
                                !showCategoryCard && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardPrice, {
                                        children: isB2bStore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AmountDiscounted, {
                                            fontColor: ((ref10 = props.builderOverrideStyles) === null || ref10 === void 0 ? void 0 : ref10.textColor) || (theme === null || theme === void 0 ? void 0 : (ref11 = theme.colors) === null || ref11 === void 0 ? void 0 : ref11.primary_color),
                                            children: (data === null || data === void 0 ? void 0 : (ref12 = data.b2b_pricing_info) === null || ref12 === void 0 ? void 0 : ref12.price_range) || "Price on Request"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AmountDiscounted, {
                                                    fontColor: ((ref13 = props.builderOverrideStyles) === null || ref13 === void 0 ? void 0 : ref13.textColor) || (theme === null || theme === void 0 ? void 0 : (ref14 = theme.colors) === null || ref14 === void 0 ? void 0 : ref14.primary_color),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "₹"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: data === null || data === void 0 ? void 0 : data.discounted_price
                                                        })
                                                    ]
                                                }),
                                                (data === null || data === void 0 ? void 0 : data.discounted_price) !== (data === null || data === void 0 ? void 0 : data.price) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(AmountActual, {
                                                    fontColor: ((ref15 = props.builderOverrideStyles) === null || ref15 === void 0 ? void 0 : ref15.textColor) ? (0,utils_common/* hexToRgba */.a7)((ref16 = props.builderOverrideStyles) === null || ref16 === void 0 ? void 0 : ref16.textColor, 0.7) : "rgba(0, 0, 0, 0.3)",
                                                    children: [
                                                        "₹",
                                                        data === null || data === void 0 ? void 0 : data.price
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        !isWishlistCard && (services === null || services === void 0 ? void 0 : services.store_flag) !== 0 && !!(data === null || data === void 0 ? void 0 : data.available) && props.showButton && !isB2bStore && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                    disableAddition: (0,itemQuantityValueComparison/* itemQuantityValueComparison */.i)(cartData.items[itemIndexInCart]),
                                    hasVariant: hasVariant,
                                    fontSize: "14",
                                    onChange: handleAddRemoveItem,
                                    quantity: itemIndexInCart >= 0 ? cartData.items[itemIndexInCart].quantity : 0,
                                    hasScheduler: hasScheduler
                                }),
                                hasVariant && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "variant--count-icontext",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            loading: "lazy",
                                            src: "https://cdn.dotpe.in/longtail/themes/8073865/FcwGogkZ.webp"
                                        }),
                                        (ref17 = props.data) === null || ref17 === void 0 ? void 0 : ref17.variants_count,
                                        " options"
                                    ]
                                })
                            ]
                        }),
                        !showCategoryCard && !imageUrl && discountPercent > 0 && !isB2bStore && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardDiscount, {
                            children: "".concat(discountPercent, "% OFF")
                        })
                    ]
                }),
                !hasRating && !isWishlistCard && /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferAvailableTag/* default */.Z, {
                    productInfo: data,
                    customClasses: "tw-mt-[8px]"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: hasRating ? "pv8px" : "",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingBox/* default */.Z, {
                        isVisible: hasRating && !isWishlistCard,
                        rating: (data === null || data === void 0 ? void 0 : (ref18 = data.store_item_review_rating) === null || ref18 === void 0 ? void 0 : ref18.review_rating) && ((ref20 = data === null || data === void 0 ? void 0 : (ref19 = data.store_item_review_rating) === null || ref19 === void 0 ? void 0 : ref19.review_rating[0]) === null || ref20 === void 0 ? void 0 : ref20.avg_rating),
                        ratingsCount: (data === null || data === void 0 ? void 0 : (ref21 = data.store_item_review_rating) === null || ref21 === void 0 ? void 0 : ref21.review_rating) && ((ref23 = data === null || data === void 0 ? void 0 : (ref22 = data.store_item_review_rating) === null || ref22 === void 0 ? void 0 : ref22.review_rating[0]) === null || ref23 === void 0 ? void 0 : ref23.ratings_count) || (data === null || data === void 0 ? void 0 : (ref24 = data.store_item_review_rating) === null || ref24 === void 0 ? void 0 : ref24.ratings_count),
                        productInfo: data,
                        ratingCountColor: (ref25 = props.builderOverrideStyles) === null || ref25 === void 0 ? void 0 : ref25.textColor
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: premium === 0 && "ph2 pb2",
                    property: "description",
                    children: !(data === null || data === void 0 ? void 0 : data.available) && !isB2bStore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CardDescription, {
                        fontColor: ((ref26 = props.builderOverrideStyles) === null || ref26 === void 0 ? void 0 : ref26.textColor) ? (0,utils_common/* hexToRgba */.a7)((ref27 = props.builderOverrideStyles) === null || ref27 === void 0 ? void 0 : ref27.textColor, 0.6) : "#9c9c9c",
                        children: "Out of stock"
                    }) : !showCategoryCard && (data === null || data === void 0 ? void 0 : data.description) && !isWishlistCard && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardDescription, {
                        fontColor: ((ref28 = props.builderOverrideStyles) === null || ref28 === void 0 ? void 0 : ref28.textColor) ? (0,utils_common/* hexToRgba */.a7)((ref29 = props.builderOverrideStyles) === null || ref29 === void 0 ? void 0 : ref29.textColor, 0.6) : "#9c9c9c",
                        isAvailable: !!(data === null || data === void 0 ? void 0 : data.available),
                        children: removeTagsAndReturn(data === null || data === void 0 ? void 0 : data.description)
                    })
                }),
                isWishlistCard && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: (services === null || services === void 0 ? void 0 : services.store_flag) !== 0 && props.showButton && ((data === null || data === void 0 ? void 0 : data.available) || (0,isNotifyProductEnabled/* isNotifyProductEnabled */.Z)()) && !isB2bStore && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonContainer, {
                        isWishlistCard: isWishlistCard,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                            px: "20px",
                            py: "12px",
                            label: (data === null || data === void 0 ? void 0 : data.available) ? "Move to Cart" : "Notify Me",
                            roundness: 2,
                            isWishlistCard: isWishlistCard,
                            itemInventryStatus: data === null || data === void 0 ? void 0 : data.available,
                            disableAddition: (0,itemQuantityValueComparison/* itemQuantityValueComparison */.i)(cartData.items[itemIndexInCart]),
                            hasVariant: hasVariant,
                            fontSize: "14",
                            onChange: handleAddRemoveItem,
                            quantity: itemIndexInCart >= 0 ? cartData.items[itemIndexInCart].quantity : 0,
                            hasScheduler: hasScheduler
                        })
                    })
                })
            ]
        })
    }) : null;
};


/***/ }),

/***/ 708710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CT": function() { return /* binding */ DEFAULT_GET_ITEMS_API_PAGE_SIZE; },
/* harmony export */   "FM": function() { return /* binding */ MB7_SORT_FILTER_TEMP_STORAGE_KEY; },
/* harmony export */   "Tr": function() { return /* binding */ getStoredMB7SortAndFilterConfig; },
/* harmony export */   "Wu": function() { return /* binding */ scrollIfItemPreviouslyClicked; },
/* harmony export */   "lr": function() { return /* binding */ setMB7SortAndFilterConfig; },
/* harmony export */   "vU": function() { return /* binding */ getPaginatedItemsPerPage; },
/* harmony export */   "ve": function() { return /* binding */ isCustomTag; }
/* harmony export */ });
/* unused harmony export MB7_SORT_FILTER_STORAGE_KEY */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(626042);
/* harmony import */ var _utils_scrollOnPageLoad__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(287243);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(913886);
/* harmony import */ var _utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(644779);




var MB7_SORT_FILTER_STORAGE_KEY = "mb7SortAndFilterConfig";
var MB7_SORT_FILTER_TEMP_STORAGE_KEY = "mb7SortAndFilterConfigTemp";
var DEFAULT_GET_ITEMS_API_PAGE_SIZE = 20;
function scrollIfItemPreviouslyClicked() {
    var scrollConfig = (0,_utils_scrollOnPageLoad__WEBPACK_IMPORTED_MODULE_0__/* .scrollOnPageLoad */ .l)();
    if (scrollConfig.toScroll) {
        try {
            var y_scroll = scrollConfig.y_scroll;
            setTimeout(function() {
                sessionStorage.removeItem(_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .CLICKED_ITEM_OBJ */ .uI);
                window.scrollTo({
                    top: y_scroll
                });
            }, 300);
        } catch (err) {
            console.log("timeout time error:", err);
        }
    }
}
function getStoredMB7SortAndFilterConfig() {
    if (_utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get(MB7_SORT_FILTER_STORAGE_KEY)) {
        return _utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get(MB7_SORT_FILTER_STORAGE_KEY);
    }
    return {
        filterAppliedCounter: 0,
        sortType: 0,
        collectionId: null,
        cid: null,
        isNextPage: true,
        pageNo: 1,
        filteredItems: [],
        filteredOptions: [],
        allowReset: true,
        filterAppliedCounterChanged: false,
        sortTypeChanged: false
    };
}
function setMB7SortAndFilterConfig(data) {
    var temp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var currentStoredData = getStoredMB7SortAndFilterConfig();
    var newData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, currentStoredData, data);
    if (temp) {
        _utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_2__/* ["default"].add */ .Z.add(MB7_SORT_FILTER_TEMP_STORAGE_KEY, newData);
    } else {
        _utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_2__/* ["default"].add */ .Z.add(MB7_SORT_FILTER_STORAGE_KEY, newData);
    }
}
function getPaginatedItemsPerPage() {
    var gridAndPaginationConfig = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, isMobile = arguments.length > 1 ? arguments[1] : void 0;
    var tmp = gridAndPaginationConfig.num_products_desktop, numProductsDesktop = tmp === void 0 ? DEFAULT_GET_ITEMS_API_PAGE_SIZE : tmp, tmp1 = gridAndPaginationConfig.num_products_mobile, numProductsMobile = tmp1 === void 0 ? DEFAULT_GET_ITEMS_API_PAGE_SIZE : tmp1;
    var value = isMobile ? numProductsMobile : numProductsDesktop;
    return value && !isNaN(Number(value)) ? Number(value) : DEFAULT_GET_ITEMS_API_PAGE_SIZE;
}
function isCustomTag(categoryData) {
    return (categoryData === null || categoryData === void 0 ? void 0 : categoryData.hasOwnProperty("is_custom_tag")) ? 1 : 0;
}


/***/ }),

/***/ 707780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* reexport */ Card1; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/redux/actions/logs.js
var logs = __webpack_require__(467936);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var common = __webpack_require__(731024);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/redux/actions/cart.js
var cart = __webpack_require__(666162);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/index.js + 2 modules
var AtomicComponents = __webpack_require__(438855);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ProductItemWidget/Card1/Card.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  position: relative;\n  box-sizing: border-box;\n  border: ",
        ";\n  padding: ",
        ";\n  border-radius: ",
        ";\n  cursor: ",
        ";\n  ",
        ";\n\n  @media screen and (max-width: 766px) {\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  flex: 1;\n  height: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: '100%';\n  height: 'auto';\n  position: relative;\n  object-fit: contain;\n  display: flex;\n\n  & > img {\n    width: 100%;\n    object-position: center center;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  box-sizing: border-box;\n  padding: ",
        ";\n  position: relative;\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n  font-size: 12px;\n  margin: 0 0 12px 0;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-flow: row wrap;\n  padding: ",
        ";\n\n  & > span:last-child {\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 0 0 auto;\n  align-items: center;\n  padding: 2px 4px;\n  margin-bottom: 4px;\n  color: #ffffff;\n  font-size: 11px;\n  background-color: ",
        ";\n  white-space: nowrap;\n  margin-right: 10px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 500;\n  margin: 0.5rem 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 14px;\n  ",
        "\n  font-size: 15px;\n  word-break: break-word;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  color: ",
        ";\n  letter-spacing: 1.5px;\n  font-size: 16px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  text-decoration: line-through;\n  color: rgba(0, 0, 0, 0.3);\n  letter-spacing: 1.3px;\n  margin-left: 10px;\n  font-size: 13px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  position: absolute;\n  background-color: #3ea200;\n  color: #ffffff;\n  font-size: 11px;\n  text-transform: uppercase;\n  z-index: 2;\n  padding: 2px 3px;\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 0;\n  flex-direction: column;\n\n  @media screen and (min-width: 401px) {\n    margin-left: 10px;\n    margin-top: 0.5rem;\n  }\n\n  @media screen and (max-width: 400px) {\n    margin-top: 10px;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  @media screen and (min-width: 767px) {\n    font-size: 22px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 18px;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  color: #9c9c9c;\n  font-weight: 400;\n  letter-spacing: 0.26px;\n  line-height: 1.5;\n\n  ",
        ";\n\n  @media screen and (min-width: 767px) {\n    font-size: 12px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 11px;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  color: ",
        ";\n  letter-spacing: 1.5px;\n  font-size: 14px;\n  font-weight: 700;\n  @media screen and (max-width: ",
        "px) {\n    font-size: 13px;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}



var CardContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CardContainer",
    componentId: "sc-dcb82913-0"
})(_templateObject(), function(props) {
    return !props.imageUrl && "0.4px solid #C7C7C7;";
}, function(props) {
    return !props.imageUrl && "20px;";
}, function(props) {
    return !props.imageUrl && "4px;";
}, function(props) {
    return props.isAvailable || props.isNotifyProductEnabled ? "pointer" : "default";
}, function(props) {
    return !!props.isAvailable || props.isB2bStore ? null : "filter: grayscale(1);";
}, function(props) {
    return !props.imageUrl ? " grid-column: 1 / -1;" : " max-width: 100%;";
});
var CardBody = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "CardBody",
    componentId: "sc-dcb82913-1"
})(_templateObject1());
var CardImage = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "CardImage",
    componentId: "sc-dcb82913-2"
})(_templateObject2());
var CardMain = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "CardMain",
    componentId: "sc-dcb82913-3"
})(_templateObject3(), function(param) {
    var padding = param.padding;
    return padding ? "4px 6px" : "12px 0 14px";
}, function(props) {
    return props.imageUrl && "\n    @media screen and (max-width: 400px) {\n      flex-direction: column;\n    }\n  ";
});
var CardData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CardData",
    componentId: "sc-dcb82913-4"
})(_templateObject4());
var CardInventory = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "CardInventory",
    componentId: "sc-dcb82913-5"
})(_templateObject5());
var CardTags = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CardTags",
    componentId: "sc-dcb82913-6"
})(_templateObject6(), function(param) {
    var padding = param.padding;
    return padding;
});
var CardTag = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "CardTag",
    componentId: "sc-dcb82913-7"
})(_templateObject7(), function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor;
});
var CardTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    displayName: "CardTitle",
    componentId: "sc-dcb82913-8"
})(_templateObject8(), function(props) {
    return props.categoryCard && "text-align: center;";
});
var CardPrice = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CardPrice",
    componentId: "sc-dcb82913-9"
})(_templateObject9());
var AmountDiscounted = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "AmountDiscounted",
    componentId: "sc-dcb82913-10"
})(_templateObject10(), function(props) {
    return props.fontColor;
});
var AmountActual = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "AmountActual",
    componentId: "sc-dcb82913-11"
})(_templateObject11());
var CardDiscount = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "CardDiscount",
    componentId: "sc-dcb82913-12"
})(_templateObject12(), function(props) {
    return props.imageUrl ? "bottom: 0px;" : "top: -25px;";
});
var ButtonContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "ButtonContainer",
    componentId: "sc-dcb82913-13"
})(_templateObject13());
var Button = (0,styled_components_browser_esm/* default */.ZP)(AtomicComponents/* CartButton */.WE).withConfig({
    displayName: "Button",
    componentId: "sc-dcb82913-14"
})(_templateObject14());
var CardDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "CardDescription",
    componentId: "sc-dcb82913-15"
})(_templateObject15(), function(props) {
    return props.isAvailable && "\n      display: -webkit-box;\n      -webkit-line-clamp: 3;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n      text-overflow: ellipsis;    \n    ";
});
var B2BPriceText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "B2BPriceText",
    componentId: "sc-dcb82913-16"
})(_templateObject16(), function(props) {
    return props.fontColor;
}, constants/* MAX_MOBILE_WIDTH */.Cf);

// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(186812);
// EXTERNAL MODULE: ./src/utils/isNotifyProductEnabled.js
var isNotifyProductEnabled = __webpack_require__(532953);
// EXTERNAL MODULE: ./src/utils/checkForLimitedQuantity.js
var checkForLimitedQuantity = __webpack_require__(427994);
// EXTERNAL MODULE: ./src/utils/itemQuantityValueComparison.js
var itemQuantityValueComparison = __webpack_require__(973175);
// EXTERNAL MODULE: ./src/utils/getStoreType.js
var getStoreType = __webpack_require__(66871);
// EXTERNAL MODULE: ./src/utils/getDiscountPercentage.js
var getDiscountPercentage = __webpack_require__(153716);
// EXTERNAL MODULE: ./src/components/Common/Toast/index.jsx
var Toast = __webpack_require__(40804);
// EXTERNAL MODULE: ./src/utils/canShowPDPSystem.js
var canShowPDPSystem = __webpack_require__(813051);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(505152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/utils/returnSpecificImageUrl.js
var returnSpecificImageUrl = __webpack_require__(828631);
// EXTERNAL MODULE: ./src/components/ProductMediaRenderer/MediaContainer.tsx
var MediaContainer = __webpack_require__(748577);
// EXTERNAL MODULE: ./src/components/DesignSystem/Card/CardSkeleton.tsx
var CardSkeleton = __webpack_require__(379062);
// EXTERNAL MODULE: ./src/components/DesignSystem/NextImage/index.ts + 1 modules
var NextImage = __webpack_require__(527941);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ItemImage/index.tsx







// eslint-disable-next-line no-undef


var LazyMotionSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4914), __webpack_require__.e(448), __webpack_require__.e(7357)]).then(__webpack_require__.bind(__webpack_require__, 227357)).then(function(mod) {
        return mod.motion.section;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(546431)
            ];
        }
    },
    ssr: false
});
var LazyMotionDiv = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4914), __webpack_require__.e(448), __webpack_require__.e(7357)]).then(__webpack_require__.bind(__webpack_require__, 227357)).then(function(mod) {
        return mod.motion.div;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(546431)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardSkeleton/* default */.Z, {});
    }
});
var slideMotionFirst = {
    rest: {
        x: 0,
        opacity: 1,
        transition: {
            duration: 0.25,
            type: "tween",
            ease: "easeInOut"
        }
    },
    hover: {
        x: "-100%",
        opacity: 0,
        transition: {
            duration: 0.25,
            type: "tween",
            ease: "easeInOut"
        }
    }
};
var slideMotionSecond = {
    rest: {
        x: "100%",
        opacity: 0,
        transition: {
            duration: 0.25,
            type: "tween",
            ease: "easeInOut"
        }
    },
    hover: {
        x: 0,
        opacity: 1,
        transition: {
            duration: 0.25,
            type: "tween",
            ease: "easeInOut"
        }
    }
};
var dissolveMotionFirst = {
    rest: {
        x: 0,
        opacity: 1,
        transition: {
            duration: 0.8
        }
    },
    hover: {
        x: 0,
        opacity: 0,
        transition: {
            duration: 0.8
        }
    }
};
var dissolveMotionSecond = {
    rest: {
        x: 0,
        opacity: 0,
        transition: {
            duration: 0.8
        }
    },
    hover: {
        x: 0,
        opacity: 1,
        transition: {
            duration: 0.8
        }
    }
};
var defaultImageUrl = "https://cdn.dotpe.in/longtail/store-items/default_image.png";
var ItemImage = function(props) {
    var ref, ref1;
    var ref2 = (0,react.useState)({
        first: null,
        second: null
    }), animationProperties = ref2[0], setAnimationProperties = ref2[1];
    var ref3 = (0,react.useState)([]), imgArr = ref3[0], setImgArr = ref3[1];
    var theme = (0,es/* useSelector */.v9)(function(state) {
        return state.storeReducer.store;
    }).theme;
    (0,react.useEffect)(function() {
        var ref;
        if (props === null || props === void 0 ? void 0 : (ref = props.categoryConfig) === null || ref === void 0 ? void 0 : ref.animation) {
            var ref1;
            switch(props === null || props === void 0 ? void 0 : (ref1 = props.categoryConfig) === null || ref1 === void 0 ? void 0 : ref1.animation){
                case "slide":
                    {
                        setAnimationProperties({
                            first: slideMotionFirst,
                            second: slideMotionSecond
                        });
                        break;
                    }
                case "pop":
                    {
                        setAnimationProperties({
                            first: dissolveMotionFirst,
                            second: dissolveMotionSecond
                        });
                        break;
                    }
                default:
                    setAnimationProperties({
                        first: null,
                        second: null
                    });
                    break;
            }
        }
    }, [
        props === null || props === void 0 ? void 0 : (ref = props.categoryConfig) === null || ref === void 0 ? void 0 : ref.animation
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1;
        if ((props === null || props === void 0 ? void 0 : (ref = props.productData) === null || ref === void 0 ? void 0 : (ref1 = ref.images) === null || ref1 === void 0 ? void 0 : ref1.length) > 2) {
            var ref2;
            var images = props === null || props === void 0 ? void 0 : (ref2 = props.productData) === null || ref2 === void 0 ? void 0 : ref2.images;
            // if image length is more than 2
            // reduce array length down to 2
            images.length = 2;
            setImgArr(images);
        } else {
            var ref3;
            setImgArr(props === null || props === void 0 ? void 0 : (ref3 = props.productData) === null || ref3 === void 0 ? void 0 : ref3.images);
        }
    }, [
        props === null || props === void 0 ? void 0 : (ref1 = props.productData) === null || ref1 === void 0 ? void 0 : ref1.images
    ]);
    var checkForMediaType = function(image) {
        if (image.media_type === 2) return defaultImageUrl;
        else return (0,returnSpecificImageUrl/* returnSpecificImageUrl */.B)({
            theme: theme,
            item: image
        });
    };
    var singleImageRender = function(image) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaContainer/* MediaContainer */.X, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-h-full tw-w-full tw-bg-contain tw-bg-center tw-bg-no-repeat",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* NextImage */.o, {
                    layout: "fill",
                    objectFit: "contain",
                    loading: "lazy",
                    decoding: "async",
                    src: checkForMediaType(image)
                })
            })
        });
    };
    var multiImageRender = function(imgArr) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaContainer/* MediaContainer */.X, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyMotionSection, {
                className: "image-wrap tw-h-full tw-w-full !tw-bg-transparent",
                initial: "rest",
                whileHover: "hover",
                animate: "rest",
                children: !!(imgArr === null || imgArr === void 0 ? void 0 : imgArr.length) && imgArr.map(function(image, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyMotionDiv, {
                        variants: index === 0 ? animationProperties.first : animationProperties.second,
                        className: "collection-image",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* NextImage */.o, {
                            layout: "fill",
                            objectFit: "contain",
                            loading: "lazy",
                            decoding: "async",
                            src: checkForMediaType(image)
                        })
                    }, index);
                })
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative w-100 framer-card",
        children: [
            (imgArr === null || imgArr === void 0 ? void 0 : imgArr.length) === 1 || !imgArr ? singleImageRender(imgArr ? imgArr[0] : {
                image_url: defaultImageUrl
            }) : multiImageRender(imgArr),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "banner-type",
                children: (0,canShowPDPSystem/* canShowPDPSystem */.R)(theme === null || theme === void 0 ? void 0 : theme.theme_class) ? "View Product" : "Quick View"
            })
        ]
    });
};
/* harmony default export */ var DesignSystem_ItemImage = (ItemImage);

// EXTERNAL MODULE: ./src/utils/mutateItemObjectWithCartData.js
var mutateItemObjectWithCartData = __webpack_require__(822787);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
// EXTERNAL MODULE: ./src/hooks/useCartHandler.js
var useCartHandler = __webpack_require__(491240);
// EXTERNAL MODULE: ./src/utils/checkRenderEnv.js
var checkRenderEnv = __webpack_require__(506337);
// EXTERNAL MODULE: ./src/components/Wishlist/WishlistHeartButton.tsx + 2 modules
var WishlistHeartButton = __webpack_require__(406632);
// EXTERNAL MODULE: ./src/constants/wishlist.js
var wishlist = __webpack_require__(298627);
// EXTERNAL MODULE: ./src/hooks/useSetWishlistState.tsx
var useSetWishlistState = __webpack_require__(106531);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ProductItemWidget/Card1/index.js





















var ProductCardWidget1 = function(props) {
    var removeTagsAndReturn = // function to remove all anchor tags from string
    function removeTagsAndReturn(str) {
        if (checkRenderEnv/* IS_SERVER */.W6) return str;
        var tmp = document.createElement("div");
        // add string to created div as html
        tmp.innerHTML = str;
        // get all anchor tags added to created element
        var anchor_tag_collection = tmp.getElementsByTagName("a");
        // iterate over all the tags and remove them from the HTML collection
        if (anchor_tag_collection.length) {
            // convert HTML collection to array
            Array.from(anchor_tag_collection).forEach(function(tag) {
                // remove the tags
                if (tag) {
                    tag.parentNode.removeChild(tag);
                }
            });
        }
        return tmp.textContent || tmp.innerText || "";
    };
    var handleOnClickCardContainer = function handleOnClickCardContainer() {
        if ((data === null || data === void 0 ? void 0 : data.available) || (0,isNotifyProductEnabled/* isNotifyProductEnabled */.Z)()) {
            props.onItemClick && props.onItemClick();
        }
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var data = props.data, _showCategoryCard = props.showCategoryCard, showCategoryCard = _showCategoryCard === void 0 ? false : _showCategoryCard, _imageUrl = props.imageUrl, imageUrl = _imageUrl === void 0 ? "https://picsum.photos/300/300" : _imageUrl, _noTags = props.noTags, noTags = _noTags === void 0 ? false : _noTags;
    var dispatch = (0,es/* useDispatch */.I0)();
    var storeData = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer.store;
    });
    var ref8 = (0,es/* useSelector */.v9)(function(state) {
        return {
            userData: state.userReducer,
            cartData: state.cartReducer
        };
    }), userData = ref8.userData, cartData = ref8.cartData;
    var theme = storeData.theme, store_id = storeData.store_id, premium = storeData.premium;
    var ref9 = (0,react.useState)(0), discountPercent = ref9[0], setDiscountPercent = ref9[1];
    var ref10 = (0,react.useState)(data === null || data === void 0 ? void 0 : data.item_whislisted), isItemWishlisted = ref10[0], setIsItemWishlisted = ref10[1];
    var ref11 = (0,useCartHandler/* useCartHandlers */.u)(), setProductData = ref11.setProductData, onPersonalizeProductClick = ref11.onPersonalizeProductClick, handleIncreamentClick = ref11.handleIncreamentClick, handleDecreamentClick = ref11.handleDecreamentClick, handleSetProductCustomizationCount = ref11.handleSetProductCustomizationCount;
    var setWishlistState = (0,useSetWishlistState/* useSetWishlistState */.X)().setWishlistState;
    var isB2bStore = (0,getStoreType/* getStoreType */.K)(storeData) === constants/* STORE_CUSTOMIZATION.B2B */.DO.B2B;
    var itemIndexInCart = cartData.items.findIndex(function(el) {
        return (el.id || el.item_id) === (data === null || data === void 0 ? void 0 : data.id);
    });
    (0,react.useEffect)(function() {
        if (data) {
            var percent = (0,getDiscountPercentage/* getDiscountPercentage */.$)(data === null || data === void 0 ? void 0 : data.price, data === null || data === void 0 ? void 0 : data.discounted_price);
            setDiscountPercent(percent ? percent : 0);
            setIsItemWishlisted(data === null || data === void 0 ? void 0 : data.item_whislisted);
        }
    }, [
        data
    ]);
    var handleAddRemoveItem = function(type) {
        var ref, ref1, ref2;
        dispatch((0,logs/* pushEventsLog */.U)({
            event_name: "Cx_ATC",
            data: {
                store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
                domain: storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain,
                page: window.location.href,
                device: deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf ? "Mobile" : "Desktop",
                cx_number: userData === null || userData === void 0 ? void 0 : (ref1 = userData.data) === null || ref1 === void 0 ? void 0 : ref1.phone
            }
        }));
        var productItem = cartData.items[itemIndexInCart];
        // managed_inventory !== 0. available_quantity !== 0.
        // don't proceed to control flow if available_quantity is 0
        if (type === "inc" && (0,itemQuantityValueComparison/* itemQuantityValueComparison */.i)(productItem)) {
            (0,Toast/* toastNotifyInfo */.lU)("No more units available for purchase");
            return;
        }
        /** Check if variant present in this item */ if (((ref2 = props.data) === null || ref2 === void 0 ? void 0 : ref2.variants_count) > 0) {
            var ref3;
            dispatch((0,common/* saveProductLoaderId */.XG)((ref3 = props.data) === null || ref3 === void 0 ? void 0 : ref3.id));
            /** check if item exist in cart */ if (itemIndexInCart !== -1) {
                setProductData && setProductData(productItem);
                switch(type){
                    case "inc":
                        dispatch((0,common/* setVariantModalVisibility */.VZ)(true));
                        break;
                    case "dec":
                        dispatch((0,common/* setSelectedVariantModalVisibility */.rV)(true));
                        break;
                }
            } else {
                var ref4;
                /** get the details item for this item id */ dispatch((0,catalog/* fetchCatalogItemById */.eP)({
                    store_id: store_id,
                    item_id: (ref4 = props.data) === null || ref4 === void 0 ? void 0 : ref4.id,
                    src: "design_system_product_item_widget_card1"
                }, true, function(data) {
                    return setProductData && setProductData(data);
                }));
            }
        } else {
            if (data === null || data === void 0 ? void 0 : data.product_personalization) {
                handleSetProductCustomizationCount && handleSetProductCustomizationCount(data);
                setProductData && setProductData(data);
                switch(type){
                    case "add":
                        onPersonalizeProductClick && onPersonalizeProductClick();
                        break;
                    case "inc":
                        handleIncreamentClick && handleIncreamentClick(type, data);
                        break;
                    case "dec":
                        handleDecreamentClick && handleDecreamentClick(type, data);
                        break;
                    default:
                        break;
                }
            } else {
                var newState = (0,mutateItemObjectWithCartData/* mutateItemObjectWithCartData */.L)(type, data, cartData);
                dispatch((0,cart/* saveCart */.FP)(newState));
            }
        }
    };
    var handleToggleWishlistClick = function(id) {
        var payload = {
            item_id: id,
            status: isItemWishlisted ? wishlist/* ITEM_WISHLIST_STATE.REMOVE_FROM_WISHLIST */.U.REMOVE_FROM_WISHLIST : wishlist/* ITEM_WISHLIST_STATE.ITEM_WISHLISTED */.U.ITEM_WISHLISTED
        };
        setWishlistState(payload, function(status) {
            if (status) {
                setIsItemWishlisted(function(prev) {
                    return !prev;
                });
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContainer, {
        isAvailable: data === null || data === void 0 ? void 0 : data.available,
        isB2bStore: isB2bStore,
        reactSlick: props.reactSlick,
        categoryCard: showCategoryCard,
        imageUrl: data === null || data === void 0 ? void 0 : data.thumbnail_url,
        isNotifyProductEnabled: (0,isNotifyProductEnabled/* isNotifyProductEnabled */.Z)(),
        style: {
            boxShadow: premium === 0 && theme.is_demo === 0 ? "0 2px 6px #4a4a4a" : ""
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardBody, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    onClick: handleOnClickCardContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DesignSystem_ItemImage, {
                        categoryConfig: props.categoryConfig,
                        productData: data
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-z-100 tw-absolute tw-right-[4px] tw-top-[7px] tw-rounded-[100%]",
                    onClick: function(e) {
                        e.preventDefault();
                        e.stopPropagation();
                        handleToggleWishlistClick(data === null || data === void 0 ? void 0 : data.id);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WishlistHeartButton/* default */.Z, {
                        isActive: isItemWishlisted
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardMain, {
                    imageUrl: data === null || data === void 0 ? void 0 : data.thumbnail_url,
                    padding: premium === 0,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardData, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex justify-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex pr2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTitle, {
                                                categoryCard: showCategoryCard,
                                                onClick: handleOnClickCardContainer,
                                                property: "name",
                                                children: (data === null || data === void 0 ? void 0 : data.name) || "Available Items"
                                            })
                                        }),
                                        (props === null || props === void 0 ? void 0 : (ref = props.productConfig) === null || ref === void 0 ? void 0 : ref.add_to_cart_visibility) === true && (data === null || data === void 0 ? void 0 : data.available) === 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonContainer, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                                    disableAddition: (0,itemQuantityValueComparison/* itemQuantityValueComparison */.i)(cartData.items[itemIndexInCart]),
                                                    fontSize: "14",
                                                    onChange: handleAddRemoveItem,
                                                    quantity: itemIndexInCart >= 0 ? cartData.items[itemIndexInCart].quantity : 0
                                                }),
                                                ((ref1 = props.data) === null || ref1 === void 0 ? void 0 : ref1.variants_count) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "variant--count-icontext",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "https://cdn.dotpe.in/longtail/themes/8073865/FcwGogkZ.webp"
                                                        }),
                                                        (ref2 = props.data) === null || ref2 === void 0 ? void 0 : ref2.variants_count,
                                                        " options"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                !!(data === null || data === void 0 ? void 0 : data.available) && (0,checkForLimitedQuantity/* checkForLimitedQuantity */.U)(data) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardInventory, {
                                    className: "highlighter-red-color",
                                    children: "Limited Stock Left"
                                }),
                                isB2bStore && /*#__PURE__*/ (0,jsx_runtime.jsx)(B2BPriceText, {
                                    fontColor: theme === null || theme === void 0 ? void 0 : (ref3 = theme.colors) === null || ref3 === void 0 ? void 0 : ref3.primary_color,
                                    children: (data === null || data === void 0 ? void 0 : (ref4 = data.b2b_pricing_info) === null || ref4 === void 0 ? void 0 : ref4.price_range) || "Price on Request"
                                }),
                                !showCategoryCard && !isB2bStore && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardPrice, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AmountDiscounted, {
                                                fontColor: theme === null || theme === void 0 ? void 0 : (ref5 = theme.colors) === null || ref5 === void 0 ? void 0 : ref5.primary_color,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "₹"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: data === null || data === void 0 ? void 0 : data.discounted_price
                                                    })
                                                ]
                                            }),
                                            (data === null || data === void 0 ? void 0 : data.discounted_price) !== (data === null || data === void 0 ? void 0 : data.price) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(AmountActual, {
                                                children: [
                                                    "₹",
                                                    data === null || data === void 0 ? void 0 : data.price
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        !showCategoryCard && !imageUrl && discountPercent > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardDiscount, {
                            children: "".concat(discountPercent, "% OFF")
                        })
                    ]
                }),
                !noTags && (data === null || data === void 0 ? void 0 : (ref6 = data.tags) === null || ref6 === void 0 ? void 0 : ref6.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTags, {
                    padding: "0 0 8px",
                    children: data === null || data === void 0 ? void 0 : (ref7 = data.tags) === null || ref7 === void 0 ? void 0 : ref7.map(function(tag) {
                        return tag.is_active !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTag, {
                            backgroundColor: tag.tag_color,
                            children: tag.name
                        }, tag.id);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: premium === 0 && "ph2 pb2",
                    property: "description",
                    children: !(data === null || data === void 0 ? void 0 : data.available) && !isB2bStore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CardDescription, {
                        children: "Out of stock"
                    }) : !showCategoryCard && (data === null || data === void 0 ? void 0 : data.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardDescription, {
                        isAvailable: !!(data === null || data === void 0 ? void 0 : data.available),
                        children: removeTagsAndReturn(data === null || data === void 0 ? void 0 : data.description)
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Card1 = (ProductCardWidget1);

;// CONCATENATED MODULE: ./src/components/DesignSystem/ProductItemWidget/index.js




/***/ }),

/***/ 202386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S3": function() { return /* binding */ useProductCardElements; },
/* harmony export */   "eH": function() { return /* binding */ calculateLayoutGap; },
/* harmony export */   "lT": function() { return /* binding */ useProductCardDimensions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(269396);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);
/* harmony import */ var src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(474151);




var MAX_CARD_WIDTH = 450;
// const MIN_CARD_WIDTH = 200;
var MAX_CARD_HEIGHT = 450;
function useProductCardElements() {
    var ref, ref1;
    var ref2 = (0,src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_1__/* .useWidgetDndContextData */ .KX)(), globalStyle = ref2.widgetContextState.globalStyle;
    var ref3 = (globalStyle === null || globalStyle === void 0 ? void 0 : globalStyle.productCard) || {
        infoList: [],
        isEnabled: false
    }, infoList = ref3.infoList, isProductCardEnabled = ref3.isEnabled;
    var imageElement = infoList === null || infoList === void 0 ? void 0 : infoList.find(function(item) {
        return item.type === "image";
    });
    var layoutElement = infoList === null || infoList === void 0 ? void 0 : infoList.find(function(item) {
        return item.type === "layout";
    });
    return {
        isProductCardEnabled: isProductCardEnabled,
        layoutElement: layoutElement,
        imageElement: imageElement,
        infoList: infoList,
        aspectRatio: (imageElement === null || imageElement === void 0 ? void 0 : (ref = imageElement.config) === null || ref === void 0 ? void 0 : ref.aspectRatio) || (imageElement === null || imageElement === void 0 ? void 0 : (ref1 = imageElement.config) === null || ref1 === void 0 ? void 0 : ref1.aspectRation)
    };
}
function useProductCardDimensions(param) {
    var imageWidth = param.imageWidth;
    var aspectRatio = useProductCardElements().aspectRatio;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        cardHeight: 0,
        cardWidth: 0
    }), cardSelfDimensions = ref[0], setCardSelfDimensions = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (aspectRatio) {
            var aspectRatios = function() {
                var ratio = (aspectRatio === null || aspectRatio === void 0 ? void 0 : aspectRatio.split(":")) || [
                    1,
                    1
                ];
                return {
                    heightMultiplier: +ratio[1],
                    widthMultiplier: +ratio[0]
                };
            }();
            if (imageWidth) {
                var calculatedCardWidth = imageWidth > MAX_CARD_WIDTH ? MAX_CARD_WIDTH : //   ? MIN_CARD_WIDTH
                imageWidth;
                var calculatedCardHeight = calculatedCardWidth * (aspectRatios.heightMultiplier / aspectRatios.widthMultiplier);
                if (calculatedCardHeight > MAX_CARD_HEIGHT) {
                    calculatedCardHeight = MAX_CARD_HEIGHT;
                    calculatedCardWidth = calculatedCardHeight * (aspectRatios.widthMultiplier / aspectRatios.heightMultiplier);
                }
                setCardSelfDimensions(function(data) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, data), {
                        cardWidth: calculatedCardWidth,
                        cardHeight: calculatedCardHeight
                    });
                });
            }
        }
    }, [
        imageWidth,
        aspectRatio
    ]);
    return {
        cardSelfDimensions: cardSelfDimensions
    };
}
var calculateLayoutGap = function(param) {
    var showCustomProductCard = param.showCustomProductCard, cardWrapperConfigs = param.cardWrapperConfigs, isMobile = param.isMobile;
    var gap = {
        columnGap: 20,
        rowGap: 30
    };
    if (!showCustomProductCard) return gap;
    if (!isMobile && !cardWrapperConfigs.isCardLayout) {
        gap.columnGap = 28;
        gap.rowGap = 52;
        return gap;
    }
    if (!isMobile && cardWrapperConfigs.isCardLayout) {
        gap.columnGap = 16;
        gap.rowGap = 16;
        return gap;
    }
    if (isMobile && !cardWrapperConfigs.isCardLayout) {
        gap.columnGap = 16;
        gap.rowGap = 32;
        return gap;
    }
    gap.columnGap = 8;
    gap.rowGap = 8;
    return gap;
};


/***/ }),

/***/ 628253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _utils_checkIfObjectExists__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(631891);
/* harmony import */ var _assets_svgExports_BackArrow__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(285946);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(667294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(225617);
/* harmony import */ var src_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(477733);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);







var EmiCardSelection = function(param) {
    var _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), selectedEmi = ref[0], setSelectedEmi = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), selectedAccordion = ref1[0], setSelectedAccordion = ref1[1];
    var allEmiOptions = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return {
            allEmiOptions: state.emiReducer.allEmiOptions
        };
    }).allEmiOptions;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if ((0,_utils_checkIfObjectExists__WEBPACK_IMPORTED_MODULE_6__/* .checkIfObjectExists */ .L)(allEmiOptions)) {
            setSelectedAccordion(0);
            if ((0,_utils_checkIfObjectExists__WEBPACK_IMPORTED_MODULE_6__/* .checkIfObjectExists */ .L)(allEmiOptions === null || allEmiOptions === void 0 ? void 0 : allEmiOptions.emi_options_for_credit_card)) {
                setSelectedEmi("cc");
            } else if ((0,_utils_checkIfObjectExists__WEBPACK_IMPORTED_MODULE_6__/* .checkIfObjectExists */ .L)(allEmiOptions === null || allEmiOptions === void 0 ? void 0 : allEmiOptions.emi_options_for_debit_card)) {
                setSelectedEmi("dc");
            }
        }
    }, [
        allEmiOptions
    ]);
    var setSelectedEmiOnClick = function(type) {
        return setSelectedEmi(type);
    };
    var accordionHeaderClick = function(type) {
        if (selectedAccordion === type) setSelectedAccordion(null);
        else setSelectedAccordion(type);
    };
    var ref2, ref3;
    var emiOptionArr = [
        {
            label: "Credit Card EMI",
            emiOption: (ref2 = allEmiOptions === null || allEmiOptions === void 0 ? void 0 : allEmiOptions.emi_options_for_credit_card) !== null && ref2 !== void 0 ? ref2 : {},
            type: "cc"
        },
        {
            label: "Debit Card EMI",
            emiOption: (ref3 = allEmiOptions === null || allEmiOptions === void 0 ? void 0 : allEmiOptions.emi_options_for_debit_card) !== null && ref3 !== void 0 ? ref3 : {},
            type: "dc"
        }, 
    ];
    var emiAccordionSystem = function() {
        var ref, ref1;
        var specificAccordionData = (0,_utils_checkIfObjectExists__WEBPACK_IMPORTED_MODULE_6__/* .checkIfObjectExists */ .L)(allEmiOptions) && selectedEmi && selectedEmi === "cc" ? allEmiOptions === null || allEmiOptions === void 0 ? void 0 : allEmiOptions.emi_options_for_credit_card : allEmiOptions === null || allEmiOptions === void 0 ? void 0 : allEmiOptions.emi_options_for_debit_card;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "accordion",
            children: ((ref = Object.keys(specificAccordionData !== null && specificAccordionData !== void 0 ? specificAccordionData : {})) === null || ref === void 0 ? void 0 : ref.length) ? (ref1 = Object.keys(specificAccordionData !== null && specificAccordionData !== void 0 ? specificAccordionData : {})) === null || ref1 === void 0 ? void 0 : ref1.map(function(acc, index) {
                var ref;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "accordion-item",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "accordion__header flex items-center justify-between pointer",
                            onClick: function() {
                                return accordionHeaderClick(index);
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: "accordion__header--title",
                                    children: [
                                        acc,
                                        " Bank"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        style: {
                                            transform: selectedAccordion === index ? "rotate(180deg)" : "rotate(0deg)"
                                        },
                                        src: "/assets/images/down-arrow-thin.svg",
                                        alt: "dropdown button"
                                    })
                                })
                            ]
                        }),
                        selectedAccordion === index && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "accordion__body",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("table", {
                                className: "emi-table",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("thead", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                    children: "EMI Plan"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                    children: "Interest (pa)"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                    children: "Total Cost"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tbody", {
                                        children: (ref = specificAccordionData[acc]) === null || ref === void 0 ? void 0 : ref.map(function(data) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("td", {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("b", {
                                                                children: [
                                                                    src_config__WEBPACK_IMPORTED_MODULE_4__/* .CURRENCY_SYMBOL */ .o,
                                                                    data.payable_emi_value
                                                                ]
                                                            }),
                                                            " ",
                                                            "X ",
                                                            data.tenure
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("td", {
                                                        children: [
                                                            src_config__WEBPACK_IMPORTED_MODULE_4__/* .CURRENCY_SYMBOL */ .o,
                                                            data.monthly_emi_amount,
                                                            " (",
                                                            data.emi_bank_interest,
                                                            "%)"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("td", {
                                                        children: [
                                                            src_config__WEBPACK_IMPORTED_MODULE_4__/* .CURRENCY_SYMBOL */ .o,
                                                            data.total_payable_amount
                                                        ]
                                                    })
                                                ]
                                            }, JSON.stringify(data));
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }, acc);
            }) : null
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "emiSelection",
        children: [
            isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "page-header flex items-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_BackArrow__WEBPACK_IMPORTED_MODULE_1__/* .BackArrow */ .D, {
                        onClick: function() {
                            return router.back();
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "header-text ml3 fw6",
                        children: "EMI Options"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "emiSelection__header",
                children: emiOptionArr === null || emiOptionArr === void 0 ? void 0 : emiOptionArr.map(function(emi) {
                    return (0,_utils_checkIfObjectExists__WEBPACK_IMPORTED_MODULE_6__/* .checkIfObjectExists */ .L)(emi.emiOption) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        onClick: function() {
                            return setSelectedEmiOnClick(emi.type);
                        },
                        className: "emiSelection__header--item relative ".concat(selectedEmi === emi.type ? "active" : ""),
                        children: [
                            emi.label,
                            selectedEmi === emi.type && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "active-banner"
                            })
                        ]
                    }, emi.type) : null;
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "emiSelection__body",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "center emiSelection__body--inner",
                    children: emiAccordionSystem()
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EmiCardSelection);


/***/ }),

/***/ 315241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ FullPageLoader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(225617);
/* harmony import */ var src_components_WidgetMaker_WidgetDnD_GlobalCfeLoader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(179220);
/* harmony import */ var src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(474151);



// import interLoader from '../../../public/assets/images/inter-loader.gif';


function FullPageLoader() {
    var ref, ref1;
    var ref2 = (0,src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_4__/* .useWidgetDndContextData */ .KX)(), globalStyle = ref2.widgetContextState.globalStyle;
    var globalLoader = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return {
            globalLoader: state.commonReducer.globalLoader
        };
    }).globalLoader;
    return globalLoader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "global-loader",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_WidgetMaker_WidgetDnD_GlobalCfeLoader__WEBPACK_IMPORTED_MODULE_3__/* .GlobalCfeLoader */ .I, {
            type: (globalStyle === null || globalStyle === void 0 ? void 0 : (ref = globalStyle.appLoader) === null || ref === void 0 ? void 0 : ref.loaderId) || "ellipsis",
            color: globalStyle === null || globalStyle === void 0 ? void 0 : (ref1 = globalStyle.appLoader) === null || ref1 === void 0 ? void 0 : ref1.color
        })
    });
}


/***/ }),

/***/ 573409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* reexport */ Link; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(741664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/Link/link.module.scss
var link_module = __webpack_require__(870919);
var link_module_default = /*#__PURE__*/__webpack_require__.n(link_module);
;// CONCATENATED MODULE: ./src/components/Link/Link.tsx



var Link = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: props.href,
        target: props.target,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: (link_module_default()).link,
            children: props.children
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Link/index.tsx



/***/ }),

/***/ 932948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(225617);
/* harmony import */ var _components_DesignSystem_AtomicComponents_util__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(452388);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(731024);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96031);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(666162);
/* harmony import */ var _Common_Modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(672651);
/* harmony import */ var _utils_mutateVariantItemWithCartData__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(759186);









var VariantChooseRepeatModal = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var ref14 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        repeatIndex: null,
        theme: null
    }), state = ref14[0], setState = ref14[1];
    var ref15 = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.commonReducer;
    }), chooseRepeatModal = ref15.variant.chooseRepeatModal, productLoaderId = ref15.productLoaderId;
    var cartData = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.cartReducer;
    });
    var ref16 = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.storeReducer.store;
    }), theme = ref16.theme, store_id = ref16.store_id;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (chooseRepeatModal) {
            var productIndex = cartData.items.findIndex(function(el) {
                return el.id === productLoaderId;
            });
            setState(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state), {
                    repeatIndex: productIndex
                });
            });
        }
    }, [
        chooseRepeatModal,
        cartData,
        productLoaderId
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (chooseRepeatModal) {
            setState(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state), {
                    theme: theme
                });
            });
        }
    }, [
        chooseRepeatModal,
        theme
    ]);
    var onClose = function() {
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_7__/* .setChooseAndRepeatModalVisibility */ .uT)(false));
    };
    var onIWillChooseBtnHandle = function() {
        /** get the details item for this item id */ dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .fetchCatalogItemById */ .eP)({
            store_id: store_id,
            item_id: productLoaderId,
            src: "variant_choose_repeat_modal"
        }, true));
        onClose();
    };
    var onRepeatBtnHandle = function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var newCart = (0,_utils_mutateVariantItemWithCartData__WEBPACK_IMPORTED_MODULE_4__/* .mutateVariantItemWithCartData */ .I)("repeat", cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : ref[state.repeatIndex], cartData === null || cartData === void 0 ? void 0 : (ref1 = cartData.items) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[state.repeatIndex]) === null || ref2 === void 0 ? void 0 : ref2.variants_selected[(cartData === null || cartData === void 0 ? void 0 : (ref3 = cartData.items) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[state.repeatIndex]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.variants_selected) === null || ref5 === void 0 ? void 0 : ref5.length) - 1], cartData);
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_9__/* .saveCart */ .FP)(newCart));
        onClose();
    };
    return chooseRepeatModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Common_Modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        visible: chooseRepeatModal,
        customStyles: {
            paddingLeft: 0,
            paddingRight: 0
        },
        height: "auto",
        animation: "slideUp",
        className: "bottom-modal variantChooseRepeatModal",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "closeicon",
                onClick: onClose,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    loading: "lazy",
                    src: "https://cdn.dotpe.in/longtail/themes/8073865/9sE359Sh.webp",
                    alt: "cancel"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "title",
                children: "Choose a Variant"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "sub-title",
                children: "Your Last Choice"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("article", {
                className: "variant-name",
                children: (ref5 = cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : (ref1 = ref[state.repeatIndex]) === null || ref1 === void 0 ? void 0 : ref1.variants_selected[(cartData === null || cartData === void 0 ? void 0 : (ref2 = cartData.items) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[state.repeatIndex]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.variants_selected) === null || ref4 === void 0 ? void 0 : ref4.length) - 1]) === null || ref5 === void 0 ? void 0 : ref5.variant_name
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "footer",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: "choose_btn pointer",
                        style: {
                            borderRadius: "".concat(state.theme ? "".concat((0,_components_DesignSystem_AtomicComponents_util__WEBPACK_IMPORTED_MODULE_10__/* .roundnessCalculator */ .M)((ref6 = state.theme) === null || ref6 === void 0 ? void 0 : ref6.roundness)) : "8px"),
                            borderColor: "".concat(state.theme ? (ref7 = state.theme) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.colors) === null || ref8 === void 0 ? void 0 : ref8.primary_color : "#EA5151"),
                            color: "".concat(state.theme ? (ref9 = state.theme) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.colors) === null || ref10 === void 0 ? void 0 : ref10.primary_color : "#EA5151")
                        },
                        onClick: onIWillChooseBtnHandle,
                        children: "I’LL CHOOSE"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: "repeat_btn pointer",
                        style: {
                            backgroundColor: "".concat(state.theme ? (ref11 = state.theme) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.colors) === null || ref12 === void 0 ? void 0 : ref12.primary_color : "#EA5151"),
                            borderRadius: "".concat(state.theme ? "".concat((0,_components_DesignSystem_AtomicComponents_util__WEBPACK_IMPORTED_MODULE_10__/* .roundnessCalculator */ .M)((ref13 = state.theme) === null || ref13 === void 0 ? void 0 : ref13.roundness)) : "8px"),
                            color: "#ffffff"
                        },
                        onClick: onRepeatBtnHandle,
                        children: "REPEAT"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (VariantChooseRepeatModal);


/***/ }),

/***/ 284557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_VariantSelectedListModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var common = __webpack_require__(731024);
// EXTERNAL MODULE: ./src/redux/actions/logs.js
var logs = __webpack_require__(467936);
// EXTERNAL MODULE: ./src/redux/actions/cart.js
var cart = __webpack_require__(666162);
// EXTERNAL MODULE: ./src/components/Common/Modal/index.jsx
var Modal = __webpack_require__(672651);
;// CONCATENATED MODULE: ./src/components/Common/IncDecButton/index.js
/**
 * Increament Decreament Button for Catalog Items
 */ 

var IncDecButton = function(param) {
    var quantity = param.quantity, onChangeEventhandle = param.onChangeEventhandle, _showAddAction = param.showAddAction, showAddAction = _showAddAction === void 0 ? -1 : _showAddAction, catalogCta = param.catalogCta, showLoader = param.showLoader, _disableAddition = param.disableAddition, disableAddition = _disableAddition === void 0 ? false : _disableAddition;
    var styleClass = catalogCta ? "addtocart" : "pdp-addtocart";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(styleClass, "-btn"),
        style: !catalogCta ? {
            backgroundColor: "".concat(quantity <= 0 ? "#EA5151" : "#ffffff")
        } : {
            backgroundColor: "#ffffff"
        },
        children: [
            showAddAction < 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(styleClass, "-btn__changeIcon"),
                onClick: function() {
                    return onChangeEventhandle("add");
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "ADD",
                            !catalogCta && "+"
                        ]
                    }),
                    catalogCta && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        loading: "lazy",
                        src: "https://cdn.dotpe.in/longtail/themes/8073865/P6ghQCtu.webp",
                        alt: "Add Item button"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                style: {
                    display: "flex"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(styleClass, "-btn__changeIcon"),
                        onClick: function() {
                            return onChangeEventhandle("dec");
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            loading: "lazy",
                            src: "https://cdn.dotpe.in/longtail/themes/8073865/GPgsbV9o.webp",
                            alt: "Decreament button"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(styleClass, "-btn__text"),
                        children: quantity
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(styleClass, "-btn__changeIcon"),
                        onClick: function() {
                            return onChangeEventhandle("inc");
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "din ".concat(disableAddition ? "o-20" : "o-100"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                loading: "lazy",
                                src: "https://cdn.dotpe.in/longtail/themes/8073865/P6ghQCtu.webp",
                                alt: "Increment button"
                            })
                        })
                    })
                ]
            }),
            showLoader && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "loading-wrapper"
            })
        ]
    });
};
/* harmony default export */ var Common_IncDecButton = (IncDecButton);

// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(186812);
// EXTERNAL MODULE: ./src/utils/itemQuantityValueComparison.js
var itemQuantityValueComparison = __webpack_require__(973175);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
// EXTERNAL MODULE: ./src/utils/mutateVariantItemWithCartData.js
var mutateVariantItemWithCartData = __webpack_require__(759186);
// EXTERNAL MODULE: ./src/utils/LocalStorageHelper.js
var LocalStorageHelper = __webpack_require__(644779);
// EXTERNAL MODULE: ./src/utils/checkRenderEnv.js
var checkRenderEnv = __webpack_require__(506337);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/hooks/useCartHandler.js
var useCartHandler = __webpack_require__(491240);
;// CONCATENATED MODULE: ./src/components/VariantSelectedListModal/index.js

















var VariantSelectedListModal = function(props) {
    var ref, ref1, ref2;
    var ref3 = (0,useCartHandler/* useCartHandlers */.u)(), handleIncreamentClick = ref3.handleIncreamentClick, handleDecreamentClick = ref3.handleDecreamentClick, handleSetProductData = ref3.handleSetProductData;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref4 = (0,react.useState)({
        itemCartIndex: null
    }), state = ref4[0], setState = ref4[1];
    var ref5 = (0,es/* useSelector */.v9)(function(state) {
        return state.commonReducer;
    }), selectedVariantsModal = ref5.variant.selectedVariantsModal, productLoaderId = ref5.productLoaderId;
    var ref6 = (0,es/* useSelector */.v9)(function(state) {
        return {
            userData: state.userReducer,
            storeData: state.storeReducer.store,
            cartData: state.cartReducer,
            pdpData: state.catalogReducer.pdpData
        };
    }), userData = ref6.userData, storeData = ref6.storeData, cartData = ref6.cartData, pdpData = ref6.pdpData;
    (0,react.useEffect)(function() {
        if (selectedVariantsModal) {
            var ref;
            var productIndex = cartData.items.findIndex(function(el) {
                return el.item_id === productLoaderId;
            });
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    itemCartIndex: productIndex
                });
            });
            if (productLoaderId) {
                dispatch((0,catalog/* fetchCatalogItemById */.eP)({
                    store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
                    item_id: productLoaderId,
                    src: "variant_selected_modal"
                }, false, function(data) {
                    handleSetProductData(data);
                    dispatch((0,catalog/* savePDPData */.zP)(data));
                }));
            }
            if (cartData && !(cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : ref[productIndex])) {
                onClose();
            }
        }
    }, [
        selectedVariantsModal,
        cartData,
        productLoaderId
    ]);
    (0,react.useEffect)(function() {
        if (selectedVariantsModal) {
            if (document.getElementsByTagName("body")[0] && document.getElementsByTagName("body")[0].style) {
                document.getElementsByTagName("body")[0].style.overflowY = "hidden";
            }
        } else {
            if (document.getElementsByTagName("body")[0] && document.getElementsByTagName("body")[0].style) {
                document.getElementsByTagName("body")[0].style.overflowY = "scroll";
            }
        }
    }, [
        selectedVariantsModal
    ]);
    var onClose = function() {
        dispatch((0,common/* setSelectedVariantModalVisibility */.rV)(false));
    };
    var handleAddRemoveItem = function(type, variantType) {
        var ref, ref1, ref2;
        dispatch((0,logs/* pushEventsLog */.U)({
            event_name: "Cx_ATC",
            data: {
                store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
                domain: storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain,
                page: window.location.href,
                device: deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf ? "Mobile" : "Desktop",
                cx_number: userData === null || userData === void 0 ? void 0 : (ref1 = userData.data) === null || ref1 === void 0 ? void 0 : ref1.phone
            }
        }));
        var newCart = (0,mutateVariantItemWithCartData/* mutateVariantItemWithCartData */.I)(type, cartData === null || cartData === void 0 ? void 0 : (ref2 = cartData.items) === null || ref2 === void 0 ? void 0 : ref2[state.itemCartIndex], variantType, cartData);
        dispatch((0,cart/* saveCart */.FP)(newCart));
    };
    var handleOnChange = function(type, variant) {
        if (pdpData === null || pdpData === void 0 ? void 0 : pdpData.product_personalization) {
            handleSetProductData(pdpData);
            checkRenderEnv/* IS_CLIENT */.kc && LocalStorageHelper/* default.add */.Z.add("activeVariantId", variant === null || variant === void 0 ? void 0 : variant.variant_id);
            if (type === "inc") {
                handleIncreamentClick(type, pdpData);
            } else if (type === "dec") {
                handleDecreamentClick(type, pdpData);
            }
            dispatch((0,common/* setSelectedVariantModalVisibility */.rV)(false));
        } else {
            handleAddRemoveItem(type, variant);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        visible: selectedVariantsModal,
        customStyles: {
            paddingLeft: 0,
            paddingRight: 0
        },
        height: "auto",
        animation: "slideUp",
        className: "bottom-modalVvariantSelectedListModal",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "closeicon pointer",
                onClick: onClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    loading: "lazy",
                    src: "https://cdn.dotpe.in/longtail/themes/8073865/9sE359Sh.webp",
                    alt: "cancel"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "title",
                children: "Choose Item to remove"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "item-list",
                children: cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : (ref1 = ref[state.itemCartIndex]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.variants_selected) === null || ref2 === void 0 ? void 0 : ref2.map(function(variant, ind) {
                    var ref, ref1, ref2, ref3;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "item",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-start justify-start",
                                children: [
                                    variant.images && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: variant === null || variant === void 0 ? void 0 : (ref = variant.images) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.image_url,
                                        className: "img h3",
                                        alt: "variant image ".concat(ind + 1)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                        className: "left ml2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "item-name",
                                                children: cartData === null || cartData === void 0 ? void 0 : (ref2 = cartData.items) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[state.itemCartIndex]) === null || ref3 === void 0 ? void 0 : ref3.name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "variant-name",
                                                children: variant.variant_name
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                                className: "right",
                                style: {
                                    justifyContent: "flex-end"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_IncDecButton, {
                                    disableAddition: (0,itemQuantityValueComparison/* itemQuantityValueComparison */.i)(variant),
                                    catalogCta: true,
                                    showAddAction: 1,
                                    quantity: variant.quantity,
                                    onChangeEventhandle: function(change) {
                                        return handleOnChange(change, variant);
                                    }
                                })
                            })
                        ]
                    }, "items-variant-".concat(ind));
                })
            })
        ]
    });
};
/* harmony default export */ var components_VariantSelectedListModal = (VariantSelectedListModal);


/***/ }),

/***/ 155039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _assets_svgExports_WishlistHeartIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(407056);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(225617);
/* harmony import */ var _constants_wishlist__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(298627);
/* harmony import */ var src_hooks_useFeatureLocks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(482516);





var WishlistIcon = function(param) {
    var color = param.color, iconSize = param.iconSize, isActive = param.isActive;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_WishlistHeartIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        color: color,
        iconSize: iconSize,
        isActive: isActive
    });
};
var WishlistText = function(param) {
    var _customTextClassName = param.customTextClassName, customTextClassName = _customTextClassName === void 0 ? "" : _customTextClassName, _ctaText = param.ctaText, ctaText = _ctaText === void 0 ? "Wishlist" : _ctaText;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "tw-font-inter tw-text-[17px] tw-font-normal ".concat(customTextClassName),
        children: ctaText
    });
};
var WishlistBoth = function(param) {
    var color = param.color, iconPosition = param.iconPosition, iconSize = param.iconSize, wrapperClassName = param.wrapperClassName, _customTextClassName = param.customTextClassName, customTextClassName = _customTextClassName === void 0 ? "" : _customTextClassName, ctaText = param.ctaText, isActive = param.isActive;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "tw-flex tw-gap-[10px] tw-items-center ".concat(wrapperClassName),
        children: iconPosition === "right" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistText, {
                    customTextClassName: customTextClassName,
                    ctaText: ctaText
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistIcon, {
                    color: color,
                    iconSize: iconSize,
                    isActive: isActive
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistIcon, {
                    color: color,
                    iconSize: iconSize,
                    isActive: isActive
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistText, {
                    customTextClassName: customTextClassName,
                    ctaText: ctaText
                })
            ]
        })
    });
};
var WishlistHeaderMenuItem = function(param) {
    var color = param.color, iconSize = param.iconSize, _iconPosition = param.iconPosition, iconPosition = _iconPosition === void 0 ? "right" : _iconPosition, _showComponent = param.showComponent, showComponent = _showComponent === void 0 ? "both" : _showComponent, _customTextClassName = param.customTextClassName, customTextClassName = _customTextClassName === void 0 ? "" : _customTextClassName, _wrapperClassName = param.wrapperClassName, wrapperClassName = _wrapperClassName === void 0 ? "" : _wrapperClassName, ctaText = param.ctaText, isActive = param.isActive, onClick = param.onClick;
    var wishlistFeatureActive = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        var ref, ref1, ref2;
        return {
            wishlistFeatureActive: (ref = state.storeReducer) === null || ref === void 0 ? void 0 : (ref1 = ref.store) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.services) === null || ref2 === void 0 ? void 0 : ref2.wishlist_flag
        };
    }).wishlistFeatureActive;
    var wishlistFeatureStatus = (0,src_hooks_useFeatureLocks__WEBPACK_IMPORTED_MODULE_4__/* .useFeatureLocks */ .r)().wishlistFeatureStatus;
    if (wishlistFeatureActive !== _constants_wishlist__WEBPACK_IMPORTED_MODULE_3__/* .WISHLIST_FEATURE_STATUS.WISHLIST_ACTIVE */ .g.WISHLIST_ACTIVE || (wishlistFeatureStatus === null || wishlistFeatureStatus === void 0 ? void 0 : wishlistFeatureStatus.isLocked)) {
        return null;
    }
    if (showComponent === "icon") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        onClick: onClick,
        style: {
            cursor: onClick ? "pointer" : undefined
        },
        className: "tw-flex tw-items-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistIcon, {
            color: color,
            iconSize: iconSize,
            isActive: isActive
        })
    });
    if (showComponent === "text") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        onClick: onClick,
        style: {
            cursor: onClick ? "pointer" : undefined
        },
        className: "tw-flex tw-items-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistText, {
            customTextClassName: customTextClassName,
            ctaText: ctaText
        })
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        onClick: onClick,
        style: {
            cursor: onClick ? "pointer" : undefined
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistBoth, {
            color: color,
            iconPosition: iconPosition,
            iconSize: iconSize,
            wrapperClassName: wrapperClassName,
            customTextClassName: customTextClassName,
            ctaText: ctaText,
            isActive: isActive
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WishlistHeaderMenuItem);


/***/ }),

/***/ 692687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _404Page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./src/utils/themeImports.js + 1 modules
var themeImports = __webpack_require__(353978);
// EXTERNAL MODULE: ./src/utils/specificThemeRender.ts
var specificThemeRender = __webpack_require__(698616);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(268037);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
;// CONCATENATED MODULE: ./src/assets/svgExports/SearchIcon404.js


var SearchIcon404 = function(param) {
    var height = param.height, width = param.width;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        viewBox: "0 0 201 200",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4E4E4E",
                fillRule: "evenodd",
                d: "m132.534 99.053-33.146 33.144s11.787-3.681 28.728 2.209c2.85.991 7.618-3.778 6.628-6.628-5.891-16.94-2.21-28.725-2.21-28.725",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#F7F7F7",
                fillRule: "evenodd",
                d: "M43.825 43.488c20.125-20.122 52.797-20.122 72.922 0 20.122 20.124 20.122 52.796 0 72.921-20.125 20.122-52.797 20.122-72.922 0-20.122-20.125-20.122-52.797 0-72.922",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#E9E9E9",
                fillRule: "evenodd",
                d: "M110.081 37.856a52 52 0 0 1 6.666 5.631c20.122 20.125 20.122 52.797 0 72.922-20.125 20.122-52.797 20.122-72.922 0a53 53 0 0 1-3.347-3.681c19.506 6.338 41.8 1.763 57.288-13.725 16.518-16.519 20.625-40.781 12.315-61.147",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#BABABA",
                fillRule: "evenodd",
                d: "M39.406 39.069c22.563-22.563 59.197-22.563 81.76 0 22.562 22.562 22.562 59.197 0 81.759-22.563 22.563-59.197 22.563-81.76 0-22.562-22.562-22.562-59.197 0-81.76m6.628 6.628c18.904-18.903 49.6-18.903 68.504 0 18.903 18.903 18.903 49.6 0 68.503-18.904 18.903-49.6 18.903-68.504 0-18.903-18.903-18.903-49.6 0-68.503",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#BABABA",
                fillRule: "evenodd",
                d: "M28.49 105.656c-10.724-21.622-7.087-48.584 10.916-66.587 16.907-16.906 41.713-21.144 62.585-12.713a74.5 74.5 0 0 1 .09 10.325c-18.16-9.143-40.89-6.137-56.047 9.016-16.065 16.066-18.478 40.65-7.23 59.275-3.295.45-6.657.684-10.07.684z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4E4E4E",
                fillRule: "evenodd",
                d: "M125.584 145.134c-5.49-5.49-5.49-14.393 0-19.887 5.491-5.491 14.397-5.491 19.888 0l45.3 45.3c1.219 1.219-2.247 6.666-7.734 12.153-5.488 5.488-10.935 8.953-12.154 7.734z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#E9E9E9",
                fillRule: "evenodd",
                d: "M125.584 145.134c-5.49-5.49-5.49-14.393 0-19.887 5.491-5.491 14.397-5.491 19.888 0l41 41c1.219 1.219-2.247 6.666-7.734 12.153-5.488 5.488-10.935 8.953-12.154 7.734z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4E4E4E",
                fillRule: "evenodd",
                d: "M73.666 70.11c-.072-2.979 1.047-5.154 2.772-6.429 2.712-2 6.765-1.915 8.965.563.944 1.065 1.49 2.572 1.506 4.478.038 4.572-2.106 7.244-4.206 10.01-2.825 3.727-5.647 7.559-5.997 13.956a3.127 3.127 0 0 0 6.244.34c.263-4.86 2.587-7.69 4.734-10.522 2.875-3.79 5.529-7.572 5.475-13.834-.03-3.681-1.259-6.522-3.084-8.578-4.263-4.8-12.09-5.319-17.347-1.444-3.15 2.325-5.44 6.175-5.312 11.606a3.127 3.127 0 0 0 6.25-.147",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4E4E4E",
                d: "M79.538 107.584a3.844 3.844 0 1 0 0-7.687 3.844 3.844 0 0 0 0 7.687"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4E4E4E",
                fillRule: "evenodd",
                d: "m135.775 26.553 9.375-15.625a3.124 3.124 0 1 0-5.359-3.216l-9.375 15.625a3.125 3.125 0 1 0 5.359 3.216M150.559 36.85l34.375-25a3.13 3.13 0 0 0 .691-4.366 3.13 3.13 0 0 0-4.366-.69l-34.375 25a3.127 3.127 0 0 0 3.675 5.056M155.728 56.103l25-6.25a3.126 3.126 0 1 0-1.515-6.062l-25 6.25a3.124 3.124 0 0 0 1.515 6.063",
                clipRule: "evenodd"
            })
        ]
    });
};
/* harmony default export */ var svgExports_SearchIcon404 = (SearchIcon404);

// EXTERNAL MODULE: ./src/utils/getWindowDimension.js
var getWindowDimension = __webpack_require__(37110);
// EXTERNAL MODULE: ./src/utils/handleRedirectToHomePage.js
var handleRedirectToHomePage = __webpack_require__(254051);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
;// CONCATENATED MODULE: ./src/containers/404Page/ErrorMsg.tsx







var ErrorMsg = function() {
    var store = (0,es/* useSelector */.v9)(function(state) {
        return {
            store: state.storeReducer.store
        };
    }).store;
    var isDesktop = (0,getWindowDimension/* default */.Z)().isDesktop;
    var ref = function() {
        var size = isDesktop ? 200 : 100;
        return {
            height: size,
            width: size
        };
    }(), height = ref.height, width = ref.width;
    var goToHomePage = function() {
        (0,handleRedirectToHomePage/* redirectToHomePage */.A)(routes.PATH.PRODUCT, store === null || store === void 0 ? void 0 : store.domain);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-static tw-flex tw-flex-col tw-bg-white ".concat(isDesktop ? "tw-my-[78px] tw-gap-[60px]" : "tw-my-[138px] tw-gap-[48px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-flex-col tw-items-center ".concat(isDesktop ? "tw-gap-[40px]" : "tw-gap-[32px]"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svgExports_SearchIcon404, {
                        height: height,
                        width: width
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "msg tw-flex tw-flex-col tw-gap-16 tw-text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "tw-font-inter tw-text-[22px]/[32px] tw-font-semibold tw-text-[#000000] md:tw-text-[32px]/[44px] md:tw-font-semibold",
                                children: "Uh oh, this page does not exist."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "tw-font-inter tw-text-[14px] tw-font-normal tw-leading-[22px] tw-text-[#00000099] md:tw-text-[18px]/7",
                                children: [
                                    "You may have mistyped the address or the ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " page may have been removed."
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-flex tw-justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: goToHomePage,
                    className: "tw-mx-auto tw-w-[90%] tw-cursor-pointer tw-rounded-lg tw-border-none tw-bg-[#2B74D8] tw-px-24 tw-py-10 tw-font-inter tw-text-[14px] tw-font-semibold tw-leading-8 tw-text-white md:tw-w-auto md:tw-text-[16px]",
                    children: "Go to home page"
                })
            })
        ]
    });
};
/* harmony default export */ var _404Page_ErrorMsg = (ErrorMsg);

// EXTERNAL MODULE: ./src/utils/ssrCommonApiCall.ts + 1 modules
var ssrCommonApiCall = __webpack_require__(122987);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
;// CONCATENATED MODULE: ./src/containers/404Page/index.tsx









var Error404 = function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var dispatch = (0,es/* useDispatch */.I0)();
    var storeInfo = (0,redux/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer.store;
    });
    (0,react.useEffect)(function() {
        (0,ssrCommonApiCall/* ssrDataCall */.z)([
            "collections",
            "categories",
            "seo"
        ], storeInfo).then(function(data) {
            dispatch((0,catalog/* saveCatalogCategories */.FF)((data === null || data === void 0 ? void 0 : data.catalogCategories) || []));
            dispatch((0,catalog/* saveCollections */.VN)((data === null || data === void 0 ? void 0 : data.collections) || []));
            dispatch((0,catalog/* saveCatalogTags */.Vj)((data === null || data === void 0 ? void 0 : data.catalogTags) || []));
        });
    }, [
        storeInfo
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "ErrorPage_wrapper",
        children: [
            (ref = (0,specificThemeRender/* specificThemeRender */.t)(storeInfo)) === null || ref === void 0 ? void 0 : (ref1 = ref.components) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Header) === null || ref2 === void 0 ? void 0 : ref2.map(function(layout) {
                return (0,themeImports/* getThemeComponent */.s)(layout.sub_type, layout.name, layout);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(_404Page_ErrorMsg, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "EroorPage_body_wrapper",
                children: (ref3 = (0,specificThemeRender/* specificThemeRender */.t)(storeInfo)) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.components) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.Footer) === null || ref5 === void 0 ? void 0 : ref5.map(function(layout) {
                    return (0,themeImports/* getThemeComponent */.s)(layout.sub_type, layout.name, layout);
                })
            })
        ]
    });
};
/* harmony default export */ var _404Page = (Error404);


/***/ }),

/***/ 227172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProductDescription; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(147568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(629815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(197582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(811163);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(505152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-tooltip/dist/index.es.js + 3 modules
var index_es = __webpack_require__(924762);
// EXTERNAL MODULE: ./src/components/ReviewsSection/index.js + 7 modules
var ReviewsSection = __webpack_require__(853724);
// EXTERNAL MODULE: ./src/components/RatingBox/index.js
var RatingBox = __webpack_require__(18468);
// EXTERNAL MODULE: ./src/components/Common/Modal/index.jsx
var Modal = __webpack_require__(672651);
// EXTERNAL MODULE: ./src/components/EmiCardSelection/index.js
var EmiCardSelection = __webpack_require__(628253);
;// CONCATENATED MODULE: ./src/components/EmiModal/index.js




var EmiModal = function(props) {
    (0,react.useEffect)(function() {
        if (props.open) {
            document.getElementsByTagName("body")[0].style.overflowY = "hidden";
        } else {
            document.getElementsByTagName("body")[0].style.overflowY = "";
        }
    }, [
        props.open
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        visible: props.open,
        customStyles: {
            padding: 0,
            maxWidth: 672,
            maxHeight: "600px",
            height: "100%",
            overflowY: "auto"
        },
        animation: "slideUp",
        className: "bottom-modal",
        onClose: props.onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "emiModal",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmiCardSelection/* default */.Z, {})
        })
    });
};
/* harmony default export */ var components_EmiModal = (EmiModal);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(414924);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(186812);
;// CONCATENATED MODULE: ./src/components/BankOfferModal/index.js






var BankOfferModal = function(props) {
    var paymentOffersList = (0,es/* useSelector */.v9)(function(state) {
        return {
            paymentOffersList: state.promoReducer.paymentOffersList
        };
    }).paymentOffersList;
    (0,react.useEffect)(function() {
        if (props.open) {
            document.getElementsByTagName("body")[0].style.overflowY = "hidden";
        } else {
            document.getElementsByTagName("body")[0].style.overflowY = "";
        }
    }, [
        props.open
    ]);
    var ref;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        visible: props.open,
        customStyles: (_obj = {
            padding: 0,
            maxWidth: 672,
            maxHeight: deviceWidth/* deviceWidth */.o <= 766 ? "90vh" : "auto"
        }, (0,_define_property/* default */.Z)(_obj, "maxHeight", "600px"), (0,_define_property/* default */.Z)(_obj, "height", "100%"), (0,_define_property/* default */.Z)(_obj, "overflowY", "auto"), _obj),
        animation: "slideUp",
        className: "bottom-modal",
        onClose: props.onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bankOfferModal",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bankOfferModal__header",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Bank Offer"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bankOfferModal__body",
                    children: (paymentOffersList === null || paymentOffersList === void 0 ? void 0 : paymentOffersList.length) ? paymentOffersList === null || paymentOffersList === void 0 ? void 0 : paymentOffersList.map(function(offer, index) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                            className: "bankOfferModal__list",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                    className: "bankOfferModal__list--header mt0",
                                    children: [
                                        "Offer ",
                                        index + 1
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "bankOfferModal__list--desc mv0",
                                    children: (ref = offer === null || offer === void 0 ? void 0 : offer.description) !== null && ref !== void 0 ? ref : ""
                                })
                            ]
                        }, index);
                    }) : null
                })
            ]
        })
    });
};
/* harmony default export */ var components_BankOfferModal = (BankOfferModal);

// EXTERNAL MODULE: ./src/utils/mutateItemObjectWithCartData.js
var mutateItemObjectWithCartData = __webpack_require__(822787);
// EXTERNAL MODULE: ./src/utils/mutateVariantItemWithCartData.js
var mutateVariantItemWithCartData = __webpack_require__(759186);
// EXTERNAL MODULE: ./src/redux/actions/emi.js
var emi = __webpack_require__(258165);
// EXTERNAL MODULE: ./src/redux/actions/cart.js
var actions_cart = __webpack_require__(666162);
// EXTERNAL MODULE: ./src/redux/actions/storeInfo.js
var actions_storeInfo = __webpack_require__(117321);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var common = __webpack_require__(731024);
// EXTERNAL MODULE: ./src/redux/actions/logs.js
var logs = __webpack_require__(467936);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
// EXTERNAL MODULE: ./src/utils/checkRenderEnv.js
var checkRenderEnv = __webpack_require__(506337);
;// CONCATENATED MODULE: ./src/utils/storeItemClickedDetails.js


function storeItemClickedDetails(itemId) {
    var expiresAt = new Date(new Date().getTime() + constants/* ITEM_CLICKED_DETAIL_EXPIRY_DURATION */.q2);
    var sessionObject = {
        expiresAt: expiresAt,
        itemId: itemId
    };
    if (!checkRenderEnv/* IS_SERVER */.W6) {
        sessionStorage.setItem(constants/* ITEM_CLICKED_DATA */.rB, JSON.stringify(sessionObject));
    }
}

// EXTERNAL MODULE: ./src/utils/selectedVariantFromVariantList.js
var selectedVariantFromVariantList = __webpack_require__(982983);
// EXTERNAL MODULE: ./src/utils/storeGSTStatus.js
var storeGSTStatus = __webpack_require__(541359);
// EXTERNAL MODULE: ./src/utils/isNotifyProductEnabled.js
var isNotifyProductEnabled = __webpack_require__(532953);
// EXTERNAL MODULE: ./src/utils/itemIndexFromCart.js
var itemIndexFromCart = __webpack_require__(648670);
// EXTERNAL MODULE: ./src/utils/checkForLimitedQuantity.js
var checkForLimitedQuantity = __webpack_require__(427994);
// EXTERNAL MODULE: ./src/utils/isStoreServiceBased.js
var isStoreServiceBased = __webpack_require__(666466);
// EXTERNAL MODULE: ./src/utils/getStoreType.js
var getStoreType = __webpack_require__(66871);
// EXTERNAL MODULE: ./src/utils/getItemAmountForPDP.js
var getItemAmountForPDP = __webpack_require__(544990);
// EXTERNAL MODULE: ./src/utils/themeImports.js + 1 modules
var themeImports = __webpack_require__(353978);
// EXTERNAL MODULE: ./src/assets/svgExports/NoStoreInfoIcon.js
var NoStoreInfoIcon = __webpack_require__(519105);
// EXTERNAL MODULE: ./src/utils/checkIfObjectExists.ts
var checkIfObjectExists = __webpack_require__(631891);
// EXTERNAL MODULE: ./src/components/VariantModal/index.js
var VariantModal = __webpack_require__(740261);
// EXTERNAL MODULE: ./src/components/VariantChooseRepeatModal/index.js
var VariantChooseRepeatModal = __webpack_require__(932948);
// EXTERNAL MODULE: ./src/components/VariantSelectedListModal/index.js + 1 modules
var VariantSelectedListModal = __webpack_require__(284557);
// EXTERNAL MODULE: ./src/utils/deviceInfo.js
var deviceInfo = __webpack_require__(990864);
// EXTERNAL MODULE: ./src/config/index.js
var config = __webpack_require__(477733);
// EXTERNAL MODULE: ./src/components/CheckItemDelivery/CheckItemDelivery.js + 1 modules
var CheckItemDelivery = __webpack_require__(825180);
// EXTERNAL MODULE: ./src/components/Common/DetailedDescription/index.js
var DetailedDescription = __webpack_require__(59696);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/ReactToastify.css
var ReactToastify = __webpack_require__(940993);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js + 1 modules
var react_toastify_esm = __webpack_require__(170148);
// EXTERNAL MODULE: ./src/utils/useIsComponentMounted.js
var useIsComponentMounted = __webpack_require__(471778);
;// CONCATENATED MODULE: ./src/utils/getYoutubeId.js
function getYoutubeId(url) {
    var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    var match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
}

// EXTERNAL MODULE: ./src/utils/compressedImagesHelpers.ts
var compressedImagesHelpers = __webpack_require__(940619);
;// CONCATENATED MODULE: ./src/utils/getImageThumbnailUrl.js



function getImageThumbnailUrl(itemImage) {
    var shouldReturnThumbnailImage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    if ((itemImage === null || itemImage === void 0 ? void 0 : itemImage.media_type) === constants/* MEDIA_TYPES.YOUTUBE_VIDEO */.w_.YOUTUBE_VIDEO) return "https://img.youtube.com/vi/".concat(getYoutubeId(itemImage === null || itemImage === void 0 ? void 0 : itemImage.thumbnail_url), "/hqdefault.jpg");
    return shouldReturnThumbnailImage ? itemImage === null || itemImage === void 0 ? void 0 : itemImage.thumbnail_url : (0,compressedImagesHelpers/* getImageUrlFromCompressedImages */.vb)(itemImage === null || itemImage === void 0 ? void 0 : itemImage.compressed_images, (itemImage === null || itemImage === void 0 ? void 0 : itemImage.thumbnail_url) || (itemImage === null || itemImage === void 0 ? void 0 : itemImage.image_url), {
        maxImgSize: (0,compressedImagesHelpers/* getMaxImgSizeForComponent */.N7)(compressedImagesHelpers/* componentTypeEnums.ITEM_THUMBNAIL */.Xx.ITEM_THUMBNAIL)
    });
}

;// CONCATENATED MODULE: ./src/assets/svgExports/PlayIcon.js

function PlayIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: (props === null || props === void 0 ? void 0 : props.width) ? props === null || props === void 0 ? void 0 : props.width : "22",
        height: (props === null || props === void 0 ? void 0 : props.height) ? props === null || props === void 0 ? void 0 : props.height : "22",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "11",
                cy: "11",
                r: "11",
                fill: "black",
                fillOpacity: "0.4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17 10.5L8 15.2631L8 5.73686L17 10.5Z",
                fill: "white"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/assets/svgExports/ShareIcon.js

function ShareIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "18",
        height: "20",
        viewBox: "0 0 18 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M14.5 13.7399C13.8033 13.7399 13.18 14.0149 12.7033 14.4458L6.1675 10.6416C6.21333 10.4308 6.25 10.2199 6.25 9.99992C6.25 9.77992 6.21333 9.56909 6.1675 9.35825L12.63 5.59075C13.125 6.04909 13.7758 6.33325 14.5 6.33325C16.0217 6.33325 17.25 5.10492 17.25 3.58325C17.25 2.06159 16.0217 0.833252 14.5 0.833252C12.9783 0.833252 11.75 2.06159 11.75 3.58325C11.75 3.80325 11.7867 4.01409 11.8325 4.22492L5.37 7.99242C4.875 7.53409 4.22417 7.24992 3.5 7.24992C1.97833 7.24992 0.75 8.47825 0.75 9.99992C0.75 11.5216 1.97833 12.7499 3.5 12.7499C4.22417 12.7499 4.875 12.4658 5.37 12.0074L11.8967 15.8208C11.8508 16.0133 11.8233 16.2149 11.8233 16.4166C11.8233 17.8924 13.0242 19.0933 14.5 19.0933C15.9758 19.0933 17.1767 17.8924 17.1767 16.4166C17.1767 14.9408 15.9758 13.7399 14.5 13.7399ZM14.5 2.66659C15.0042 2.66659 15.4167 3.07909 15.4167 3.58325C15.4167 4.08742 15.0042 4.49992 14.5 4.49992C13.9958 4.49992 13.5833 4.08742 13.5833 3.58325C13.5833 3.07909 13.9958 2.66659 14.5 2.66659ZM3.5 10.9166C2.99583 10.9166 2.58333 10.5041 2.58333 9.99992C2.58333 9.49575 2.99583 9.08325 3.5 9.08325C4.00417 9.08325 4.41667 9.49575 4.41667 9.99992C4.41667 10.5041 4.00417 10.9166 3.5 10.9166ZM14.5 17.3516C13.9958 17.3516 13.5833 16.9391 13.5833 16.4349C13.5833 15.9308 13.9958 15.5183 14.5 15.5183C15.0042 15.5183 15.4167 15.9308 15.4167 16.4349C15.4167 16.9391 15.0042 17.3516 14.5 17.3516Z",
            fill: "#0E0E0E"
        })
    });
}

// EXTERNAL MODULE: ./src/components/ReactSlickCarousel/index.js
var ReactSlickCarousel = __webpack_require__(842783);
;// CONCATENATED MODULE: ./src/hooks/useSetImagesDescriptionModal.js


function useSetImagesDescriptionModal(props) {
    var setInitialImages = function setInitialImages() {
        var ref, ref1;
        var tempImages = [];
        if (productData === null || productData === void 0 ? void 0 : (ref = productData.variants) === null || ref === void 0 ? void 0 : ref.length) {
            var ref2, ref3;
            if ((selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.images) && (selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref2 = selectedVariant.images) === null || ref2 === void 0 ? void 0 : ref2.length)) tempImages = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.images.slice(0, selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref3 = selectedVariant.images) === null || ref3 === void 0 ? void 0 : ref3.length);
        }
        if ((productData === null || productData === void 0 ? void 0 : productData.images) && (productData === null || productData === void 0 ? void 0 : (ref1 = productData.images) === null || ref1 === void 0 ? void 0 : ref1.length)) {
            productData === null || productData === void 0 ? void 0 : productData.images.forEach(function(imageItem) {
                tempImages.push(imageItem);
            });
        }
        if (!(tempImages === null || tempImages === void 0 ? void 0 : tempImages.length)) tempImages.push(constants/* DEFAULT_IMAGE_OBJECT */.M0);
        setImages(tempImages);
    };
    var ref;
    var productData = props.productData, activeIdx = props.activeIdx, showImageDescModal = props.showImageDescModal;
    var ref1 = (0,react.useState)([]), images = ref1[0], setImages = ref1[1];
    var ref2 = (0,react.useState)((productData === null || productData === void 0 ? void 0 : (ref = productData.variants) === null || ref === void 0 ? void 0 : ref[activeIdx]) || []), selectedVariant = ref2[0], setSelectedVariant = ref2[1];
    (0,react.useEffect)(function() {
        var ref;
        setSelectedVariant(productData === null || productData === void 0 ? void 0 : (ref = productData.variants) === null || ref === void 0 ? void 0 : ref[activeIdx]);
    }, [
        activeIdx,
        productData
    ]);
    (0,react.useEffect)(function() {
        setInitialImages();
    }, [
        showImageDescModal,
        selectedVariant,
        productData
    ]);
    return images;
}
/* harmony default export */ var hooks_useSetImagesDescriptionModal = (useSetImagesDescriptionModal);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/DesktopImageComponent/DesktopImageComponent.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  width: max-content;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  position: relative;\n  position: ",
        ";\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: ",
        ";\n  width: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 48px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  margin-bottom: 16px;\n  cursor: pointer;\n  ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  margin-bottom: 16px;\n  cursor: pointer;\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  position: absolute;\n  display: flex;\n  color: white;\n  justify-content: center;\n  align-items: center;\n  background: black;\n  opacity: 0.59;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  position: absolute;\n  width: inherit;\n  height: inherit;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  height: 100%;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 8px;\n  height: 100%;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  cursor: pointer;\n  top: ",
        ";\n  right: 8px;\n  z-index: 999;\n  width: 32px;\n  border-radius: 50%;\n  border: 1px solid #e0e0e0;\n  background: white;\n  height: 32px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* box-shadow:\n    1px 1px 4px 0px rgba(0, 0, 0, 0.12),\n    -1px -1px 4px 0px rgba(0, 0, 0, 0.12); */\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 156px;\n  border-radius: 8px;\n  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.15);\n  background: rgba(255, 255, 255, 1);\n  /* height: 272px; */\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  z-index: 999;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem 0;\n  border-bottom: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 0.75rem;\n  width: 100%;\n  display: flex;\n  gap: 12px;\n  cursor: pointer;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}

var DesktopComponentContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DesktopComponentContainer",
    componentId: "sc-7affb2c9-0"
})(_templateObject());
var DesktopComponentMainImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DesktopComponentMainImageContainer",
    componentId: "sc-7affb2c9-1"
})(_templateObject1(), function(props) {
    return props.isCustomWebsite ? "sticky" : "relative";
});
var DesktopComponentMainVideoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DesktopComponentMainVideoContainer",
    componentId: "sc-7affb2c9-2"
})(_templateObject2(), function(props) {
    var ref, ref1;
    return ((ref = props.imageDimensions) === null || ref === void 0 ? void 0 : ref.height) === "auto" ? "480px" : (ref1 = props.imageDimensions) === null || ref1 === void 0 ? void 0 : ref1.height;
}, function(props) {
    var ref;
    return (ref = props.imageDimensions) === null || ref === void 0 ? void 0 : ref.width;
});
var SideImagePanelContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SideImagePanelContainer",
    componentId: "sc-7affb2c9-3"
})(_templateObject3());
var SidePanelImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    displayName: "SidePanelImage",
    componentId: "sc-7affb2c9-4"
})(_templateObject4(), function(props) {
    var ref;
    return (ref = props.thumbnailImageDimensions) === null || ref === void 0 ? void 0 : ref.width;
}, function(props) {
    var ref;
    return (ref = props.thumbnailImageDimensions) === null || ref === void 0 ? void 0 : ref.height;
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.isSelected) ? "border : 0.6px solid #858585" : "";
});
var SidePanelVideo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SidePanelVideo",
    componentId: "sc-7affb2c9-5"
})(_templateObject5(), function(props) {
    var ref;
    return (ref = props.thumbnailImageDimensions) === null || ref === void 0 ? void 0 : ref.width;
}, function(props) {
    var ref;
    return (ref = props.thumbnailImageDimensions) === null || ref === void 0 ? void 0 : ref.height;
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.isSelected) ? "border : 0.6px solid #858585" : "";
});
var SidePanelLastMaskContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SidePanelLastMaskContainer",
    componentId: "sc-7affb2c9-6"
})(_templateObject6(), function(props) {
    var ref;
    return (ref = props.thumbnailImageDimensions) === null || ref === void 0 ? void 0 : ref.width;
}, function(props) {
    var ref;
    return (ref = props.thumbnailImageDimensions) === null || ref === void 0 ? void 0 : ref.height;
});
var SidePanelLastMask = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SidePanelLastMask",
    componentId: "sc-7affb2c9-7"
})(_templateObject7(), function(props) {
    var ref;
    return (ref = props.thumbnailImageDimensions) === null || ref === void 0 ? void 0 : ref.width;
}, function(props) {
    var ref;
    return (ref = props.thumbnailImageDimensions) === null || ref === void 0 ? void 0 : ref.height;
});
var MainImageVideoIconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MainImageVideoIconContainer",
    componentId: "sc-7affb2c9-8"
})(_templateObject8());
var MagnifyImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MagnifyImageContainer",
    componentId: "sc-7affb2c9-9"
})(_templateObject9());
var ShareActionsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShareActionsContainer",
    componentId: "sc-7affb2c9-10"
})(_templateObject10());
var ShareIconContainer = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "ShareIconContainer",
    componentId: "sc-7affb2c9-11"
})(_templateObject11(), function(props) {
    return props.top ? props.top : "62px";
});
var ShareOptionsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShareOptionsContainer",
    componentId: "sc-7affb2c9-12"
})(_templateObject12());
var SharOptionsBlock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SharOptionsBlock",
    componentId: "sc-7affb2c9-13"
})(_templateObject13(), function(props) {
    return props.lastIdx === 5 ? "0" : "1px solid rgba(0, 0, 0, 0.2)";
});
var SharOptionsSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SharOptionsSection",
    componentId: "sc-7affb2c9-14"
})(_templateObject14());
var PortalContainer = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "PortalContainer",
    componentId: "sc-7affb2c9-15"
})(_templateObject15(), function(param) {
    var portal = param.portal;
    return portal === "Link Copied" ? "rgba(43, 116, 216, 1)" : "black";
});

;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/MobileImageComponent/MobileImageCompnent.styles.js

function MobileImageCompnent_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n"
    ]);
    MobileImageCompnent_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MobileImageCompnent_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  display: flex;\n  width: auto;\n  height: -webkit-fill-available;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    MobileImageCompnent_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var MobilePdpImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    displayName: "MobilePdpImage",
    componentId: "sc-5ae8044e-0"
})(MobileImageCompnent_styles_templateObject(), function(props) {
    return props.width;
}, function(props) {
    return props.height;
});
var MobilePdpPlayIconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MobilePdpPlayIconContainer",
    componentId: "sc-5ae8044e-1"
})(MobileImageCompnent_styles_templateObject1());

;// CONCATENATED MODULE: ./src/utils/generateShareableURLS.js



var generateWhatsAppShareURL = function(textMessage, productURL, utmSource) {
    var baseURL = constants/* SOCIAL_BASE_URL.whatsapp */._1.whatsapp;
    var encodedProductURL = encodeURIComponent(productURL);
    var encodedUTMSource = encodeURIComponent(utmSource);
    var fullURL = "".concat(baseURL, "text=").concat(encodeURIComponent(textMessage), "%20").concat(encodedProductURL, "&source=").concat(encodedUTMSource);
    return fullURL;
};
var generateFacebookShareURL = function(productURL, textMessage, utmSource) {
    var baseURL = constants/* SOCIAL_BASE_URL.facebook */._1.facebook;
    var encodedProductURL = encodeURIComponent(productURL);
    var encodedTextMessage = encodeURIComponent(textMessage);
    var encodedUTMSource = encodeURIComponent(utmSource);
    var fullURL = "".concat(baseURL, "?u=").concat(encodedProductURL, "&p[title]=").concat(encodedTextMessage, "&utm_source=").concat(encodedUTMSource);
    return fullURL;
};
var generateTwitterWebIntentURL = function(productURL, textMessage, utmSource) {
    var baseURL = constants/* SOCIAL_BASE_URL.twitter */._1.twitter;
    var encodedProductURL = encodeURIComponent(productURL);
    var encodedTextMessage = encodeURIComponent(textMessage);
    var encodedUTMSource = encodeURIComponent(utmSource);
    var fullURL = "".concat(baseURL, "?text=").concat(encodedTextMessage, "&url=").concat(encodedProductURL, "&utm_source=").concat(encodedUTMSource);
    return fullURL;
};
var generateTelegramShareLink = function(productURL, textMessage, utmSource) {
    var baseURL = constants/* SOCIAL_BASE_URL.telegram */._1.telegram;
    var encodedProductURL = encodeURIComponent(productURL);
    var encodedTextMessage = encodeURIComponent(textMessage);
    var encodedUTMSource = encodeURIComponent(utmSource);
    var fullURL = "".concat(baseURL, "?text=").concat(encodedTextMessage, "&url=").concat(encodedProductURL, "&utm_source=").concat(encodedUTMSource);
    return fullURL;
};
function fallbackCopyTextToClipboard(text) {
    var customText = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var textArea = document.createElement("textarea");
    textArea.value = text;
    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
        return true;
    } catch (err) {
        return false;
    }
    document.body.removeChild(textArea);
}
function copyTextToClipboard(text, isCopied) {
    return _copyTextToClipboard.apply(this, arguments);
}
function _copyTextToClipboard() {
    _copyTextToClipboard = (0,_async_to_generator/* default */.Z)(function(text, isCopied) {
        var res;
        return (0,tslib_es6.__generator)(this, function(_state) {
            if (!navigator.clipboard) {
                fallbackCopyTextToClipboard(text);
                return [
                    2,
                    false
                ];
            }
            res = navigator.clipboard.writeText(text).then(function() {
                isCopied(true);
            }, function(err) {
                isCopied(false);
            });
            return [
                2,
                res
            ];
        });
    });
    return _copyTextToClipboard.apply(this, arguments);
}

// EXTERNAL MODULE: ./src/components/Common/Toast/index.jsx
var Toast = __webpack_require__(40804);
// EXTERNAL MODULE: ./src/components/ProductMediaRenderer/MediaContainer.tsx
var MediaContainer = __webpack_require__(748577);
// EXTERNAL MODULE: ./src/components/Wishlist/WishlistHeartButton.tsx + 2 modules
var WishlistHeartButton = __webpack_require__(406632);
// EXTERNAL MODULE: ./src/utils/isWishlistUnlockedAndActive.js
var isWishlistUnlockedAndActive = __webpack_require__(291529);
;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/MobileImageComponent/MobileImageComponent.js





















var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true
};
var getSliderStyles = function(aspectRatio, isCustomWebsite) {
    var sliderStyles = {
        width: "100vw",
        // height: 380,
        marginBottom: 16
    };
    // if (aspectRatio > 100 && isCustomWebsite) {
    //   sliderStyles.height = 220;
    // }
    // if (aspectRatio < 100 && isCustomWebsite) {
    //   sliderStyles.height = 674;
    // }
    return sliderStyles;
};
function MobileImageComponent(props) {
    var handleImageClick = function handleImageClick(e, item) {
        props === null || props === void 0 ? void 0 : props.setMainImageIndexFromPdp(images.findIndex(function(imageData) {
            return (imageData === null || imageData === void 0 ? void 0 : imageData.image_url) === (item === null || item === void 0 ? void 0 : item.image_url);
        }));
        handleShowImageDescriptionModal();
    };
    var ref = (0,react.useState)(false), isCopied = ref[0], setIsCopied = ref[1];
    var activeIdx = props.activeIdx, productData = props.productData, handleShowImageDescriptionModal = props.handleShowImageDescriptionModal, showImageDescModal = props.showImageDescModal, handleToggleWishlistClick = props.handleToggleWishlistClick;
    var theme = (0,es/* useSelector */.v9)(function(state) {
        return {
            theme: state.storeReducer.store.theme
        };
    }).theme;
    var carouselRef = (0,react.useRef)(null);
    var images = hooks_useSetImagesDescriptionModal({
        productData: productData,
        activeIdx: activeIdx,
        showImageDescModal: showImageDescModal
    });
    var sliderStyles = getSliderStyles(theme === null || theme === void 0 ? void 0 : theme.product_aspect_ratio, theme === null || theme === void 0 ? void 0 : theme.custom_theme_flag);
    (0,react.useEffect)(function() {
        var ref;
        if ((ref = carouselRef.current) === null || ref === void 0 ? void 0 : ref.slickGoTo) carouselRef.current.slickGoTo(0);
    }, [
        activeIdx
    ]);
    var handleNativeShare = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, contentForSharing, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        contentForSharing = {
                            title: productData === null || productData === void 0 ? void 0 : productData.name,
                            url: window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!navigator.share) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            navigator.share(contentForSharing)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        copyTextToClipboard(window.location.href, setIsCopied);
                        isCopied && (0,Toast/* toastNotifySuccess */.jh)("Link is copied!!");
                        console.warn("Web Share API not supported");
                        _state.label = 4;
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        err = _state.sent();
                        copyTextToClipboard(window.location.href, setIsCopied);
                        isCopied && (0,Toast/* toastNotifySuccess */.jh)("Link is copied!!");
                        console.error("Error Sharing", err);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleNativeShare() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "image",
                content: getImageThumbnailUrl(images[0], false)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactSlickCarousel/* Slider */.i, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                style: sliderStyles
            }, settings), {
                ref: carouselRef,
                children: images.map(function(item) {
                    var imageUrl = item === null || item === void 0 ? void 0 : item.image_url;
                    if ((item === null || item === void 0 ? void 0 : item.media_type) === constants/* MEDIA_TYPES.YOUTUBE_VIDEO */.w_.YOUTUBE_VIDEO) {
                        imageUrl = getImageThumbnailUrl(item);
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MediaContainer/* MediaContainer */.X, {
                            width: "tw-max-h-[480px] tw-max-w-full",
                            children: [
                                (0,isWishlistUnlockedAndActive/* isWishlistUnlockedAndActive */.r)() && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-absolute tw-right-[20px] tw-top-[20px] tw-z-10",
                                    onClick: function(e) {
                                        return handleToggleWishlistClick(e);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WishlistHeartButton/* default */.Z, {
                                        isActive: props === null || props === void 0 ? void 0 : props.isItemWishlisted,
                                        scale: 1.43
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareActionsContainer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareIconContainer, {
                                        onClick: handleNativeShare,
                                        top: (0,isWishlistUnlockedAndActive/* isWishlistUnlockedAndActive */.r)() ? "62px" : "16px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareIcon, {})
                                    })
                                }),
                                (item === null || item === void 0 ? void 0 : item.media_type) !== constants/* MEDIA_TYPES.VIDEO */.w_.VIDEO ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobilePdpImage, {
                                    className: "tw-h-full tw-w-full tw-object-contain",
                                    src: imageUrl,
                                    srcSet: (0,compressedImagesHelpers/* getSrcSetFromCompressedImages */.VW)(item === null || item === void 0 ? void 0 : item.compressed_images, imageUrl, {
                                        minImgSize: compressedImagesHelpers/* imgSizeEnums.HIGH */.Hp.HIGH
                                    }),
                                    alt: "item",
                                    onClick: function(e) {
                                        return handleImageClick(e, item);
                                    }
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (item === null || item === void 0 ? void 0 : item.thumbnail_url) || "",
                                    style: {
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "contain"
                                    }
                                }),
                                ((item === null || item === void 0 ? void 0 : item.media_type) === constants/* MEDIA_TYPES.YOUTUBE_VIDEO */.w_.YOUTUBE_VIDEO || (item === null || item === void 0 ? void 0 : item.media_type) === constants/* MEDIA_TYPES.VIDEO */.w_.VIDEO) && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobilePdpPlayIconContainer, {
                                    onClick: function(e) {
                                        return handleImageClick(e, item);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayIcon, {
                                        width: 64,
                                        height: 64
                                    })
                                })
                            ]
                        })
                    }, item.name);
                })
            }))
        ]
    });
}
/* harmony default export */ var MobileImageComponent_MobileImageComponent = (MobileImageComponent);

// EXTERNAL MODULE: ./node_modules/react-image-magnify/dist/es/ReactImageMagnify.js + 28 modules
var ReactImageMagnify = __webpack_require__(917398);
;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/DesktopImageComponent/constants.js
var SIDE_PANEL_MAX_IMAGE_LIMIT = 4;
var SHARE_OPTIONS = [
    {
        id: 1,
        portal: "Copy Link",
        logo: "https://cdn.dotpe.in/kiranaStatic/custom_website/link_1.svg"
    },
    {
        id: 2,
        portal: "Facebook",
        logo: "https://cdn.dotpe.in/kiranaStatic/custom_website/facebook_1.svg"
    },
    {
        id: 3,
        portal: "Whatsapp",
        logo: "https://cdn.dotpe.in/kiranaStatic/custom_website/whatsapp_1.svg"
    },
    {
        id: 4,
        portal: "Twitter",
        logo: "https://cdn.dotpe.in/kiranaStatic/custom_website/twitter_1.svg"
    },
    {
        id: 5,
        portal: "Telegram",
        logo: "https://cdn.dotpe.in/kiranaStatic/custom_website/telegram_1.svg"
    }, 
];

;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/DesktopImageComponent/utils.js
var getPlayIconPosition = function(aspectRatio, isCustomWebsite) {
    if (isCustomWebsite && aspectRatio < 100) return "30%";
    return "50%";
};
var getImageDimensions = function(aspectRatio) {
    var imageDimensionsObj = {
        width: "480px",
        height: "480px"
    };
    return imageDimensionsObj;
};
var getThumbnailImageDimensions = function(aspectRatio) {
    var imageDimensionsObj = {
        height: "48px",
        width: "48px"
    };
    return imageDimensionsObj;
};
var getEnlargedImageContainerDimensions = function(aspectRatio) {
    var imageDimensionsObj = {
        height: "100%",
        width: "100%"
    };
    return imageDimensionsObj;
};
var getZoomedImageDimension = function(aspectRatio) {
    var imageDimensionsObj = {
        width: 1000,
        height: 1000
    };
    if (aspectRatio > 100) {
        imageDimensionsObj.width = 1000;
        imageDimensionsObj.height = 560;
    }
    if (aspectRatio < 100) {
        imageDimensionsObj.width = 1000;
        imageDimensionsObj.height = 1800;
    }
    return imageDimensionsObj;
};

// EXTERNAL MODULE: ./src/utils/storeSubscriptionConfigs.ts
var storeSubscriptionConfigs = __webpack_require__(114150);
// EXTERNAL MODULE: ./src/redux/store/index.js + 44 modules
var store = __webpack_require__(167261);
;// CONCATENATED MODULE: ./src/utils/isThemeCustomizableForStore.js


var isThemeCustomizableForStore = function() {
    var ref;
    var theme = (ref = store/* default.getState */.Z.getState().storeReducer.store) === null || ref === void 0 ? void 0 : ref.theme;
    var ref1 = (0,storeSubscriptionConfigs/* getWebsiteLiveStatus */.B)(), isNewStoreWebsiteLive = ref1.isNewStoreWebsiteLive, isNewStoreWebsiteInactive = ref1.isNewStoreWebsiteInactive;
    return isNewStoreWebsiteLive || isNewStoreWebsiteInactive || (theme === null || theme === void 0 ? void 0 : theme.custom_theme_flag);
};

;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/DesktopImageComponent/SidePanelImages.tsx







var SidePanelImages = function(param) {
    var sidePanelImages = param.sidePanelImages, thumbnailImageDimensions = param.thumbnailImageDimensions, mainImage = param.mainImage, handleSidePanelViewMore = param.handleSidePanelViewMore, handleSidePanelImage = param.handleSidePanelImage, _returnIndexOnSelect = param.returnIndexOnSelect, returnIndexOnSelect = _returnIndexOnSelect === void 0 ? false : _returnIndexOnSelect;
    var _renderCustomIconOverMedia = function _renderCustomIconOverMedia(index) {
        return showLimitedImages && index === SIDE_PANEL_MAX_IMAGE_LIMIT && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SidePanelLastMask, {
            thumbnailImageDimensions: thumbnailImageDimensions,
            className: "tw-absolute tw-left-1/2 tw-top-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2",
            onClick: handleSidePanelViewMore,
            children: [
                "+ ",
                (sidePanelImages === null || sidePanelImages === void 0 ? void 0 : sidePanelImages.length) - SIDE_PANEL_MAX_IMAGE_LIMIT
            ]
        });
    };
    if (!(sidePanelImages === null || sidePanelImages === void 0 ? void 0 : sidePanelImages.length)) {
        return null;
    }
    var showLimitedImages = !!handleSidePanelViewMore && (sidePanelImages === null || sidePanelImages === void 0 ? void 0 : sidePanelImages.length) > SIDE_PANEL_MAX_IMAGE_LIMIT;
    var showPlayIcon = function(item, index) {
        return ((item === null || item === void 0 ? void 0 : item.media_type) === constants/* MEDIA_TYPES.YOUTUBE_VIDEO */.w_.YOUTUBE_VIDEO || (item === null || item === void 0 ? void 0 : item.media_type) === constants/* MEDIA_TYPES.VIDEO */.w_.VIDEO) && (!showLimitedImages || index !== SIDE_PANEL_MAX_IMAGE_LIMIT);
    };
    var imagesToShow = showLimitedImages ? sidePanelImages.slice(0, SIDE_PANEL_MAX_IMAGE_LIMIT + 1) : sidePanelImages;
    return imagesToShow.map(function(item, index) {
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(MediaContainer/* MediaContainer */.X, {
            width: thumbnailImageDimensions === null || thumbnailImageDimensions === void 0 ? void 0 : thumbnailImageDimensions.width,
            containerClasses: "tw-mb-[16px] tw-cursor-pointer tw-mr-[16px] md:tw-mr-[0px] tw-flex-shrink-0",
            onClick: function() {
                return handleSidePanelImage(returnIndexOnSelect ? index : item);
            },
            isSelected: (mainImage === null || mainImage === void 0 ? void 0 : mainImage.thumbnail_url) === (item === null || item === void 0 ? void 0 : item.thumbnail_url),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: "tw-h-full tw-w-full tw-object-contain",
                    src: getImageThumbnailUrl(item, (item === null || item === void 0 ? void 0 : item.media_type) === constants/* MEDIA_TYPES.VIDEO */.w_.VIDEO)
                }),
                showPlayIcon(item, index) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "tw-absolute tw-left-[50%] tw-top-[50%] tw-flex -tw-translate-x-1/2 -tw-translate-y-1/2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayIcon, {})
                }),
                _renderCustomIconOverMedia(index)
            ]
        }, "".concat(item === null || item === void 0 ? void 0 : item.image_id, "-").concat(index, "-index-side-panel-images"));
    });
};

// EXTERNAL MODULE: ./src/utils/checkClientDeviceType.js
var checkClientDeviceType = __webpack_require__(313508);
;// CONCATENATED MODULE: ./src/containers/ProductDescription/SubComponents/ShareOptions.jsx










var PdpShareOptions = function(param) {
    var productData = param.productData, _showText = param.showText, showText = _showText === void 0 ? false : _showText, _customWrapperClass = param.customWrapperClass, customWrapperClass = _customWrapperClass === void 0 ? "" : _customWrapperClass;
    var shareRef = (0,react.useRef)();
    var ref = (0,react.useState)(false), showAction = ref[0], setShowAction = ref[1];
    var ref1 = (0,react.useState)(false), isCopied = ref1[0], setIsCopied = ref1[1];
    (0,react.useEffect)(function() {
        var handler = function(e) {
            if (shareRef.current && !shareRef.current.contains(e.target)) {
                setShowAction(false);
            }
        };
        document.addEventListener("click", handler);
        return function() {
            document.removeEventListener("click", handler);
        };
    });
    var handleParentEvent = function(e) {
        e.stopPropagation();
    };
    var handleShareButtonAction = function(e) {
        setShowAction(function(state) {
            return !state;
        });
        setIsCopied(false);
    };
    var handleShareOptionAction = function(choice) {
        switch(choice){
            case "Copy Link":
                copyTextToClipboard(window.location.href, setIsCopied);
                break;
            case "Facebook":
                {
                    var url = generateFacebookShareURL(window.location.href, productData === null || productData === void 0 ? void 0 : productData.name, choice);
                    window.open(url);
                }
                break;
            case "Whatsapp":
                {
                    var url1 = generateWhatsAppShareURL(window.location.href, productData === null || productData === void 0 ? void 0 : productData.name, choice);
                    window.open(url1);
                }
                break;
            case "Twitter":
                {
                    var url2 = generateTwitterWebIntentURL(window.location.href, productData === null || productData === void 0 ? void 0 : productData.name, choice);
                    window.open(url2);
                }
                break;
            case "Telegram":
                {
                    var url3 = generateTelegramShareLink(window.location.href, productData === null || productData === void 0 ? void 0 : productData.name, choice);
                    window.open(url3);
                }
            default:
                console.error("Please Select a valid option");
        }
    };
    var handleNativeShare = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, contentForSharing, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        contentForSharing = {
                            title: productData === null || productData === void 0 ? void 0 : productData.name,
                            url: window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!navigator.share) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            navigator.share(contentForSharing)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        copyTextToClipboard(window.location.href, setIsCopied);
                        isCopied && (0,Toast/* toastNotifySuccess */.jh)("Link is copied!!");
                        console.warn("Web Share API not supported");
                        _state.label = 4;
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        err = _state.sent();
                        copyTextToClipboard(window.location.href, setIsCopied);
                        isCopied && (0,Toast/* toastNotifySuccess */.jh)("Link is copied!!");
                        console.error("Error Sharing", err);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleNativeShare() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: shareRef,
        onClick: handleParentEvent,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: checkClientDeviceType/* IS_DESKTOP */.yn ? handleShareButtonAction : handleNativeShare,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex tw-cursor-pointer tw-items-center ".concat(customWrapperClass),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareIcon, {}),
                        showText && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Share"
                        })
                    ]
                })
            }),
            showAction && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareOptionsContainer, {
                    children: SHARE_OPTIONS.map(function(param, idx) {
                        var id = param.id, portal = param.portal, logo = param.logo;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SharOptionsBlock, {
                            lastIdx: idx + 1 === SHARE_OPTIONS.length ? SHARE_OPTIONS.length : "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SharOptionsSection, {
                                onClick: function() {
                                    return handleShareOptionAction(portal);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: logo
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PortalContainer, {
                                        portal: portal === "Copy Link" && isCopied ? "Link Copied" : portal,
                                        children: portal === "Copy Link" && isCopied ? "Link Copied" : portal
                                    })
                                ]
                            })
                        }, id);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var ShareOptions = (PdpShareOptions);

;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/DesktopImageComponent/DesktopImageComponent.js


















function DesktopImageComponent(props) {
    var handleSidePanelViewMore = function handleSidePanelViewMore(e) {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        if ((mainImage === null || mainImage === void 0 ? void 0 : mainImage.image_url) === constants/* DEFAULT_IMAGE_OBJECT.image_url */.M0.image_url) return;
        handleShowImageDescriptionModal();
    };
    var setImagesifVariantNotPresent = function setImagesifVariantNotPresent() {
        var ref;
        if (!(productData === null || productData === void 0 ? void 0 : (ref = productData.images) === null || ref === void 0 ? void 0 : ref.length)) {
            setSidePanelImages([
                constants/* DEFAULT_IMAGE_OBJECT */.M0
            ]);
        } else {
            setSidePanelImages(productData === null || productData === void 0 ? void 0 : productData.images);
        }
    };
    var setImagesifVariantPresent = function setImagesifVariantPresent() {
        var ref;
        if (productData === null || productData === void 0 ? void 0 : (ref = productData.variants) === null || ref === void 0 ? void 0 : ref.length) {
            var ref1;
            var tempImages = !!(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.images) ? selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.images.slice(0, SIDE_PANEL_MAX_IMAGE_LIMIT) : [];
            if ((productData === null || productData === void 0 ? void 0 : productData.images) && (productData === null || productData === void 0 ? void 0 : (ref1 = productData.images) === null || ref1 === void 0 ? void 0 : ref1.length)) {
                var ref2, ref3;
                if (tempImages === null || tempImages === void 0 ? void 0 : tempImages.length) tempImages = tempImages.concat(productData === null || productData === void 0 ? void 0 : productData.images);
                else tempImages = productData === null || productData === void 0 ? void 0 : (ref2 = productData.images) === null || ref2 === void 0 ? void 0 : ref2.slice(0, productData === null || productData === void 0 ? void 0 : (ref3 = productData.images) === null || ref3 === void 0 ? void 0 : ref3.length);
            }
            if (!(tempImages === null || tempImages === void 0 ? void 0 : tempImages.length)) tempImages === null || tempImages === void 0 ? void 0 : tempImages.push(constants/* DEFAULT_IMAGE_OBJECT */.M0);
            setSidePanelImages(tempImages);
        } else {
            var ref4, ref5;
            var tempImages1 = productData === null || productData === void 0 ? void 0 : (ref4 = productData.images) === null || ref4 === void 0 ? void 0 : ref4.slice(0, productData === null || productData === void 0 ? void 0 : (ref5 = productData.images) === null || ref5 === void 0 ? void 0 : ref5.length);
            setSidePanelImages(tempImages1);
        }
    };
    var handleSidePanelImages = function handleSidePanelImages() {
        if (!(productData === null || productData === void 0 ? void 0 : productData.variants_count)) {
            setImagesifVariantNotPresent();
        } else {
            setImagesifVariantPresent();
        }
    };
    var handleSidePanelImage = function handleSidePanelImage(item) {
        if ((item === null || item === void 0 ? void 0 : item.media_type) === constants/* MEDIA_TYPES.YOUTUBE_VIDEO */.w_.YOUTUBE_VIDEO || (item === null || item === void 0 ? void 0 : item.media_type) === constants/* MEDIA_TYPES.VIDEO */.w_.VIDEO) {
            handleShowImageDescriptionModal();
        }
        setMainImage(item);
    };
    var handleMainImageView = function handleMainImageView(item) {
        if ((item === null || item === void 0 ? void 0 : item.media_type) === constants/* MEDIA_TYPES.YOUTUBE_VIDEO */.w_.YOUTUBE_VIDEO) {
            return getImageThumbnailUrl(item);
        }
        return item === null || item === void 0 ? void 0 : item.image_url;
    };
    var ref;
    var ref1 = (0,es/* useSelector */.v9)(function(state) {
        return {
            theme: state.storeReducer.store.theme
        };
    }), _theme = ref1.theme, aspectRatio = _theme.product_aspect_ratio;
    var isAspectRatioAllowed = isThemeCustomizableForStore();
    var imageDimensions = getImageDimensions(aspectRatio, isAspectRatioAllowed);
    var enlargedImageContainerDimensions = getEnlargedImageContainerDimensions(aspectRatio, isAspectRatioAllowed);
    var thumbnailImageDimensions = getThumbnailImageDimensions(aspectRatio, isAspectRatioAllowed);
    var zoomedImageDimensions = getZoomedImageDimension(aspectRatio, isAspectRatioAllowed);
    // const playIconPosition = getPlayIconPosition(aspectRatio, isAspectRatioAllowed);
    var handleShowImageDescriptionModal = props.handleShowImageDescriptionModal, productData = props.productData, activeIdx = props.activeIdx, handleToggleWishlistClick = props.handleToggleWishlistClick;
    var ref2 = (0,react.useState)([]), sidePanelImages = ref2[0], setSidePanelImages = ref2[1];
    var ref3 = (0,react.useState)(), mainImage = ref3[0], setMainImage = ref3[1];
    var ref4 = (0,react.useState)((productData === null || productData === void 0 ? void 0 : (ref = productData.variants) === null || ref === void 0 ? void 0 : ref[activeIdx]) || {}), selectedVariant = ref4[0], setSelectedVariant = ref4[1];
    var imageRef = (0,react.useRef)();
    (0,react.useEffect)(function() {
        handleSidePanelImages();
    }, [
        productData,
        selectedVariant
    ]);
    (0,react.useEffect)(function() {
        !!(sidePanelImages === null || sidePanelImages === void 0 ? void 0 : sidePanelImages.length) && setMainImage(sidePanelImages[0]);
    }, [
        sidePanelImages
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (activeIdx !== -1) setSelectedVariant(productData === null || productData === void 0 ? void 0 : (ref = productData.variants) === null || ref === void 0 ? void 0 : ref[activeIdx]);
    }, [
        activeIdx
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1, ref2;
        (ref1 = imageRef === null || imageRef === void 0 ? void 0 : (ref = imageRef.current) === null || ref === void 0 ? void 0 : ref.getElementsByTagName("img")) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.setAttribute("property", "image");
    }, [
        productData === null || productData === void 0 ? void 0 : productData.name
    ]);
    (0,react.useEffect)(function() {
        props === null || props === void 0 ? void 0 : props.setMainImageIndexFromPdp(sidePanelImages.findIndex(function(item) {
            return (item === null || item === void 0 ? void 0 : item.image_url) === (mainImage === null || mainImage === void 0 ? void 0 : mainImage.image_url);
        }));
    }, [
        mainImage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DesktopComponentContainer, {
        isCustomWebsite: isAspectRatioAllowed,
        className: "tw-mx-auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SideImagePanelContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SidePanelImages, {
                    sidePanelImages: sidePanelImages,
                    thumbnailImageDimensions: thumbnailImageDimensions,
                    mainImage: mainImage,
                    handleSidePanelViewMore: handleSidePanelViewMore,
                    handleSidePanelImage: handleSidePanelImage
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaContainer/* MediaContainer */.X, {
                width: imageDimensions.width,
                containerClasses: "tw-ml-[16px] !tw-overflow-visible",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DesktopComponentMainImageContainer, {
                    ref: imageRef,
                    isCustomWebsite: isAspectRatioAllowed,
                    imageDimensions: imageDimensions,
                    mediaType: mainImage === null || mainImage === void 0 ? void 0 : mainImage.media_type,
                    onClick: handleSidePanelViewMore,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MagnifyImageContainer, {
                            children: [
                                (0,isWishlistUnlockedAndActive/* isWishlistUnlockedAndActive */.r)() && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-absolute tw-right-[20px] tw-top-[20px] tw-z-10 tw-cursor-pointer",
                                    onClick: function(e) {
                                        return handleToggleWishlistClick(e);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WishlistHeartButton/* default */.Z, {
                                        isActive: props === null || props === void 0 ? void 0 : props.isItemWishlisted,
                                        scale: 1.43
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-absolute tw-right-[20px] ".concat((0,isWishlistUnlockedAndActive/* isWishlistUnlockedAndActive */.r)() ? "tw-top-[60px]" : "tw-top-[20px]", " tw-z-10 tw-flex tw-h-[32px] tw-w-[32px] tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-[#E0E0E0] tw-bg-white"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareOptions, {
                                        productData: productData
                                    })
                                }),
                                ((mainImage === null || mainImage === void 0 ? void 0 : mainImage.image_url) || (mainImage === null || mainImage === void 0 ? void 0 : mainImage.thumbnail_url)) && ((mainImage === null || mainImage === void 0 ? void 0 : mainImage.media_type) !== constants/* MEDIA_TYPES.VIDEO */.w_.VIDEO ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactImageMagnify/* default */.Z, {
                                    className: "!tw-h-full !tw-w-full !tw-overflow",
                                    smallImage: {
                                        alt: (mainImage === null || mainImage === void 0 ? void 0 : mainImage.alt_text) || (productData === null || productData === void 0 ? void 0 : productData.name),
                                        src: handleMainImageView(mainImage),
                                        srcSet: (0,compressedImagesHelpers/* getSrcSetFromCompressedImages */.VW)(mainImage === null || mainImage === void 0 ? void 0 : mainImage.compressed_images, handleMainImageView(mainImage)),
                                        isFluidWidth: true
                                    },
                                    largeImage: (0,_object_spread/* default */.Z)({
                                        src: handleMainImageView(mainImage)
                                    }, zoomedImageDimensions),
                                    enlargedImageContainerDimensions: enlargedImageContainerDimensions,
                                    enlargedImageContainerStyle: {
                                        backgroundColor: "#ffffff",
                                        zIndex: 10,
                                        marginLeft: 42,
                                        boxShadow: "0 0 24px rgba(0,0,0,0.34)",
                                        borderRadius: 16,
                                        display: (mainImage === null || mainImage === void 0 ? void 0 : mainImage.image_url) === constants/* DEFAULT_IMAGE_OBJECT.image_url */.M0.image_url ? "none" : ""
                                    },
                                    enlargedImageStyle: {
                                        objectFit: "cover",
                                        maxWidth: 1000,
                                        display: (mainImage === null || mainImage === void 0 ? void 0 : mainImage.image_url) === constants/* DEFAULT_IMAGE_OBJECT.image_url */.M0.image_url ? "none" : ""
                                    },
                                    lensStyle: {
                                        display: (mainImage === null || mainImage === void 0 ? void 0 : mainImage.image_url) === constants/* DEFAULT_IMAGE_OBJECT.image_url */.M0.image_url ? "none" : ""
                                    },
                                    imageClassName: "!tw-object-contain !tw-w-full !tw-h-full",
                                    shouldUsePositiveSpaceLens: true
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: mainImage === null || mainImage === void 0 ? void 0 : mainImage.thumbnail_url,
                                    className: "tw-h-full tw-w-full tw-object-contain"
                                }))
                            ]
                        }),
                        ((mainImage === null || mainImage === void 0 ? void 0 : mainImage.media_type) === constants/* MEDIA_TYPES.YOUTUBE_VIDEO */.w_.YOUTUBE_VIDEO || (mainImage === null || mainImage === void 0 ? void 0 : mainImage.media_type) === constants/* MEDIA_TYPES.VIDEO */.w_.VIDEO) && /*#__PURE__*/ (0,jsx_runtime.jsx)(MainImageVideoIconContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayIcon, {
                                height: 64,
                                width: 64
                            })
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var DesktopImageComponent_DesktopImageComponent = (DesktopImageComponent);

// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.ts
var useFeatureLocks = __webpack_require__(482516);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/index.js + 2 modules
var AtomicComponents = __webpack_require__(438855);
// EXTERNAL MODULE: ./src/components/NotifyProduct/index.js
var NotifyProduct = __webpack_require__(532890);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/util.js
var util = __webpack_require__(452388);
// EXTERNAL MODULE: ./src/utils/getCustomCtaText.js
var getCustomCtaText = __webpack_require__(336623);
;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/PdpCartCta/CartCta.styles.js

function CartCta_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: ",
        ";\n  border: 1px solid ",
        ";\n  padding-top: 12px;\n  padding-bottom: 12px;\n  width: ",
        ";\n  cursor: pointer;\n  color: ",
        ";\n  @media screen and (min-width: ",
        "px) {\n    font-size: 18px;\n  }\n"
    ]);
    CartCta_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CartCta_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100vw;\n  height: 48px;\n  justify-content: center;\n  align-items: center;\n  background: #c6c6c6;\n  position: fixed;\n  bottom: 0%;\n  z-index: 3;\n"
    ]);
    CartCta_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CartCta_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-weight: 600;\n  color: #ffffff;\n"
    ]);
    CartCta_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var ref, ref1, ref2, ref3, ref4;




var storeInfo = store/* default.getState */.Z.getState().storeReducer.store;
var CartCtaDesktopContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CartCtaDesktopContainer",
    componentId: "sc-6646faae-0"
})(CartCta_styles_templateObject(), (0,util/* roundnessCalculator */.M)(storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : ref.roundness), storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.theme) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.colors) === null || ref2 === void 0 ? void 0 : ref2.primary_color, function(props) {
    return props.cartCtaButtonWidth;
}, storeInfo === null || storeInfo === void 0 ? void 0 : (ref3 = storeInfo.theme) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.colors) === null || ref4 === void 0 ? void 0 : ref4.primary_color, constants/* MAX_MOBILE_WIDTH */.Cf);
var MobileOutOfStockContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MobileOutOfStockContainer",
    componentId: "sc-6646faae-1"
})(CartCta_styles_templateObject1());
var MobileOutOfStockText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "MobileOutOfStockText",
    componentId: "sc-6646faae-2"
})(CartCta_styles_templateObject2());

// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicComponents/CartButton/CartButton.styles.js
var CartButton_styles = __webpack_require__(151592);
// EXTERNAL MODULE: ./src/assets/svgExports/MinusIcon.js
var MinusIcon = __webpack_require__(282513);
;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/PdpCartCta/LeftCartButton.js




function LeftCartButton(props) {
    var handleCart = props.handleCart, isPDPPage = props.isPDPPage;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CartButton_styles/* InteractionComponent */.$1, {
        position: "left:14px;",
        width: "30px",
        isPDPPage: isPDPPage,
        onClick: function(e) {
            e.stopPropagation();
            handleCart("dec");
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MinusIcon/* MinusIcon */.V, {
            iconWidth: props === null || props === void 0 ? void 0 : props.iconWidth
        })
    });
}
/* harmony default export */ var PdpCartCta_LeftCartButton = (LeftCartButton);

// EXTERNAL MODULE: ./src/assets/svgExports/PlusIcon.js
var PlusIcon = __webpack_require__(408886);
;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/PdpCartCta/RightCartButton.js




function RightCartButton(props) {
    var handleCart = props.handleCart, disabledAdditionComponent = props.disabledAdditionComponent, isPDPPage = props.isPDPPage;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CartButton_styles/* InteractionComponent */.$1, {
        position: "right:14px;",
        width: "30px",
        isPDPPage: isPDPPage,
        onClick: function(e) {
            e.stopPropagation();
            handleCart("inc");
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: disabledAdditionComponent() ? "o-100" : "o-20",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlusIcon/* PlusIcon */.p, {
                iconWidth: props === null || props === void 0 ? void 0 : props.iconWidth
            })
        })
    });
}
/* harmony default export */ var PdpCartCta_RightCartButton = (RightCartButton);

// EXTERNAL MODULE: ./src/containers/ProductDescription/Utils/common.js
var Utils_common = __webpack_require__(772911);
// EXTERNAL MODULE: ./src/hooks/useCartHandler.js
var useCartHandler = __webpack_require__(491240);
;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/PdpCartCta/CartCtaMobile.js


















function CartCtaMobile(props) {
    var openProductPersonalizationPopUp = /**
   * This function is responsible to perform 3 tasks:
   * 1. Set the active product data in personalisedProduct state of catalogReducer
   * 2. Set the product customization config ( image count, text count etc ) in personalisedProduct state of catalogReducer
   * 3. Open the product personalization popup
   */ function openProductPersonalizationPopUp() {
        handleSetProductData(product);
        handleSetProductCustomizationCount(product);
        onPersonalizeProductClick();
    };
    var handleCartAction = function handleCartAction(type) {
        if (isProductPersonalizationAvailable) {
            type === "inc" ? handleIncreamentClick(type, product) : handleDecreamentClick(type, product);
        } else {
            handleCart(type);
        }
    };
    var renderOutOfStock = function renderOutOfStock() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileOutOfStockContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileOutOfStockText, {
                children: "Out Of Stock"
            })
        });
    };
    var personalizeAndBuyCTA = function personalizeAndBuyCTA() {
        var ref, ref1, ref2, ref3, ref4;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomicComponents/* Button */.zx, {
            borderColor: "#EDEDED",
            borderWidth: "0px",
            label: (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.cta_config) === null || ref1 === void 0 ? void 0 : ref1.pdp_personalized_cta) || "Personalise and buy",
            backgroundColor: storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.theme) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.colors) === null || ref3 === void 0 ? void 0 : ref3.primary_color,
            fontSize: "14px",
            px: "30px",
            py: "15px",
            my: "0",
            mx: "auto",
            className: "!tw-w-[100%] !tw-text-[0.875rem] !tw-font-normal",
            roundness: storeInfo === null || storeInfo === void 0 ? void 0 : (ref4 = storeInfo.theme) === null || ref4 === void 0 ? void 0 : ref4.roundness,
            onClick: function() {
                if (schedualerConstraints && !scheduleInfo) {
                    setShowSchedulerError(true);
                    return;
                }
                handleSetProductData(product);
                handleSetProductCustomizationCount(product);
                onPersonalizeProductClick();
            }
        });
    };
    var ref;
    var handleCart = props.handleCart, goToCart = props.goToCart, itemIndexInCart = props.itemIndexInCart, onBuyNowClick = props.onBuyNowClick, returnItemData = props.returnItemData, disabledAdditionComponent = props.disabledAdditionComponent, variantOutOfStock = props.variantOutOfStock, product = props.product, schedualerConstraints = props.schedualerConstraints, scheduleInfo = props.scheduleInfo, setShowSchedulerError = props.setShowSchedulerError;
    var dispatch = (0,es/* useDispatch */.I0)();
    var isMobile = deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf;
    var storeInfo = (0,es/* useSelector */.v9)(function(state) {
        return {
            storeInfo: state.storeReducer.store
        };
    }).storeInfo;
    var notifyMeFeatureStatus = (0,useFeatureLocks/* useFeatureLocks */.r)().notifyMeFeatureStatus;
    var isNotifyMeFeatureVisible = notifyMeFeatureStatus === null || notifyMeFeatureStatus === void 0 ? void 0 : notifyMeFeatureStatus.isVisible;
    var isComponentMounted = (0,useIsComponentMounted/* default */.Z)();
    var ref1 = (0,useCartHandler/* useCartHandlers */.u)(), handleIncreamentClick = ref1.handleIncreamentClick, handleDecreamentClick = ref1.handleDecreamentClick, handleSetProductData = ref1.handleSetProductData, handleSetProductCustomizationCount = ref1.handleSetProductCustomizationCount, onPersonalizeProductClick = ref1.onPersonalizeProductClick;
    var isProductPersonalizationAvailable = (0,Utils_common/* checkProductPersonalizationExist */.wj)(storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.store_type_flag, product === null || product === void 0 ? void 0 : product.product_personalization);
    if (!isMobile) return null;
    if (isNotifyMeFeatureVisible && (0,isNotifyProductEnabled/* isNotifyProductEnabled */.Z)() && (variantOutOfStock || product.available === 0)) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-pt-3",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NotifyProduct/* default */.Z, {
            product: product
        })
    });
    if (product.available === 0) return renderOutOfStock();
    if (variantOutOfStock) return renderOutOfStock();
    var handleItemChange = function(type) {
        var count = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, reset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
        var selectedProductInfo = returnItemData().selectedItem;
        if (count && (selectedProductInfo === null || selectedProductInfo === void 0 ? void 0 : selectedProductInfo.managed_inventory) && (selectedProductInfo === null || selectedProductInfo === void 0 ? void 0 : selectedProductInfo.available_quantity) < count) {
            dispatch((0,common/* setUnavailableQuantityAlertState */.K6)({
                show: true,
                availableQuantity: selectedProductInfo === null || selectedProductInfo === void 0 ? void 0 : selectedProductInfo.available_quantity,
                onConfirm: function() {
                    return handleCart(type, selectedProductInfo === null || selectedProductInfo === void 0 ? void 0 : selectedProductInfo.available_quantity);
                },
                onCancel: reset
            }));
        } else {
            handleCart(type, count);
        }
    };
    var renderCTA = function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
        if ((storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.store_flag) === 0) {
            return null;
        }
        if (isProductPersonalizationAvailable && itemIndexInCart === -1) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                className: "box--price",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "box--addToCart-btn w-100 flex justify-center items-center",
                    children: [
                        " ",
                        personalizeAndBuyCTA(),
                        " "
                    ]
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
            className: "box--price",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "box--addToCart-btn w-100 flex justify-center items-center",
                children: [
                    itemIndexInCart === -1 && isComponentMounted ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomicComponents/* Button */.zx, {
                        label: "Add to Cart",
                        variant: "outline",
                        borderColor: "#EDEDED",
                        backgroundColor: storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.theme) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.colors) === null || ref2 === void 0 ? void 0 : ref2.primary_color,
                        fontSize: "18",
                        px: "30px",
                        py: "15px",
                        mr: "8px",
                        roundness: storeInfo === null || storeInfo === void 0 ? void 0 : (ref3 = storeInfo.theme) === null || ref3 === void 0 ? void 0 : ref3.roundness,
                        onClick: function() {
                            if (schedualerConstraints && !scheduleInfo) {
                                setShowSchedulerError(true);
                                return;
                            }
                            isProductPersonalizationAvailable ? openProductPersonalizationPopUp() : handleCart("add");
                        }
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomicComponents/* CartButton */.WE, {
                        allowCustomInput: !(product === null || product === void 0 ? void 0 : product.product_personalization),
                        leftButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(PdpCartCta_LeftCartButton, {
                            isPDPPage: true,
                            iconWidth: 14,
                            handleCart: handleCartAction
                        }),
                        rightButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(PdpCartCta_RightCartButton, {
                            isPDPPage: true,
                            disabledAdditionComponent: disabledAdditionComponent,
                            handleCart: handleCartAction,
                            iconWidth: 14
                        }),
                        label: isProductPersonalizationAvailable ? (storeInfo === null || storeInfo === void 0 ? void 0 : (ref4 = storeInfo.theme) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.cta_config) === null || ref5 === void 0 ? void 0 : ref5.pdp_personalized_cta) || "Personalise and buy" : null,
                        fontSize: "14",
                        height: "48px",
                        roundness: storeInfo === null || storeInfo === void 0 ? void 0 : (ref6 = storeInfo.theme) === null || ref6 === void 0 ? void 0 : ref6.roundness,
                        onChange: handleItemChange,
                        quantity: returnItemData().quantity,
                        px: "5px",
                        py: "14px",
                        mr: "8px",
                        customClasses: "!tw-w-full !tw-justify-center",
                        wrapperClasses: " !tw-h-[48px]"
                    }),
                    itemIndexInCart === -1 && isComponentMounted ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomicComponents/* Button */.zx, {
                        borderColor: "#EDEDED",
                        label: (storeInfo === null || storeInfo === void 0 ? void 0 : (ref7 = storeInfo.theme) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.cta_config) === null || ref8 === void 0 ? void 0 : ref8.pdp_cta) || (0,getCustomCtaText/* default */.Z)("buy_now_cta"),
                        backgroundColor: storeInfo === null || storeInfo === void 0 ? void 0 : (ref9 = storeInfo.theme) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.colors) === null || ref10 === void 0 ? void 0 : ref10.primary_color,
                        fontSize: "18",
                        px: "30px",
                        py: "15px",
                        roundness: storeInfo === null || storeInfo === void 0 ? void 0 : (ref11 = storeInfo.theme) === null || ref11 === void 0 ? void 0 : ref11.roundness,
                        onClick: function() {
                            if (schedualerConstraints && !scheduleInfo) {
                                setShowSchedulerError(true);
                                return;
                            }
                            isProductPersonalizationAvailable ? openProductPersonalizationPopUp() : onBuyNowClick();
                        }
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "go-to-cart__btn",
                        style: {
                            borderRadius: "".concat((0,util/* roundnessCalculator */.M)(storeInfo === null || storeInfo === void 0 ? void 0 : (ref12 = storeInfo.theme) === null || ref12 === void 0 ? void 0 : ref12.roundness)),
                            backgroundColor: "".concat(storeInfo === null || storeInfo === void 0 ? void 0 : (ref13 = storeInfo.theme) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.colors) === null || ref14 === void 0 ? void 0 : ref14.primary_color),
                            height: "48px",
                            fontSize: "14px"
                        },
                        onClick: goToCart,
                        children: "Go to Cart"
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: renderCTA()
    });
}
/* harmony default export */ var PdpCartCta_CartCtaMobile = (CartCtaMobile);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(999534);
;// CONCATENATED MODULE: ./src/hooks/useVariantsOutOfVisible.js

function useVariantsOutOfVisible(props) {
    var getVariantHiddenStatus = function getVariantHiddenStatus(status) {
        switch(status){
            case 1:
                return true;
            case 2:
                return false;
        }
    };
    var getItemOptionMapAndAvaialableStatus = function getItemOptionMapAndAvaialableStatus(item) {
        var ref;
        var optionNameVariantNameMap = {};
        var isAvaialble = getVariantHiddenStatus(item === null || item === void 0 ? void 0 : item.status);
        !!((ref = item.option_variant_names) === null || ref === void 0 ? void 0 : ref.length) && item.option_variant_names.forEach(function(optionDetails) {
            optionNameVariantNameMap[optionDetails === null || optionDetails === void 0 ? void 0 : optionDetails.option_name] = optionDetails === null || optionDetails === void 0 ? void 0 : optionDetails.variant_name;
        });
        return {
            optionNameVariantNameMap: optionNameVariantNameMap,
            isAvaialble: isAvaialble
        };
    };
    var setVariantAvaialableStatus = function setVariantAvaialableStatus(optionNameVariantNameMap, isAvaialble) {
        var tempOutOfVisble = outOfVisbleInfo.slice(0, outOfVisbleInfo === null || outOfVisbleInfo === void 0 ? void 0 : outOfVisbleInfo.length);
        switch(itemOptionVariantLengths === null || itemOptionVariantLengths === void 0 ? void 0 : itemOptionVariantLengths.length){
            case 1:
                tempOutOfVisble[variantNameIndexMap[Object.keys(optionNameVariantNameMap)[0]][optionNameVariantNameMap[Object.keys(optionNameVariantNameMap)[0]]]] = isAvaialble;
                break;
            case 2:
                tempOutOfVisble[variantNameIndexMap[Object.keys(optionNameVariantNameMap)[0]][optionNameVariantNameMap[Object.keys(optionNameVariantNameMap)[0]]]][variantNameIndexMap[Object.keys(optionNameVariantNameMap)[1]][optionNameVariantNameMap[Object.keys(optionNameVariantNameMap)[1]]]] = isAvaialble;
                break;
            case 3:
                tempOutOfVisble[variantNameIndexMap[Object.keys(optionNameVariantNameMap)[0]][optionNameVariantNameMap[Object.keys(optionNameVariantNameMap)[0]]]][variantNameIndexMap[Object.keys(optionNameVariantNameMap)[1]][optionNameVariantNameMap[Object.keys(optionNameVariantNameMap)[1]]]][variantNameIndexMap[Object.keys(optionNameVariantNameMap)[2]][optionNameVariantNameMap[Object.keys(optionNameVariantNameMap)[2]]]] = isAvaialble;
                break;
        }
        setOutOfVisbleInfo(tempOutOfVisble);
    };
    var getIndexOneAvalaibleStatus = function getIndexOneAvalaibleStatus(variantName) {
        if ((itemOptionVariantLengths === null || itemOptionVariantLengths === void 0 ? void 0 : itemOptionVariantLengths.length) === 3) {
            var selectedVariants = variantNameIndexMap[Object.keys(variantNameIndexMap)[0]][activeVariantOptions[0]] !== ( false || null) ? outOfVisbleInfo[variantNameIndexMap[Object.keys(variantNameIndexMap)[0]][activeVariantOptions[0]]][variantNameIndexMap[Object.keys(variantNameIndexMap)[1]][variantName]] : [];
            return selectedVariants.find(function(items) {
                return items === true;
            });
        } else if ((itemOptionVariantLengths === null || itemOptionVariantLengths === void 0 ? void 0 : itemOptionVariantLengths.length) === 2) {
            return outOfVisbleInfo[variantNameIndexMap[Object.keys(variantNameIndexMap)[0]][activeVariantOptions[0]]][variantNameIndexMap[Object.keys(variantNameIndexMap)[1]][variantName]];
        }
    };
    var getOneVariantFilterAvailabilty = function getOneVariantFilterAvailabilty(variantName) {
        var variantHiddenStatus = false;
        for(var i = 0; i < (variants === null || variants === void 0 ? void 0 : variants.length); i++){
            var ref;
            for(var j = 0; j < ((ref = variants[i].option_variant_names) === null || ref === void 0 ? void 0 : ref.length); j++){
                if (variants[i].option_variant_names[j].variant_name === variantName) {
                    var ref1;
                    variantHiddenStatus = variantHiddenStatus || getVariantHiddenStatus((ref1 = variants[i]) === null || ref1 === void 0 ? void 0 : ref1.status);
                }
            }
        }
        return variantHiddenStatus;
    };
    var getTwoVariantFilterAvailabilty = function getTwoVariantFilterAvailabilty(variantName, index) {
        switch(index){
            case 1:
                return getIndexOneAvalaibleStatus(variantName);
        }
    };
    var getThreeVariantFilterAvailabilty = function getThreeVariantFilterAvailabilty(variantName, index) {
        return outOfVisbleInfo ? outOfVisbleInfo[variantNameIndexMap[Object.keys(variantNameIndexMap)[0]][activeVariantOptions[0]]][variantNameIndexMap[Object.keys(variantNameIndexMap)[1]][activeVariantOptions[1]]][variantNameIndexMap[Object.keys(variantNameIndexMap)[2]][variantName]] : false;
    };
    var returnIsVariantVisible = function returnIsVariantVisible(variantName, index) {
        switch(index){
            case 0:
                return getOneVariantFilterAvailabilty(variantName, index);
            case 1:
                return getTwoVariantFilterAvailabilty(variantName, index);
            case 2:
                return getThreeVariantFilterAvailabilty(variantName, index);
        }
    };
    var activeIdx = props.activeIdx, item_option_variants = props.item_option_variants, variants = props.variants;
    var ref = (0,react.useState)([]), itemOptionVariantLengths = ref[0], setItemOptionVariantLengths = ref[1];
    var ref1 = (0,react.useState)(), outOfVisbleInfo = ref1[0], setOutOfVisbleInfo = ref1[1];
    var ref2 = (0,react.useState)({}), variantNameIndexMap = ref2[0], setVariantNameIndexMap = ref2[1];
    var ref3 = (0,react.useState)([]), activeVariantOptions = ref3[0], setActiveOptionVariant = ref3[1];
    (0,react.useEffect)(function() {
        var tempItemOptionVariantLengths = [];
        var tempOptionVariantNameIndexMap = {};
        item_option_variants.forEach(function(item) {
            tempItemOptionVariantLengths.push(item[Object.keys(item)[0]].length);
            var tempVariantNameIndexMap = {};
            item[Object.keys(item)[0]].forEach(function(optionsDetails, index) {
                tempVariantNameIndexMap[optionsDetails === null || optionsDetails === void 0 ? void 0 : optionsDetails.variant_name] = index;
            });
            tempOptionVariantNameIndexMap[Object.keys(item)[0]] = tempVariantNameIndexMap;
        });
        setItemOptionVariantLengths(tempItemOptionVariantLengths);
        setVariantNameIndexMap(tempOptionVariantNameIndexMap);
    }, []);
    (0,react.useEffect)(function() {
        variants.forEach(function(item) {
            var ref = getItemOptionMapAndAvaialableStatus(item), optionNameVariantNameMap = ref.optionNameVariantNameMap, isAvaialble = ref.isAvaialble;
            !!(outOfVisbleInfo === null || outOfVisbleInfo === void 0 ? void 0 : outOfVisbleInfo.length) && setVariantAvaialableStatus(optionNameVariantNameMap, isAvaialble);
        });
    }, [
        itemOptionVariantLengths,
        outOfVisbleInfo === null || outOfVisbleInfo === void 0 ? void 0 : outOfVisbleInfo.length
    ]);
    (0,react.useEffect)(function() {
        var ref;
        var tempActiveVariantOptions = [];
        (ref = variants[activeIdx]) === null || ref === void 0 ? void 0 : ref.option_variant_names.forEach(function(item) {
            tempActiveVariantOptions.push(item === null || item === void 0 ? void 0 : item.variant_name);
        });
        setActiveOptionVariant(tempActiveVariantOptions);
    }, [
        itemOptionVariantLengths
    ]);
    (0,react.useEffect)(function() {
        setOutOfVisbleInfo(getInitialOutOfVisbleArray(0));
    }, [
        itemOptionVariantLengths
    ]);
    function getInitialOutOfVisbleArray(ptypeIndex) {
        if (ptypeIndex === (itemOptionVariantLengths === null || itemOptionVariantLengths === void 0 ? void 0 : itemOptionVariantLengths.length) - 1) {
            return Array(itemOptionVariantLengths[ptypeIndex]).fill(0).slice(0, itemOptionVariantLengths[ptypeIndex]);
        } else {
            var rowSize = itemOptionVariantLengths[ptypeIndex];
            var parentArray = [];
            while(rowSize){
                parentArray.push(getInitialOutOfVisbleArray(ptypeIndex + 1));
                rowSize--;
            }
            var length = parentArray.length;
            return parentArray.slice(0, length);
        }
    }
    return {
        returnIsVariantVisible: returnIsVariantVisible,
        setActiveOptionVariant: setActiveOptionVariant,
        activeVariantOptions: activeVariantOptions,
        outOfVisbleInfo: outOfVisbleInfo
    };
}
/* harmony default export */ var hooks_useVariantsOutOfVisible = (useVariantsOutOfVisible);

;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/PdpCartCta/CartCtaDesktop.js

















function CartCtaDesktop(props) {
    var openProductPersonalizationPopUp = /**
   * This function is responsible to perform 3 tasks:
   * 1. Set the active product data in personalisedProduct state of catalogReducer
   * 2. Set the product customization config ( image count, text count etc ) in personalisedProduct state of catalogReducer
   * 3. Open the product personalization popup
   */ function openProductPersonalizationPopUp() {
        handleSetProductData(product);
        handleSetProductCustomizationCount(product);
        onPersonalizeProductClick();
    };
    var handleCartAction = function handleCartAction(type) {
        if (isProductPersonalizationAvailable) {
            if (activeVariant) {
                checkRenderEnv/* IS_CLIENT */.kc && localStorage.setItem("activeVariantId", activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.variant_id);
            }
            type === "inc" ? handleIncreamentClick(type, product) : handleDecreamentClick(type, product);
        } else {
            handleCart(type);
        }
    };
    var renderAddToCart = function renderAddToCart() {
        var ref, ref1, ref2, ref3, ref4;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomicComponents/* Button */.zx, {
            label: "Add to Cart",
            variant: "outline",
            borderColor: storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color,
            backgroundColor: storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.theme) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.colors) === null || ref3 === void 0 ? void 0 : ref3.primary_color,
            fontSize: "18",
            px: "12px",
            py: "12px",
            ml: "22px",
            width: "256px",
            roundness: storeInfo === null || storeInfo === void 0 ? void 0 : (ref4 = storeInfo.theme) === null || ref4 === void 0 ? void 0 : ref4.roundness,
            onClick: function() {
                if (schedualerConstraints && !scheduleInfo) {
                    setShowSchedulerError(true);
                    return;
                }
                isProductPersonalizationAvailable ? openProductPersonalizationPopUp() : handleCart("add");
            }
        });
    };
    var renderBuyNow = function renderBuyNow() {
        var ref, ref1, ref2, ref3, ref4;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomicComponents/* Button */.zx, {
            borderColor: "#EDEDED",
            borderWidth: "0px",
            label: (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.cta_config) === null || ref1 === void 0 ? void 0 : ref1.pdp_cta) || (0,getCustomCtaText/* default */.Z)("buy_now_cta"),
            backgroundColor: storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.theme) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.colors) === null || ref3 === void 0 ? void 0 : ref3.primary_color,
            fontSize: "18",
            px: "12px",
            py: "12px",
            width: "256px",
            roundness: storeInfo === null || storeInfo === void 0 ? void 0 : (ref4 = storeInfo.theme) === null || ref4 === void 0 ? void 0 : ref4.roundness,
            onClick: function() {
                if (schedualerConstraints && !scheduleInfo) {
                    setShowSchedulerError(true);
                    return;
                }
                isProductPersonalizationAvailable ? openProductPersonalizationPopUp() : onBuyNowClick(null, scheduleInfo);
            }
        });
    };
    var personalizeAndBuyCTA = function personalizeAndBuyCTA() {
        var ref, ref1, ref2, ref3, ref4;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-row mt24px w-100",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomicComponents/* Button */.zx, {
                borderColor: "#EDEDED",
                borderWidth: "0px",
                label: (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.cta_config) === null || ref1 === void 0 ? void 0 : ref1.pdp_personalized_cta) || "Personalise and buy",
                backgroundColor: storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.theme) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.colors) === null || ref3 === void 0 ? void 0 : ref3.primary_color,
                fontSize: "18",
                px: "12px",
                py: "12px",
                width: "256px",
                roundness: storeInfo === null || storeInfo === void 0 ? void 0 : (ref4 = storeInfo.theme) === null || ref4 === void 0 ? void 0 : ref4.roundness,
                onClick: function() {
                    if (schedualerConstraints && !scheduleInfo) {
                        setShowSchedulerError(true);
                        return;
                    }
                    openProductPersonalizationPopUp();
                }
            })
        });
    };
    var renderCartMinusQuantityPlus = function renderCartMinusQuantityPlus() {
        var ref, ref1, ref2, ref3, ref4;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomicComponents/* CartButton */.WE, {
            allowCustomInput: !(product === null || product === void 0 ? void 0 : product.product_personalization),
            leftButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(PdpCartCta_LeftCartButton, {
                isPDPPage: isPDPPage,
                iconWidth: 18,
                handleCart: handleCartAction
            }),
            rightButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(PdpCartCta_RightCartButton, {
                disabledAdditionComponent: disabledAdditionComponent,
                handleCart: handleCartAction,
                iconWidth: 18,
                isPDPPage: isPDPPage
            }),
            label: isProductPersonalizationAvailable ? (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.cta_config) === null || ref1 === void 0 ? void 0 : ref1.pdp_personalized_cta) || "Personalise and buy" : null,
            primaryColor: storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.theme) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.colors) === null || ref3 === void 0 ? void 0 : ref3.primary_color,
            fontSize: "18",
            roundness: storeInfo === null || storeInfo === void 0 ? void 0 : (ref4 = storeInfo.theme) === null || ref4 === void 0 ? void 0 : ref4.roundness,
            onChange: handleItemChange,
            quantity: returnItemData().quantity,
            centered: true,
            ml: "22px",
            width: "256px",
            height: "unset",
            isPDPPage: isPDPPage,
            wrapperClasses: "tw-h-full"
        });
    };
    var renderGoToCart = function renderGoToCart() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CartCtaDesktopContainer, {
            onClick: goToCart,
            cartCtaButtonWidth: "256px",
            children: "Go to Cart"
        });
    };
    var renderOutOfStock = function renderOutOfStock() {
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomicComponents/* Button */.zx, {
            label: "Out Of Stock",
            backgroundColor: "#C6C6C6",
            fontSize: "18",
            px: "12px",
            py: "12px",
            mt: "32px",
            width: "100%",
            roundness: storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : ref.roundness
        });
    };
    var ref;
    var handleCart = props.handleCart, goToCart = props.goToCart, itemIndexInCart = props.itemIndexInCart, onBuyNowClick = props.onBuyNowClick, returnItemData = props.returnItemData, disabledAdditionComponent = props.disabledAdditionComponent, variantOutOfStock = props.variantOutOfStock, product = props.product, isPDPPage = props.isPDPPage, activeVariant = props.activeVariant, schedualerConstraints = props.schedualerConstraints, scheduleInfo = props.scheduleInfo, setShowSchedulerError = props.setShowSchedulerError;
    var isMobile = deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf;
    var storeInfo = (0,es/* useSelector */.v9)(function(state) {
        return {
            storeInfo: state.storeReducer.store
        };
    }).storeInfo;
    var dispatch = (0,es/* useDispatch */.I0)();
    var notifyMeFeatureStatus = (0,useFeatureLocks/* useFeatureLocks */.r)().notifyMeFeatureStatus;
    var isNotifyMeFeatureVisible = notifyMeFeatureStatus === null || notifyMeFeatureStatus === void 0 ? void 0 : notifyMeFeatureStatus.isVisible;
    var ref1 = (0,useCartHandler/* useCartHandlers */.u)(), handleIncreamentClick = ref1.handleIncreamentClick, handleDecreamentClick = ref1.handleDecreamentClick, handleSetProductData = ref1.handleSetProductData, handleSetProductCustomizationCount = ref1.handleSetProductCustomizationCount, onPersonalizeProductClick = ref1.onPersonalizeProductClick;
    if (isMobile) return null;
    var isProductPersonalizationAvailable = (0,Utils_common/* checkProductPersonalizationExist */.wj)(storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.store_type_flag, product === null || product === void 0 ? void 0 : product.product_personalization);
    var handleOnChange = function() {
        var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "add", count = arguments.length > 1 ? arguments[1] : void 0;
        return isProductPersonalizationAvailable ? openProductPersonalizationPopUp() : handleCart(type, count);
    };
    var handleItemChange = function(type) {
        var count = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, reset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
        var selectedProductInfo = returnItemData().selectedItem;
        if (count && (selectedProductInfo === null || selectedProductInfo === void 0 ? void 0 : selectedProductInfo.managed_inventory) && (selectedProductInfo === null || selectedProductInfo === void 0 ? void 0 : selectedProductInfo.available_quantity) < count) {
            dispatch((0,common/* setUnavailableQuantityAlertState */.K6)({
                show: true,
                availableQuantity: selectedProductInfo === null || selectedProductInfo === void 0 ? void 0 : selectedProductInfo.available_quantity,
                onConfirm: function() {
                    return handleOnChange(type, selectedProductInfo === null || selectedProductInfo === void 0 ? void 0 : selectedProductInfo.available_quantity);
                },
                onCancel: reset
            }));
        } else {
            handleOnChange(type, count);
        }
    };
    if (isNotifyMeFeatureVisible && (0,isNotifyProductEnabled/* isNotifyProductEnabled */.Z)() && !product.available) return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotifyProduct/* default */.Z, {
        product: product
    });
    if (!product.available) return renderOutOfStock();
    if (variantOutOfStock) return renderOutOfStock();
    var renderCTA = function() {
        var ref;
        if ((storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.store_flag) === 0) {
            return null;
        }
        if (isProductPersonalizationAvailable && itemIndexInCart === -1) {
            return personalizeAndBuyCTA();
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-row w-100 tw-mt-[32px]",
            children: [
                itemIndexInCart === -1 ? renderBuyNow() : renderGoToCart(),
                itemIndexInCart === -1 ? renderAddToCart() : renderCartMinusQuantityPlus()
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: renderCTA()
    });
}
/* harmony default export */ var PdpCartCta_CartCtaDesktop = (CartCtaDesktop);

;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/VariantDescription/VariantDescription.styles.js

function VariantDescription_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  border-top: 1px solid #e9e9e9;\n  border-bottom: 1px solid #e9e9e9;\n  padding-top: 24px;\n"
    ]);
    VariantDescription_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function VariantDescription_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n\n  @media screen and (max-width: ",
        "px) {\n    gap: 24px;\n  }\n"
    ]);
    VariantDescription_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function VariantDescription_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  @media screen and (max-width: ",
        "px) {\n    margin-left: 16px;\n  }\n"
    ]);
    VariantDescription_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function VariantDescription_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  font-weight: 400;\n  font-size: 14px;\n  padding-top: 5px;\n  color: #414141;\n  @media screen and (max-width: ",
        "px) {\n    transform: none;\n  }\n"
    ]);
    VariantDescription_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function VariantDescription_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center;\n\n  @media screen and (max-width: ",
        "px) {\n    margin-top: ",
        ";\n  }\n"
    ]);
    VariantDescription_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function VariantDescription_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-bottom: 24px;\n"
    ]);
    VariantDescription_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function VariantDescription_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 2px;\n  font-weight: 500;\n  color: #000000;\n"
    ]);
    VariantDescription_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var VariantDescriptionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "VariantDescriptionContainer",
    componentId: "sc-5e71a8c4-0"
})(VariantDescription_styles_templateObject());
var VariantGroupsContainer = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "VariantGroupsContainer",
    componentId: "sc-5e71a8c4-1"
})(VariantDescription_styles_templateObject1(), constants/* MAX_MOBILE_WIDTH */.Cf);
var VariantDescriptionFilterContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "VariantDescriptionFilterContainer",
    componentId: "sc-5e71a8c4-2"
})(VariantDescription_styles_templateObject2(), constants/* MAX_MOBILE_WIDTH */.Cf);
var VariantDescriptionFilterHeading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "VariantDescriptionFilterHeading",
    componentId: "sc-5e71a8c4-3"
})(VariantDescription_styles_templateObject3(), constants/* MAX_MOBILE_WIDTH */.Cf);
var VariantDescriptionFilterContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "VariantDescriptionFilterContent",
    componentId: "sc-5e71a8c4-4"
})(VariantDescription_styles_templateObject4(), constants/* MAX_MOBILE_WIDTH */.Cf, function(props) {
    return (props === null || props === void 0 ? void 0 : props.isColor) ? "" : "8px";
});
var VariantDescriptionCartCta = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "VariantDescriptionCartCta",
    componentId: "sc-5e71a8c4-5"
})(VariantDescription_styles_templateObject5());
var ActiveVariantName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "ActiveVariantName",
    componentId: "sc-5e71a8c4-6"
})(VariantDescription_styles_templateObject6());

// EXTERNAL MODULE: ./src/components/ColorVariant/ColorVariant.js + 4 modules
var ColorVariant = __webpack_require__(106541);
;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/VariantTypes/VariantColors/index.js



function VariantColors(props) {
    var ref, ref1;
    var item = props.item, index = props.index, activeVariant = props.activeVariant;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(VariantDescriptionFilterContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(VariantDescriptionFilterHeading, {
                children: [
                    Object.keys(item)[0],
                    ":",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ActiveVariantName, {
                        children: (activeVariant === null || activeVariant === void 0 ? void 0 : (ref = activeVariant.option_variant_names) === null || ref === void 0 ? void 0 : (ref1 = ref[index]) === null || ref1 === void 0 ? void 0 : ref1.variant_name) || ""
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantDescriptionFilterContent, {
                isColor: true,
                children: item[Object.keys(item)[0]].map(function(item_variants) {
                    var ref, ref1, ref2, ref3;
                    return activeVariant && /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorVariant/* default */.Z, {
                        color: item_variants === null || item_variants === void 0 ? void 0 : item_variants.colour_code,
                        isPdp: true,
                        toggleClick: props === null || props === void 0 ? void 0 : props.toggleClick,
                        outOfVisbleInfo: props === null || props === void 0 ? void 0 : props.outOfVisbleInfo,
                        outOfStockInfo: props === null || props === void 0 ? void 0 : props.outOfStockInfo,
                        isSelectedOption: props === null || props === void 0 ? void 0 : props.isSelectedOption,
                        activeVariantOption: props === null || props === void 0 ? void 0 : props.activeVariantOption,
                        handleVariantBtnClick: props === null || props === void 0 ? void 0 : props.handleVariantBtnClick,
                        rowIndex: index,
                        variantName: item_variants === null || item_variants === void 0 ? void 0 : item_variants.variant_name,
                        activeIdx: props === null || props === void 0 ? void 0 : props.activeIdx,
                        returnIsVariantVisible: props === null || props === void 0 ? void 0 : props.returnIsVariantVisible,
                        returnIsVariantAvailable: props === null || props === void 0 ? void 0 : props.returnIsVariantAvailable,
                        themeColor: props === null || props === void 0 ? void 0 : (ref = props.storeInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.theme) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.colors) === null || ref2 === void 0 ? void 0 : ref2.primary_color,
                        storeTheme: props === null || props === void 0 ? void 0 : (ref3 = props.storeInfo) === null || ref3 === void 0 ? void 0 : ref3.theme
                    }, "specific-variant-".concat(item_variants === null || item_variants === void 0 ? void 0 : item_variants.variant_name));
                })
            })
        ]
    }, "variant-category-".concat(Object.keys(item)[0]));
}
/* harmony default export */ var VariantTypes_VariantColors = (VariantColors);

// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/common.js + 9 modules
var utils_common = __webpack_require__(720901);
;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/VariantCta/VariantCta.styles.js

function VariantCta_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 8px 20px;\n  border-radius: ",
        ";\n  border: 1px solid\n    ",
        ";\n  ",
        ";\n  ",
        ";\n  width: fit-content;\n  background: ",
        ";\n  color: ",
        ";\n  margin-right: 14px;\n  margin-top: 10px;\n  cursor: pointer;\n\n  &:hover {\n    border: ",
        ";\n  }\n"
    ]);
    VariantCta_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function VariantCta_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-weight: 400;\n  user-select: none;\n  color: ",
        ";\n"
    ]);
    VariantCta_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var borderColorAttributes = function(isAvailable, isSelected, storeInfo) {
    if (!isAvailable) {
        return isSelected ? "#B2B2B2" : "#F0F0F0";
    } else if (isSelected) {
        var ref, ref1;
        return "".concat(storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color);
    } else {
        return "#D5D5D5";
    }
};
var variantTextColor = function(props) {
    if (!(props === null || props === void 0 ? void 0 : props.isAvailable)) {
        return "#9A9A9A";
    }
    if (props === null || props === void 0 ? void 0 : props.isSelected) {
        var ref, ref1, ref2;
        return props === null || props === void 0 ? void 0 : (ref = props.storeInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.theme) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.colors) === null || ref2 === void 0 ? void 0 : ref2.primary_color;
    }
    return "#000000";
};
var variantBackgroundColor = function(props) {
    if (!(props === null || props === void 0 ? void 0 : props.isAvailable)) {
        return "#F0F0F0";
    }
    if (props === null || props === void 0 ? void 0 : props.isSelected) {
        var ref, ref1, ref2;
        return (0,utils_common/* hexToRgba */.a7)(props === null || props === void 0 ? void 0 : (ref = props.storeInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.theme) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.colors) === null || ref2 === void 0 ? void 0 : ref2.primary_color, 0.05);
    }
    return "#FFFFFF";
};
var hoveredBorderState = function(props) {
    if (!(props === null || props === void 0 ? void 0 : props.isAvailable)) {
        return (props === null || props === void 0 ? void 0 : props.isSelected) ? "1px solid #B2B2B2" : "1px solid #F0F0F0";
    } else if (props.isSelected) {
        var ref, ref1, ref2;
        return "1px solid ".concat(props === null || props === void 0 ? void 0 : (ref = props.storeInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.theme) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.colors) === null || ref2 === void 0 ? void 0 : ref2.primary_color);
    } else {
        var ref3, ref4, ref5;
        return "1px solid ".concat(props === null || props === void 0 ? void 0 : (ref3 = props.storeInfo) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.theme) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.colors) === null || ref5 === void 0 ? void 0 : ref5.primary_color);
    }
};
// Here
var VariantCtaContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "VariantCtaContainer",
    componentId: "sc-41f002c3-0"
})(VariantCta_styles_templateObject(), function(props) {
    var ref, ref1;
    return (0,util/* roundnessCalculator */.M)(props === null || props === void 0 ? void 0 : (ref = props.storeInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.theme) === null || ref1 === void 0 ? void 0 : ref1.roundness);
}, function(props) {
    return borderColorAttributes(props === null || props === void 0 ? void 0 : props.isAvailable, props === null || props === void 0 ? void 0 : props.isSelected, props === null || props === void 0 ? void 0 : props.storeInfo);
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.ml) && "margin-left: ".concat(props.ml);
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.mr) && "margin-right: ".concat(props.mr);
}, function(props) {
    return variantBackgroundColor(props);
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.isSelected) ? "blue" : "#dfdfdf";
}, function(props) {
    return hoveredBorderState(props);
});
var VariantCtaText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "VariantCtaText",
    componentId: "sc-41f002c3-1"
})(VariantCta_styles_templateObject1(), function(props) {
    return variantTextColor(props);
});

;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/VariantCta/VariantCta.js





function VariantCta(props) {
    // checkForLimitedQuantity(product)
    var ref = (0,react.useState)(true), isAvailable = ref[0], setIsAvailable = ref[1];
    var ref1 = (0,react.useState)(false), isSelected = ref1[0], setIsSelected = ref1[1];
    var ref2 = (0,react.useState)(false), isVisible = ref2[0], setIsVisible = ref2[1];
    (0,react.useEffect)(function() {
        setIsVisible(props === null || props === void 0 ? void 0 : props.returnIsVariantVisible(props === null || props === void 0 ? void 0 : props.variantName, props === null || props === void 0 ? void 0 : props.rowIndex));
        setIsAvailable(props === null || props === void 0 ? void 0 : props.returnIsVariantAvailable(props === null || props === void 0 ? void 0 : props.variantName, props === null || props === void 0 ? void 0 : props.rowIndex));
    }, [
        props === null || props === void 0 ? void 0 : props.variantName,
        props === null || props === void 0 ? void 0 : props.rowIndex,
        props === null || props === void 0 ? void 0 : props.outOfVisbleInfo,
        props === null || props === void 0 ? void 0 : props.toggleClick,
        props === null || props === void 0 ? void 0 : props.outOfStockInfo, 
    ]);
    (0,react.useEffect)(function() {
        if ((props === null || props === void 0 ? void 0 : props.variantName) === (props === null || props === void 0 ? void 0 : props.activeVariantOption)) {
            setIsSelected(true);
        } else setIsSelected(false);
    }, [
        props === null || props === void 0 ? void 0 : props.activeVariantOption,
        props === null || props === void 0 ? void 0 : props.toggleClick
    ]);
    var clickHandler = function() {
        props === null || props === void 0 ? void 0 : props.handleVariantBtnClick(props === null || props === void 0 ? void 0 : props.rowIndex, props === null || props === void 0 ? void 0 : props.variantName, isVisible);
    };
    var getTrimmedVariantName = function(variantName) {
        if (variantName.length > 20) {
            return "".concat(variantName.slice(0, 20), "...");
        }
        return variantName;
    };
    if (!isVisible) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantCtaContainer, {
            isAvailable: isAvailable,
            isSelected: isSelected,
            variantName: props === null || props === void 0 ? void 0 : props.variantName,
            onClick: clickHandler,
            storeInfo: props.storeInfo,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantCtaText, {
                storeInfo: props.storeInfo,
                isSelected: isSelected,
                isAvailable: isAvailable,
                children: getTrimmedVariantName(props === null || props === void 0 ? void 0 : props.variantName)
            })
        })
    });
}
/* harmony default export */ var VariantCta_VariantCta = (VariantCta);

;// CONCATENATED MODULE: ./src/assets/svgExports/AddIcon.js

function AddIcon(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M5.16675 6.83342H0.166748V5.16675H5.16675V0.166748H6.83342V5.16675H11.8334V6.83342H6.83342V11.8334H5.16675V6.83342Z",
            fill: color || "#1A7FDC"
        })
    });
}
function AddIcon_MinusIcon(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "12",
        height: "2",
        viewBox: "0 0 12 2",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M0.166626 1.83341V0.166748H11.8333V1.83341H0.166626Z",
            fill: color || "#1A7FDC"
        })
    });
}

;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/VariantTypes/VariantChips/index.js






function VariantChips(props) {
    var renderShowMoreLessCTA = function renderShowMoreLessCTA() {
        var ref, ref1, ref2;
        var themeColor = (props === null || props === void 0 ? void 0 : (ref = props.storeInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.theme) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.colors) === null || ref2 === void 0 ? void 0 : ref2.primary_color) || "#000";
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-mt-[14px] tw-flex tw-cursor-pointer tw-items-center tw-gap-[8px] tw-text-sm tw-font-medium",
            style: {
                color: themeColor
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-items-center tw-gap-[8px]",
                onClick: toggleShowMore,
                children: [
                    !showMore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AddIcon, {
                        color: themeColor
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AddIcon_MinusIcon, {
                        color: themeColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: !showMore ? "View more" : "View less"
                    })
                ]
            })
        });
    };
    var ref, ref1, ref2, ref3, ref4;
    var item = props.item, index = props.index, activeVariant = props.activeVariant;
    var ref5 = (0,react.useState)(false), isOverflowing = ref5[0], setIsOverflowing = ref5[1];
    var ref6 = (0,react.useState)(false), showMore = ref6[0], setShowMore = ref6[1];
    var containerRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        setTimeout(function() {
            var container = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current;
            requestAnimationFrame(function() {
                if ((container === null || container === void 0 ? void 0 : container.scrollHeight) > (container === null || container === void 0 ? void 0 : container.clientHeight)) {
                    setIsOverflowing(true);
                }
            });
        }, 100);
    }, [
        containerRef === null || containerRef === void 0 ? void 0 : (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.scrollHeight,
        containerRef === null || containerRef === void 0 ? void 0 : (ref1 = containerRef.current) === null || ref1 === void 0 ? void 0 : ref1.clientHeight
    ]);
    var toggleShowMore = function() {
        setShowMore(!showMore);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(VariantDescriptionFilterContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantDescriptionFilterHeading, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                Object.keys(item)[0],
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ActiveVariantName, {
                            children: (props === null || props === void 0 ? void 0 : (ref2 = props.activeVariant) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.option_variant_names) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[index]) === null || ref4 === void 0 ? void 0 : ref4.variant_name) || ""
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantDescriptionFilterContent, {
                isColor: false,
                ref: containerRef,
                style: {
                    maxHeight: showMore ? "none" : checkClientDeviceType/* IS_DESKTOP */.yn ? "90px" : "140px",
                    overflow: "hidden",
                    transition: "max-height 0.3s ease-in-out, overflow 0.3s ease-out"
                },
                children: item[Object.keys(item)[0]].map(function(item_variants) {
                    return activeVariant && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantCta_VariantCta, {
                            activeIdx: props === null || props === void 0 ? void 0 : props.activeIdx,
                            toggleClick: props === null || props === void 0 ? void 0 : props.toggleClick,
                            activeVariantOption: props === null || props === void 0 ? void 0 : props.activeVariantOption,
                            activeVariant: props === null || props === void 0 ? void 0 : props.activeVariant,
                            outOfVisbleInfo: props === null || props === void 0 ? void 0 : props.outOfVisbleInfo,
                            outOfStockInfo: props === null || props === void 0 ? void 0 : props.outOfStockInfo,
                            variantName: item_variants === null || item_variants === void 0 ? void 0 : item_variants.variant_name,
                            rowIndex: index,
                            handleVariantBtnClick: props === null || props === void 0 ? void 0 : props.handleVariantBtnClick,
                            returnIsVariantVisible: props === null || props === void 0 ? void 0 : props.returnIsVariantVisible,
                            returnIsVariantAvailable: props === null || props === void 0 ? void 0 : props.returnIsVariantAvailable,
                            storeInfo: props === null || props === void 0 ? void 0 : props.storeInfo
                        }, "specific-variant-".concat(item_variants === null || item_variants === void 0 ? void 0 : item_variants.variant_name))
                    }, "specific-variant-".concat(item_variants === null || item_variants === void 0 ? void 0 : item_variants.variant_name));
                })
            }),
            isOverflowing && renderShowMoreLessCTA()
        ]
    }, "variant-category-".concat(Object.keys(item)[0]));
}
/* harmony default export */ var VariantTypes_VariantChips = (VariantChips);

;// CONCATENATED MODULE: ./src/assets/svgExports/CaratIcon.js

var CaratIcon = function(param) {
    var style = param.style;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "12",
        height: "8",
        viewBox: "0 0 12 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M6 7.4L0 1.4L1.4 0L6 4.6L10.6 0L12 1.4L6 7.4Z",
            fill: "black"
        })
    });
};

;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/Dropdown/index.js



var CustomDropDown = function(props) {
    var getDefaultValue = function getDefaultValue() {
        var selectedOption = menus.find(function(item) {
            return item.value === selected;
        });
        if (!(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.available)) {
            var ref, ref1;
            var trimmedText = (selectedOption === null || selectedOption === void 0 ? void 0 : (ref = selectedOption.text) === null || ref === void 0 ? void 0 : ref.length) > 40 ? "".concat(selectedOption === null || selectedOption === void 0 ? void 0 : (ref1 = selectedOption.text) === null || ref1 === void 0 ? void 0 : ref1.substring(0, 40), "...") : selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.text;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "tw-text-[#999999]",
                children: "".concat(trimmedText, " (Out of stock)")
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.text
        });
    };
    var ref = (0,react.useState)(false), isMenuOpen = ref[0], setIsMenuOpen = ref[1];
    var menus = props.menus, selected = props.selected, onChange = props.onChange, className = props.className, style = props.style;
    var ref1 = (0,react.useState)(false), isDropdownHovered = ref1[0], setIsDropdownHovered = ref1[1];
    var ref2 = (0,react.useState)(null), hoveredIndex = ref2[0], setHoveredIndex = ref2[1];
    var dropdownRef = (0,react.useRef)(null);
    var handleSelect = function(value) {
        onChange({
            target: {
                value: value
            }
        });
        setIsMenuOpen(false);
    };
    var handleClickOutside = function(event) {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsMenuOpen(false);
        }
    };
    (0,react.useEffect)(function() {
        if (isMenuOpen) {
            document.body.style.overflowY = "hidden";
            document.addEventListener("mousedown", handleClickOutside);
            document.body.style.pointerEvents = "none";
            dropdownRef.current.style.pointerEvents = "auto"; // Enable pointer events only for the dropdown
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
            document.body.style.pointerEvents = "auto"; // Re-enable pointer events when dropdown is closed
            document.body.style.overflowY = "scroll";
        }
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
            document.body.style.pointerEvents = "auto";
        };
    }, [
        isMenuOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: dropdownRef,
        className: "tw-max-w-[500px] ".concat(className),
        style: style,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                onClick: function() {
                    return setIsMenuOpen(!isMenuOpen);
                },
                className: "dropdown-header tw-flex tw-cursor-pointer tw-items-center tw-justify-between tw-border tw-border-solid tw-border-[#d5d5d5] tw-px-[16px] tw-py-[11.5px] tw-text-sm tw-font-normal",
                style: {
                    borderRadius: (props === null || props === void 0 ? void 0 : props.borderRadius) || 0,
                    borderColor: isDropdownHovered && !isMenuOpen ? (props === null || props === void 0 ? void 0 : props.storeThemeColor) || "#d5d5d5" : "#d5d5d5"
                },
                onMouseEnter: function() {
                    return setIsDropdownHovered(true);
                },
                onMouseLeave: function() {
                    return setIsDropdownHovered(false);
                },
                children: [
                    getDefaultValue(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CaratIcon, {
                        style: {
                            transform: isMenuOpen ? "rotate(180deg)" : "rotate(0deg)",
                            transition: "transform 0.3s ease"
                        }
                    })
                ]
            }),
            isMenuOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "dropdown-menu tw-absolute tw-z-10 tw-mt-[6px] tw-max-h-[200px] tw-w-full tw-max-w-[500px] tw-overflow-y-auto tw-border tw-border-solid tw-border-[#e9e9e9] tw-bg-white",
                style: {
                    borderRadius: (props === null || props === void 0 ? void 0 : props.borderRadius) !== "0px" ? 12 : 0,
                    boxShadow: "2px 2px 4px 0px #0000001A"
                },
                children: menus.map(function(param, index) {
                    var value = param.value, text = param.text, visible = param.visible, available = param.available;
                    return visible ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: function() {
                            return handleSelect(value);
                        },
                        onMouseEnter: function() {
                            return setHoveredIndex(index);
                        },
                        onMouseLeave: function() {
                            return setHoveredIndex(null);
                        },
                        className: "dropdown-item tw-z-10 tw-px-[16px] tw-py-[11px] tw-text-sm tw-font-normal",
                        style: {
                            borderBottom: index !== menus.length - 1 ? "1px solid #E9E9E9" : "none",
                            color: available ? "#000" : "#999999",
                            backgroundColor: value === selected || index === hoveredIndex ? "#F7F7F7" : "#fff",
                            cursor: available ? "pointer" : "default"
                        },
                        children: text !== null && text !== void 0 ? text : value
                    }, index) : null;
                })
            })
        ]
    });
};
/* harmony default export */ var Dropdown = (CustomDropDown);

;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/VariantOptionModal/index.js


var CrossIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1.86667 13.4168L0.583332 12.1335L5.71667 7.00016L0.583332 1.86683L1.86667 0.583496L7 5.71683L12.1333 0.583496L13.4167 1.86683L8.28333 7.00016L13.4167 12.1335L12.1333 13.4168L7 8.2835L1.86667 13.4168Z",
            fill: "black"
        })
    });
};
var VariantOptionModal = function(param) {
    var activeVariantGroup = param.activeVariantGroup, _variantOptions = param.variantOptions, variantOptions = _variantOptions === void 0 ? [] : _variantOptions, activeVariantOption = param.activeVariantOption, onClose = param.onClose, onClick = param.onClick;
    var Heading = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-flex tw-items-center tw-justify-between tw-border-b tw-border-solid tw-border-[#E9E9E9] tw-p-[16px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "tw-text-sm tw-font-semibold",
                    children: [
                        "Select ",
                        activeVariantGroup
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    onClick: onClose,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CrossIcon, {})
                })
            ]
        });
    };
    var VariantOption = function(param) {
        var variant = param.variant;
        if (!(variant === null || variant === void 0 ? void 0 : variant.visible)) {
            return null;
        }
        var handleVariantClick = function(variantName) {
            onClick(variantName);
            onClose();
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
            className: "tw-border-b tw-border-solid tw-border-[#E9E9E9] tw-p-[16px] tw-font-normal ".concat(!(variant === null || variant === void 0 ? void 0 : variant.available) && "tw-text-[#999]", " ").concat((variant === null || variant === void 0 ? void 0 : variant.value) === activeVariantOption && "tw-bg-[#f7f7f7]"),
            onClick: function() {
                return handleVariantClick(variant === null || variant === void 0 ? void 0 : variant.value);
            },
            children: variant === null || variant === void 0 ? void 0 : variant.value
        });
    };
    var VariantOptionsList = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: "tw-list-none",
            children: variantOptions === null || variantOptions === void 0 ? void 0 : variantOptions.map(function(variant, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantOption, {
                    variant: variant
                }, index);
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        visible: true,
        className: "bottom-modal",
        animation: "slideUp",
        onClose: onClose,
        height: "auto",
        customStyles: {
            padding: 0,
            maxHeight: "400px",
            overflowY: "auto"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantOptionsList, {})
            ]
        })
    });
};
/* harmony default export */ var Components_VariantOptionModal = (VariantOptionModal);

;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/VariantTypes/VariantDropdown/index.js








function VariantDropdown(param) {
    var _item = param.item, item = _item === void 0 ? {} : _item, index = param.index, returnIsVariantVisible = param.returnIsVariantVisible, returnIsVariantAvailable = param.returnIsVariantAvailable, activeVariantOptions = param.activeVariantOptions, handleVariantBtnClick = param.handleVariantBtnClick, storeInfo = param.storeInfo;
    var getSelectedValueForMobile = function getSelectedValueForMobile() {
        var ref, ref1;
        var selectedOption = menus.find(function(item) {
            return item.value === activeVariantOptions[index];
        });
        var maxAllowedLength = (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.available) ? 30 : 20;
        var trimmedText = (selectedOption === null || selectedOption === void 0 ? void 0 : (ref = selectedOption.text) === null || ref === void 0 ? void 0 : ref.length) > maxAllowedLength ? "".concat(selectedOption === null || selectedOption === void 0 ? void 0 : (ref1 = selectedOption.text) === null || ref1 === void 0 ? void 0 : ref1.substring(0, maxAllowedLength), "...") : selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.text;
        if (!(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.available)) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "tw-text-[#999999]",
                children: "".concat(trimmedText, " (Out of stock)")
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: trimmedText
        });
    };
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,react.useState)(false), showVariantOptionModal = ref5[0], setShowVariantOptionModal = ref5[1];
    var activeVariantGroup = item && ((ref = Object.keys(item)) === null || ref === void 0 ? void 0 : ref.length) > 0 ? Object.keys(item)[0] : "";
    var customVariantList = item[activeVariantGroup];
    var menus = customVariantList === null || customVariantList === void 0 ? void 0 : customVariantList.map(function(variant) {
        return {
            value: variant === null || variant === void 0 ? void 0 : variant.variant_name,
            text: variant.variant_name,
            visible: returnIsVariantVisible(variant === null || variant === void 0 ? void 0 : variant.variant_name, index),
            available: returnIsVariantAvailable(variant === null || variant === void 0 ? void 0 : variant.variant_name, index)
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(VariantDescriptionFilterContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantDescriptionFilterHeading, {
                children: activeVariantGroup
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantDescriptionFilterContent, {
                style: {
                    width: "100%",
                    marginTop: "10px"
                },
                children: checkClientDeviceType/* IS_DESKTOP */.yn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown, {
                    menus: menus,
                    selected: activeVariantOptions[index],
                    onChange: function(e) {
                        return handleVariantBtnClick(index, e.target.value, true);
                    },
                    style: {
                        width: "100%",
                        maxHeight: "210px",
                        overflow: "scroll"
                    },
                    borderRadius: (0,util/* roundnessCalculator */.M)(storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.theme) === null || ref1 === void 0 ? void 0 : ref1.roundness),
                    storeThemeColor: storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.theme) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.colors) === null || ref3 === void 0 ? void 0 : ref3.primary_color
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-mr-[16px] tw-flex tw-w-full tw-items-center tw-justify-between tw-border tw-border-solid tw-border-[#D5D5D5] tw-px-[16px] tw-py-[12px] tw-text-sm tw-font-medium",
                    onClick: function() {
                        return setShowVariantOptionModal(true);
                    },
                    style: {
                        borderRadius: (0,util/* roundnessCalculator */.M)(storeInfo === null || storeInfo === void 0 ? void 0 : (ref4 = storeInfo.theme) === null || ref4 === void 0 ? void 0 : ref4.roundness)
                    },
                    children: [
                        getSelectedValueForMobile(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CaratIcon, {
                            style: {
                                transform: showVariantOptionModal ? "rotate(180deg)" : "rotate(0deg)"
                            }
                        })
                    ]
                })
            }),
            showVariantOptionModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_VariantOptionModal, {
                activeVariantGroup: activeVariantGroup,
                variantOptions: menus,
                onClose: function() {
                    return setShowVariantOptionModal(false);
                },
                onClick: function(variantName) {
                    return handleVariantBtnClick(index, variantName, true);
                },
                activeVariantOption: activeVariantOptions[index]
            })
        ]
    }, "variant-category-".concat(activeVariantGroup));
}
/* harmony default export */ var VariantTypes_VariantDropdown = (VariantDropdown);

;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/B2b/B2bProductPriceRange.js

var B2bProductPriceRange = function(param) {
    var storeInfo = param.storeInfo, price_range = param.price_range;
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
        className: "details__box--price",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "details__box--price-container",
            rel: "schema:offers",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    property: "schema:priceCurrency",
                    content: "INR"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "details__box--price-value details__box--price-discounted",
                    style: {
                        color: storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        property: "price",
                        children: price_range || "Pricing on Request"
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/utils/handleB2bCart.js
var handleB2bCart = __webpack_require__(471822);
// EXTERNAL MODULE: ./src/containers/ProductDescription/Components/B2b/B2b.module.scss
var B2b_module = __webpack_require__(206723);
var B2b_module_default = /*#__PURE__*/__webpack_require__.n(B2b_module);
// EXTERNAL MODULE: ./src/containers/ProductDescription/Components/B2b/utils/util.ts + 1 modules
var utils_util = __webpack_require__(337183);
;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/B2b/B2bRequestForQuoteDesktop.js








var B2bRequestForQuoteDesktop = function(param) {
    var storeInfo = param.storeInfo, openRfqFormModal = param.openRfqFormModal, product = param.product, toggleAuthModal = param.toggleAuthModal, _activeVariant = param.activeVariant, activeVariant = _activeVariant === void 0 ? null : _activeVariant;
    var ref, ref1, ref2;
    var isMobile = deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf;
    var userData = (0,es/* useSelector */.v9)(function(state) {
        return {
            userData: state.userReducer
        };
    }).userData;
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleRequestForBtnClick = function() {
        if (!(userData === null || userData === void 0 ? void 0 : userData.isLogin)) {
            toggleAuthModal();
            return;
        } else {
            var ref, ref1;
            (0,handleB2bCart/* handleB2bCart */.h)(product, activeVariant, "ADD", activeVariant ? activeVariant === null || activeVariant === void 0 ? void 0 : (ref = activeVariant.b2b_pricing_info) === null || ref === void 0 ? void 0 : ref.minimum_order_quantity : product === null || product === void 0 ? void 0 : (ref1 = product.b2b_pricing_info) === null || ref1 === void 0 ? void 0 : ref1.minimum_order_quantity);
            dispatch(openRfqFormModal());
        }
    };
    if (isMobile) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (B2b_module_default()).b2bRequestForBtnContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: handleRequestForBtnClick,
            className: (B2b_module_default()).btn,
            style: {
                backgroundColor: storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color,
                borderRadius: (0,util/* roundnessCalculator */.M)(storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.theme) === null || ref2 === void 0 ? void 0 : ref2.roundness)
            },
            children: (0,utils_util/* getB2bRequestQuote */.$)(storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id)
        })
    });
};

// EXTERNAL MODULE: ./src/redux/reducers/index.ts + 19 modules
var reducers = __webpack_require__(950682);
;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/B2b/B2bRequestForQuoteMobile.js









var B2bRequestForQuoteMobile = function(param) {
    var storeInfo = param.storeInfo, openRfqFormModal = param.openRfqFormModal, product = param.product, toggleAuthModal = param.toggleAuthModal, activeVariant = param.activeVariant;
    var ref, ref1, ref2;
    var dispatch = (0,es/* useDispatch */.I0)();
    var isMobile = deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf;
    var userData = (0,reducers/* useSelector */.v)(function(state) {
        return {
            userData: state.userReducer
        };
    }).userData;
    var handleRequestForBtnClick = function() {
        if (!(userData === null || userData === void 0 ? void 0 : userData.isLogin)) {
            toggleAuthModal();
            return;
        } else {
            var ref, ref1;
            (0,handleB2bCart/* handleB2bCart */.h)(product, activeVariant, "ADD", activeVariant ? activeVariant === null || activeVariant === void 0 ? void 0 : (ref = activeVariant.b2b_pricing_info) === null || ref === void 0 ? void 0 : ref.minimum_order_quantity : product === null || product === void 0 ? void 0 : (ref1 = product.b2b_pricing_info) === null || ref1 === void 0 ? void 0 : ref1.minimum_order_quantity);
            dispatch(openRfqFormModal());
        }
    };
    if (!isMobile) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (B2b_module_default()).b2bRequestForQuoteMobileBtn,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: handleRequestForBtnClick,
            className: (B2b_module_default()).btn,
            style: {
                backgroundColor: storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color,
                borderRadius: (0,util/* roundnessCalculator */.M)(storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.theme) === null || ref2 === void 0 ? void 0 : ref2.roundness)
            },
            children: (0,utils_util/* getB2bRequestQuote */.$)(storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id)
        })
    });
};

// EXTERNAL MODULE: ./src/containers/ProductDescription/Components/B2b/B2bRfqFormModal.js + 4 modules
var B2bRfqFormModal = __webpack_require__(329748);
;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/B2b/index.js





// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
;// CONCATENATED MODULE: ./src/hooks/useVariantsAvailabilityStatus.js

function useVariantsAvailabilityStatus(props) {
    var getVariantAvailableStatus = function getVariantAvailableStatus(variantData) {
        return variantData === null || variantData === void 0 ? void 0 : variantData.available;
    };
    var getItemOptionMapAndAvaialableStatus = function getItemOptionMapAndAvaialableStatus(item) {
        var ref;
        var optionNameVariantNameMap = {};
        var isAvaialble = getVariantAvailableStatus(item);
        !!((ref = item.option_variant_names) === null || ref === void 0 ? void 0 : ref.length) && item.option_variant_names.forEach(function(optionDetails) {
            optionNameVariantNameMap[optionDetails === null || optionDetails === void 0 ? void 0 : optionDetails.option_name] = optionDetails === null || optionDetails === void 0 ? void 0 : optionDetails.variant_name;
        });
        return {
            optionNameVariantNameMap: optionNameVariantNameMap,
            isAvaialble: isAvaialble
        };
    };
    var setVariantAvaialableStatus = function setVariantAvaialableStatus(optionNameVariantNameMap, isAvaialble) {
        var tempOutOfVisble = outOfStockInfo.slice(0, outOfStockInfo === null || outOfStockInfo === void 0 ? void 0 : outOfStockInfo.length);
        switch(itemOptionVariantLengths === null || itemOptionVariantLengths === void 0 ? void 0 : itemOptionVariantLengths.length){
            case 1:
                tempOutOfVisble[variantNameIndexMap[Object.keys(optionNameVariantNameMap)[0]][optionNameVariantNameMap[Object.keys(optionNameVariantNameMap)[0]]]] = isAvaialble;
                break;
            case 2:
                tempOutOfVisble[variantNameIndexMap[Object.keys(optionNameVariantNameMap)[0]][optionNameVariantNameMap[Object.keys(optionNameVariantNameMap)[0]]]][variantNameIndexMap[Object.keys(optionNameVariantNameMap)[1]][optionNameVariantNameMap[Object.keys(optionNameVariantNameMap)[1]]]] = isAvaialble;
                break;
            case 3:
                tempOutOfVisble[variantNameIndexMap[Object.keys(optionNameVariantNameMap)[0]][optionNameVariantNameMap[Object.keys(optionNameVariantNameMap)[0]]]][variantNameIndexMap[Object.keys(optionNameVariantNameMap)[1]][optionNameVariantNameMap[Object.keys(optionNameVariantNameMap)[1]]]][variantNameIndexMap[Object.keys(optionNameVariantNameMap)[2]][optionNameVariantNameMap[Object.keys(optionNameVariantNameMap)[2]]]] = isAvaialble;
                break;
        }
        setOutOfStockInfo(tempOutOfVisble);
    };
    var getIndexOneAvalaibleStatus = function getIndexOneAvalaibleStatus(variantName) {
        if ((itemOptionVariantLengths === null || itemOptionVariantLengths === void 0 ? void 0 : itemOptionVariantLengths.length) === 3) {
            var selectedVariants = variantNameIndexMap[Object.keys(variantNameIndexMap)[0]][activeVariantOptions[0]] !== ( false || null) ? outOfStockInfo[variantNameIndexMap[Object.keys(variantNameIndexMap)[0]][activeVariantOptions[0]]][variantNameIndexMap[Object.keys(variantNameIndexMap)[1]][variantName]] : [];
            return selectedVariants.find(function(items) {
                return items === true || items === 1;
            });
        } else if ((itemOptionVariantLengths === null || itemOptionVariantLengths === void 0 ? void 0 : itemOptionVariantLengths.length) === 2) {
            return outOfStockInfo[variantNameIndexMap[Object.keys(variantNameIndexMap)[0]][activeVariantOptions[0]]][variantNameIndexMap[Object.keys(variantNameIndexMap)[1]][variantName]];
        }
    };
    var getOneVariantFilterAvailabilty = function getOneVariantFilterAvailabilty(variantName) {
        var variantOutOfStockStatus = false;
        for(var i = 0; i < (variants === null || variants === void 0 ? void 0 : variants.length); i++){
            var ref;
            for(var j = 0; j < ((ref = variants[i].option_variant_names) === null || ref === void 0 ? void 0 : ref.length); j++){
                if (variants[i].option_variant_names[j].variant_name === variantName) {
                    variantOutOfStockStatus = variantOutOfStockStatus || getVariantAvailableStatus(variants[i]);
                }
            }
        }
        return variantOutOfStockStatus;
    };
    var getTwoVariantFilterAvailabilty = function getTwoVariantFilterAvailabilty(variantName, index) {
        switch(index){
            case 1:
                return getIndexOneAvalaibleStatus(variantName);
        }
    };
    var getThreeVariantFilterAvailabilty = function getThreeVariantFilterAvailabilty(variantName) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        return outOfStockInfo ? (ref4 = outOfStockInfo[(ref1 = variantNameIndexMap[(ref = Object.keys(variantNameIndexMap || {})) === null || ref === void 0 ? void 0 : ref[0]]) === null || ref1 === void 0 ? void 0 : ref1[activeVariantOptions === null || activeVariantOptions === void 0 ? void 0 : activeVariantOptions[0]]]) === null || ref4 === void 0 ? void 0 : (ref7 = ref4[(ref3 = variantNameIndexMap[(ref2 = Object.keys(variantNameIndexMap || {})) === null || ref2 === void 0 ? void 0 : ref2[1]]) === null || ref3 === void 0 ? void 0 : ref3[activeVariantOptions === null || activeVariantOptions === void 0 ? void 0 : activeVariantOptions[1]]]) === null || ref7 === void 0 ? void 0 : ref7[(ref6 = variantNameIndexMap[(ref5 = Object.keys(variantNameIndexMap || {})) === null || ref5 === void 0 ? void 0 : ref5[2]]) === null || ref6 === void 0 ? void 0 : ref6[variantName]] : false;
    };
    var returnIsVariantAvailable = function returnIsVariantAvailable(variantName, index) {
        switch(index){
            case 0:
                return getOneVariantFilterAvailabilty(variantName, index);
            case 1:
                return getTwoVariantFilterAvailabilty(variantName, index);
            case 2:
                return getThreeVariantFilterAvailabilty(variantName, index);
        }
    };
    var activeIdx = props.activeIdx, item_option_variants = props.item_option_variants, variants = props.variants;
    var ref = (0,react.useState)([]), itemOptionVariantLengths = ref[0], setItemOptionVariantLengths = ref[1];
    var ref1 = (0,react.useState)(), outOfStockInfo = ref1[0], setOutOfStockInfo = ref1[1];
    var ref2 = (0,react.useState)({}), variantNameIndexMap = ref2[0], setVariantNameIndexMap = ref2[1];
    var ref3 = (0,react.useState)([]), activeVariantOptions = ref3[0], setActiveVariantOptions = ref3[1];
    (0,react.useEffect)(function() {
        var tempItemOptionVariantLengths = [];
        var tempOptionVariantNameIndexMap = {};
        item_option_variants.forEach(function(item) {
            tempItemOptionVariantLengths.push(item[Object.keys(item)[0]].length);
            var tempVariantNameIndexMap = {};
            item[Object.keys(item)[0]].forEach(function(optionsDetails, index) {
                tempVariantNameIndexMap[optionsDetails === null || optionsDetails === void 0 ? void 0 : optionsDetails.variant_name] = index;
            });
            tempOptionVariantNameIndexMap[Object.keys(item)[0]] = tempVariantNameIndexMap;
        });
        setItemOptionVariantLengths(tempItemOptionVariantLengths);
        setVariantNameIndexMap(tempOptionVariantNameIndexMap);
    }, []);
    (0,react.useEffect)(function() {
        variants.forEach(function(item) {
            var ref = getItemOptionMapAndAvaialableStatus(item), optionNameVariantNameMap = ref.optionNameVariantNameMap, isAvaialble = ref.isAvaialble;
            !!(outOfStockInfo === null || outOfStockInfo === void 0 ? void 0 : outOfStockInfo.length) && setVariantAvaialableStatus(optionNameVariantNameMap, isAvaialble);
        });
    }, [
        itemOptionVariantLengths,
        outOfStockInfo === null || outOfStockInfo === void 0 ? void 0 : outOfStockInfo.length
    ]);
    (0,react.useEffect)(function() {
        var ref;
        var tempActiveVariantOptions = [];
        (ref = variants[activeIdx]) === null || ref === void 0 ? void 0 : ref.option_variant_names.forEach(function(item) {
            tempActiveVariantOptions.push(item === null || item === void 0 ? void 0 : item.variant_name);
        });
        setActiveVariantOptions(tempActiveVariantOptions);
    }, [
        itemOptionVariantLengths
    ]);
    (0,react.useEffect)(function() {
        setOutOfStockInfo(getInitialOutOfStockArray(0));
    }, [
        itemOptionVariantLengths
    ]);
    function getInitialOutOfStockArray(ptypeIndex) {
        if (ptypeIndex === (itemOptionVariantLengths === null || itemOptionVariantLengths === void 0 ? void 0 : itemOptionVariantLengths.length) - 1) {
            return Array(itemOptionVariantLengths[ptypeIndex]).fill(0).slice(0, itemOptionVariantLengths[ptypeIndex]);
        } else {
            var rowSize = itemOptionVariantLengths[ptypeIndex];
            var parentArray = [];
            while(rowSize){
                parentArray.push(getInitialOutOfStockArray(ptypeIndex + 1));
                rowSize--;
            }
            var length = parentArray.length;
            return parentArray.slice(0, length);
        }
    }
    return {
        returnIsVariantAvailable: returnIsVariantAvailable,
        setActiveVariantOptions: setActiveVariantOptions,
        activeVariantOptions: activeVariantOptions,
        outOfStockInfo: outOfStockInfo
    };
}
/* harmony default export */ var hooks_useVariantsAvailabilityStatus = (useVariantsAvailabilityStatus);

// EXTERNAL MODULE: ./src/components/ProductScheduler/index.tsx + 3 modules
var ProductScheduler = __webpack_require__(431937);
// EXTERNAL MODULE: ./src/hooks/useGetDeviceType.tsx
var useGetDeviceType = __webpack_require__(662946);
;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/VariantDescription/VariantDescription.js
/* eslint-disable*/ 






















var COLOR_KEY = "Colour";
function VariantDescription(props) {
    var handleVariantBtnClick = function handleVariantBtnClick(rowIndex, variantName, isAvailable) {
        if (!isAvailable) return;
        var tempActiveVariantOptions = activeVariantOptions.slice(0, activeVariantOptions === null || activeVariantOptions === void 0 ? void 0 : activeVariantOptions.length);
        tempActiveVariantOptions[rowIndex] = variantName;
        var newActiveIdx = 0;
        var selectedItem = {};
        variants.forEach(function(item, parentIndex) {
            var isSame = true;
            item.option_variant_names.forEach(function(itemOptions, index) {
                if (isSame) {
                    if ((itemOptions === null || itemOptions === void 0 ? void 0 : itemOptions.variant_name) !== tempActiveVariantOptions[index]) {
                        isSame = false;
                    }
                }
            });
            if (isSame) {
                selectedItem = item;
                newActiveIdx = parentIndex;
                if (variants[newActiveIdx].status == 2) {
                    newActiveIdx = handleHiddenVariants(rowIndex, variantName, tempActiveVariantOptions);
                }
                setActiveVariantOptions(tempActiveVariantOptions);
                props === null || props === void 0 ? void 0 : props.onVariantSelect(newActiveIdx, selectedItem);
                setActiveOptionVariant(tempActiveVariantOptions);
                setActiveVariant(variants[newActiveIdx]);
                return;
            }
        });
        setToggleClick(!toggleClick);
    };
    var shouldDisplayNotifyMe = function shouldDisplayNotifyMe() {
        return isNotifyMeFeatureVisible && product.available && (0,isNotifyProductEnabled/* isNotifyProductEnabled */.Z)() && (commonCartCtaProps === null || commonCartCtaProps === void 0 ? void 0 : commonCartCtaProps.variantOutOfStock);
    };
    var getCommonProps = function getCommonProps(index) {
        return {
            activeVariant: activeVariant,
            activeIdx: activeIdx,
            toggleClick: toggleClick,
            activeVariantOption: activeVariantOptions[index],
            outOfVisbleInfo: outOfVisbleInfo,
            outOfStockInfo: outOfStockInfo,
            handleVariantBtnClick: handleVariantBtnClick,
            returnIsVariantVisible: returnIsVariantVisible,
            returnIsVariantAvailable: returnIsVariantAvailable,
            storeInfo: props === null || props === void 0 ? void 0 : props.storeInfo,
            isSelectedOption: activeVariantOptions[index]
        };
    };
    var renderVariantTypeDropdown = function renderVariantTypeDropdown() {
        var item = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, index = arguments.length > 1 ? arguments[1] : void 0;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantTypes_VariantDropdown, {
            item: item,
            index: index,
            returnIsVariantVisible: returnIsVariantVisible,
            returnIsVariantAvailable: returnIsVariantAvailable,
            activeVariantOptions: activeVariantOptions,
            handleVariantBtnClick: handleVariantBtnClick,
            storeInfo: props === null || props === void 0 ? void 0 : props.storeInfo
        });
    };
    var renderVariantTypeColor = function renderVariantTypeColor() {
        var item = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, index = arguments.length > 1 ? arguments[1] : void 0;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantTypes_VariantColors, (0,_object_spread/* default */.Z)({
            item: item,
            index: index,
            activeVariant: activeVariant
        }, getCommonProps(index)));
    };
    var renderVariantTypeChip = function renderVariantTypeChip() {
        var item = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, index = arguments.length > 1 ? arguments[1] : void 0;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantTypes_VariantChips, (0,_object_spread/* default */.Z)({
            item: item,
            index: index
        }, getCommonProps(index)));
    };
    var renderVariantOptions = /**
   *
   * @param {*} item
   * @param {*} index
   * @description Renders different type of variant ui as per variants. For color type variant, it renders color blocks, for size chips and for custom variants it renders either dropdown/chip as per mx configuration.
   * @returns JSX
   */ function renderVariantOptions(item, index) {
        var ref;
        var variantOption = Object.keys(item)[0];
        if (variantOption === COLOR_KEY) {
            return renderVariantTypeColor(item, index);
        }
        // If options_show_type for current variantOption is 1, then Dropdown is configured, Chips otherwise
        return !!(product === null || product === void 0 ? void 0 : (ref = product.options_show_type) === null || ref === void 0 ? void 0 : ref[variantOption]) ? renderVariantTypeDropdown(item, index) : renderVariantTypeChip(item, index);
    };
    var ref, ref1;
    var activeIdx = props.activeIdx, product = props.product, schedualerConstraints = props.schedualerConstraints, scheduleInfo = props.scheduleInfo, setScheduleInfo = props.setScheduleInfo, showSchedulerError = props.showSchedulerError, setShowSchedulerError = props.setShowSchedulerError, commonCartCtaProps = (0,_object_without_properties/* default */.Z)(props, [
        "activeIdx",
        "product",
        "schedualerConstraints",
        "scheduleInfo",
        "setScheduleInfo",
        "showSchedulerError",
        "setShowSchedulerError"
    ]);
    if (!(product === null || product === void 0 ? void 0 : (ref = product.item_option_variants) === null || ref === void 0 ? void 0 : ref.length) || !(product === null || product === void 0 ? void 0 : (ref1 = product.variants) === null || ref1 === void 0 ? void 0 : ref1.length)) return null;
    var item_option_variants = product.item_option_variants;
    var variants = product === null || product === void 0 ? void 0 : product.variants;
    var ref2 = (0,react.useState)(), activeVariant = ref2[0], setActiveVariant = ref2[1];
    var ref3 = (0,react.useState)(false), toggleClick = ref3[0], setToggleClick = ref3[1];
    var isMobile = (0,useGetDeviceType/* useGetDeviceType */.n)().isMobile;
    var storeData = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var notifyMeFeatureStatus = (0,useFeatureLocks/* useFeatureLocks */.r)().notifyMeFeatureStatus;
    var isNotifyMeFeatureVisible = notifyMeFeatureStatus === null || notifyMeFeatureStatus === void 0 ? void 0 : notifyMeFeatureStatus.isVisible;
    var ref4 = hooks_useVariantsOutOfVisible({
        activeIdx: activeIdx,
        product: product,
        item_option_variants: item_option_variants,
        variants: variants
    }), returnIsVariantVisible = ref4.returnIsVariantVisible, activeVariantOptions = ref4.activeVariantOptions, setActiveOptionVariant = ref4.setActiveOptionVariant, outOfVisbleInfo = ref4.outOfVisbleInfo;
    var ref5 = hooks_useVariantsAvailabilityStatus({
        activeIdx: activeIdx,
        product: product,
        item_option_variants: item_option_variants,
        variants: variants
    }), setActiveVariantOptions = ref5.setActiveVariantOptions, returnIsVariantAvailable = ref5.returnIsVariantAvailable, outOfStockInfo = ref5.outOfStockInfo;
    (0,react.useEffect)(function() {
        setActiveVariant(variants[activeIdx]);
    }, [
        activeIdx
    ]);
    (0,react.useEffect)(function() {
        checkRenderEnv/* IS_CLIENT */.kc && localStorage.setItem("activeVariantId", activeVariant === null || activeVariant === void 0 ? void 0 : activeVariant.variant_id);
    }, [
        activeVariant
    ]);
    var handleHiddenVariants = function(rowIndex, variantName, tempActiveVariantOptions) {
        var newIndex = 0;
        for(var variantIndex = 0; variantIndex < variants.length; variantIndex++){
            if (variants[variantIndex].status != 2 && variants[variantIndex].option_variant_names[rowIndex].variant_name == variantName && isVariantSameBelowRowIdx(variants[variantIndex], rowIndex, tempActiveVariantOptions)) {
                newIndex = variantIndex;
                break;
            }
        }
        for(var variantOptionIdx = 0; variantOptionIdx < tempActiveVariantOptions.length; variantOptionIdx++){
            tempActiveVariantOptions[variantOptionIdx] = variants[newIndex].option_variant_names[variantOptionIdx].variant_name;
        }
        return newIndex;
    };
    var isVariantSameBelowRowIdx = function(item, rowIdx, tempActiveVariantOptions) {
        var variantOptionIdx = 0;
        while(variantOptionIdx < rowIdx){
            if (item.option_variant_names[variantOptionIdx].variant_name !== tempActiveVariantOptions[variantOptionIdx]) return false;
            variantOptionIdx++;
        }
        return true;
    };
    var renderDesktopCtaButtonAccordingToStoreType = function() {
        if ((0,getStoreType/* getStoreType */.K)(storeData) === constants/* B2B_STORE_TYPE_CONSTANT */.CB) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(B2bRequestForQuoteDesktop, {
                openRfqFormModal: actions_storeInfo/* toggleRfqFormModal */.H4,
                toggleAuthModal: props.toggleAuthModal,
                product: product,
                storeInfo: props.storeInfo,
                activeVariant: activeVariant
            });
        }
        if (shouldDisplayNotifyMe() && !isMobile) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotifyProduct/* default */.Z, {
                product: product,
                activeVariant: activeVariant
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PdpCartCta_CartCtaDesktop, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonCartCtaProps), {
            product: product,
            activeVariant: activeVariant,
            schedualerConstraints: schedualerConstraints,
            scheduleInfo: scheduleInfo,
            setShowSchedulerError: setShowSchedulerError
        }));
    };
    return !!(outOfVisbleInfo === null || outOfVisbleInfo === void 0 ? void 0 : outOfVisbleInfo.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(VariantDescriptionContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(VariantGroupsContainer, {
                children: [
                    item_option_variants === null || item_option_variants === void 0 ? void 0 : item_option_variants.map(function(item, index) {
                        return renderVariantOptions(item, index);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductScheduler/* default */.Z, {
                        schedualerConstraints: schedualerConstraints,
                        showSchedulerError: showSchedulerError,
                        setScheduleInfo: function(data) {
                            setShowSchedulerError(false);
                            setScheduleInfo(data);
                        },
                        scheduleInfo: scheduleInfo,
                        customClasses: "!tw-pt-0"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantDescriptionCartCta, {
                children: renderDesktopCtaButtonAccordingToStoreType()
            })
        ]
    });
}
/* harmony default export */ var VariantDescription_VariantDescription = (VariantDescription);

;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/ImageDescriptionModal/ImageDescriptionModal.styles.js

function ImageDescriptionModal_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  @media screen and (max-width: ",
        "px) {\n    flex-direction: column-reverse;\n    height: 90vh;\n  }\n"
    ]);
    ImageDescriptionModal_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ImageDescriptionModal_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 10vw;\n  height: 600px;\n  flex-wrap: wrap;\n  flex-direction: column;\n  align-items: flex-start;\n  @media screen and (max-width: ",
        "px) {\n    flex-wrap: nowrap;\n    flex-direction: row;\n    height: auto;\n    width: 95vw;\n    overflow: auto;\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n"
    ]);
    ImageDescriptionModal_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ImageDescriptionModal_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 100px;\n  @media screen and (max-width: ",
        "px) {\n    margin-right: 0px;\n  }\n"
    ]);
    ImageDescriptionModal_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ImageDescriptionModal_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n"
    ]);
    ImageDescriptionModal_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ImageDescriptionModal_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n"
    ]);
    ImageDescriptionModal_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ImageDescriptionModal_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-right: 20px;\n  cursor: pointer;\n  @media screen and (max-width: ",
        "px) {\n    position: absolute;\n    left: 0;\n    transform: translateY(-50%);\n  }\n"
    ]);
    ImageDescriptionModal_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ImageDescriptionModal_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-left: 20px;\n  cursor: pointer;\n  > svg {\n    transform-box: fill-box;\n    transform-origin: center;\n    transform: rotate(180deg);\n  }\n  @media screen and (max-width: ",
        "px) {\n    position: absolute;\n    right: 0%;\n    transform: translateY(-50%);\n  }\n"
    ]);
    ImageDescriptionModal_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ImageDescriptionModal_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  cursor: pointer;\n  @media screen and (max-width: ",
        "px) {\n    margin-top: 18px;\n    margin-left: 16px;\n  }\n"
    ]);
    ImageDescriptionModal_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ImageDescriptionModal_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: ",
        ";\n  height: ",
        ";\n  margin-bottom: 16px;\n  ",
        ";\n  cursor: pointer;\n  @media screen and (max-width: ",
        "px) {\n    margin-right: 14px;\n    width: ",
        ";\n    height: ",
        ";\n    flex-shrink: 0;\n  }\n"
    ]);
    ImageDescriptionModal_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function ImageDescriptionModal_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n"
    ]);
    ImageDescriptionModal_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}


var ImageViewContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ImageViewContainer",
    componentId: "sc-bfe97ffc-0"
})(ImageDescriptionModal_styles_templateObject(), constants/* MAX_MOBILE_WIDTH */.Cf);
var ImageViewLeftSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ImageViewLeftSection",
    componentId: "sc-bfe97ffc-1"
})(ImageDescriptionModal_styles_templateObject1(), constants/* MAX_MOBILE_WIDTH */.Cf);
var ImageViewRightSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ImageViewRightSection",
    componentId: "sc-bfe97ffc-2"
})(ImageDescriptionModal_styles_templateObject2(), constants/* MAX_MOBILE_WIDTH */.Cf);
var ImageViewRightSectionImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    displayName: "ImageViewRightSectionImage",
    componentId: "sc-bfe97ffc-3"
})(ImageDescriptionModal_styles_templateObject3());
var VideoViewRightSectionImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "VideoViewRightSectionImage",
    componentId: "sc-bfe97ffc-4"
})(ImageDescriptionModal_styles_templateObject4());
var ImageViewRightSectionPrev = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ImageViewRightSectionPrev",
    componentId: "sc-bfe97ffc-5"
})(ImageDescriptionModal_styles_templateObject5(), constants/* MAX_MOBILE_WIDTH */.Cf);
var ImageViewRightSectionNext = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ImageViewRightSectionNext",
    componentId: "sc-bfe97ffc-6"
})(ImageDescriptionModal_styles_templateObject6(), constants/* MAX_MOBILE_WIDTH */.Cf);
var CloseIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CloseIcon",
    componentId: "sc-bfe97ffc-7"
})(ImageDescriptionModal_styles_templateObject7(), constants/* MAX_MOBILE_WIDTH */.Cf);
var ImageContainerLeftSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ImageContainerLeftSection",
    componentId: "sc-bfe97ffc-8"
})(ImageDescriptionModal_styles_templateObject8(), function(props) {
    var ref;
    return (ref = props.thumbnailImageDimensions) === null || ref === void 0 ? void 0 : ref.width;
}, function(props) {
    var ref;
    return (ref = props.thumbnailImageDimensions) === null || ref === void 0 ? void 0 : ref.height;
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.borderColor) ? "border : 0.6px solid #858585" : "";
}, constants/* MAX_MOBILE_WIDTH */.Cf, function(props) {
    var ref;
    return (ref = props.thumbnailImageDimensions) === null || ref === void 0 ? void 0 : ref.width;
}, function(props) {
    var ref;
    return (ref = props.thumbnailImageDimensions) === null || ref === void 0 ? void 0 : ref.height;
});
var ImageLeftSection = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    displayName: "ImageLeftSection",
    componentId: "sc-bfe97ffc-9"
})(ImageDescriptionModal_styles_templateObject9(), function(props) {
    var ref;
    return (ref = props.thumbnailImageDimensions) === null || ref === void 0 ? void 0 : ref.width;
}, function(props) {
    var ref;
    return (ref = props.thumbnailImageDimensions) === null || ref === void 0 ? void 0 : ref.height;
});

// EXTERNAL MODULE: ./src/assets/svgExports/CloseIconGrey.js
var CloseIconGrey = __webpack_require__(273467);
;// CONCATENATED MODULE: ./src/assets/svgExports/ImageModalBackArrow.js

function ImageModalBackArrow() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18 12H6",
                stroke: "#555555",
                strokeWidth: "1.07143",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 18L6 12L12 6",
                stroke: "#555555",
                strokeWidth: "1.07143",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/assets/svgExports/ImageModalLeftArrow.js

function ImageModalLeftArrow() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "11",
        height: "16",
        viewBox: "0 0 11 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M10.548 1.88L8.66797 0L0.667969 8L8.66797 16L10.548 14.12L4.4413 8L10.548 1.88Z",
            fill: "#797979"
        })
    });
}

;// CONCATENATED MODULE: ./src/assets/svgExports/LeftArrowImageModalMobile.js

function LeftArrowImageModalMobile() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "12",
                fill: "white",
                fillOpacity: "0.8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14 16L10 12L14 8",
                stroke: "#555555",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/ImageDescriptionModal/YouTubeViewer.js



function YouTubeViewer(props) {
    var linkUrl = props.linkUrl;
    var ref = (0,react.useState)(), youtubeUrl = ref[0], setYoutubeUrl = ref[1];
    (0,react.useEffect)(function() {
        var youtubeVideoId = getYoutubeId(linkUrl);
        var youtubeLink = "https://www.youtube.com/embed/".concat(youtubeVideoId);
        setYoutubeUrl(youtubeLink);
    }, [
        linkUrl
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
        width: "100%",
        height: "100%",
        style: {
            objectFit: "contain"
        },
        src: youtubeUrl,
        title: "YouTube video player",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
        allowFullScreen: true
    });
}
/* harmony default export */ var ImageDescriptionModal_YouTubeViewer = (YouTubeViewer);

// EXTERNAL MODULE: ./node_modules/react-zoom-pan-pinch/dist/index.esm.js
var index_esm = __webpack_require__(226126);
;// CONCATENATED MODULE: ./src/components/ImagePinchZoom/index.jsx






var PinchZoomContainer = /*#__PURE__*/ (0,react.forwardRef)(function PinchZoomContainer(_param, ref) {
    var _imageDimensions = _param.imageDimensions, imageDimensions = _imageDimensions === void 0 ? {
        width: "100%",
        height: "100%"
    } : _imageDimensions, _minScale = _param.minScale, minScale = _minScale === void 0 ? 1 : _minScale, _maxScale = _param.maxScale, maxScale = _maxScale === void 0 ? 4 : _maxScale, _doubleTapScale = _param.doubleTapScale, doubleTapScale = _doubleTapScale === void 0 ? 2 : _doubleTapScale, _resetKey = _param.resetKey, resetKey = _resetKey === void 0 ? null : _resetKey, className = _param.className, _style = _param.style, style = _style === void 0 ? {} : _style, children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "imageDimensions",
        "minScale",
        "maxScale",
        "doubleTapScale",
        "resetKey",
        "className",
        "style",
        "children"
    ]);
    var transformApiRef = (0,react.useRef)(null);
    // for mobile double-tap detection
    var lastTapTimeRef = (0,react.useRef)(0);
    var lastTapPosRef = (0,react.useRef)({
        x: 0,
        y: 0
    });
    (0,react.useEffect)(function() {
        var _$ref;
        if ((_$ref = transformApiRef.current) === null || _$ref === void 0 ? void 0 : _$ref.resetTransform) {
            transformApiRef.current.resetTransform();
        }
    }, [
        resetKey
    ]);
    (0,react.useImperativeHandle)(ref, function() {
        return {
            reset: function() {
                var _$ref;
                return (_$ref = transformApiRef.current) === null || _$ref === void 0 ? void 0 : _$ref.resetTransform();
            },
            zoomIn: function() {
                var step = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
                var _$ref;
                return (_$ref = transformApiRef.current) === null || _$ref === void 0 ? void 0 : _$ref.zoomIn(step);
            },
            zoomOut: function() {
                var step = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
                var _$ref;
                return (_$ref = transformApiRef.current) === null || _$ref === void 0 ? void 0 : _$ref.zoomOut(step);
            },
            getApi: function() {
                return transformApiRef.current;
            }
        };
    }, []);
    var normalizeDim = function(v) {
        return typeof v === "number" ? "".concat(v, "px") : v || "auto";
    };
    var wrapperStyle = (0,_object_spread/* default */.Z)({
        touchAction: "none",
        width: normalizeDim(imageDimensions.width),
        height: normalizeDim(imageDimensions.height),
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden"
    }, style);
    var contentStyle = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "auto",
        height: "auto"
    };
    var toggleZoom = function() {
        var api = transformApiRef.current;
        if (!(api === null || api === void 0 ? void 0 : api.instance)) return;
        var scale = api.instance.transformState.scale;
        if (scale > 1) api.resetTransform(); // zoom out to 1x
        else api.zoomIn(doubleTapScale); // zoom in by step
    };
    var handleTouchEnd = function(e) {
        // Only consider single-finger taps (not pinches)
        if (e.changedTouches.length !== 1) return;
        var t = e.changedTouches[0];
        var now = Date.now();
        var dt = now - lastTapTimeRef.current;
        // distance threshold (to filter drags) ~20px
        var dx = t.clientX - lastTapPosRef.current.x;
        var dy = t.clientY - lastTapPosRef.current.y;
        var dist2 = dx * dx + dy * dy;
        if (dt < 300 && dist2 < 400) {
            // 300ms + ~20px
            toggleZoom(); // double tap detected
            lastTapTimeRef.current = 0; // reset
        } else {
            lastTapTimeRef.current = now;
            lastTapPosRef.current = {
                x: t.clientX,
                y: t.clientY
            };
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* TransformWrapper */.d$, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onInit: function(api) {
            transformApiRef.current = api;
        },
        initialScale: 1,
        minScale: minScale,
        maxScale: maxScale,
        centerOnInit: false,
        limitToBounds: true,
        pinch: {
            disabled: false,
            step: 5
        },
        doubleClick: {
            disabled: true
        },
        wheel: {
            disabled: true
        },
        wrapperStyle: wrapperStyle,
        contentStyle: contentStyle,
        className: className
    }, rest), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* TransformComponent */.Uv, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "".concat(imageDimensions.width),
                    height: "".concat(imageDimensions.height),
                    pointerEvents: "auto"
                },
                onDoubleClick: toggleZoom,
                onTouchEnd: handleTouchEnd,
                children: children /* tip: set pointerEvents:'none' on the <img> itself if needed */ 
            })
        })
    }), resetKey);
});
/* harmony default export */ var ImagePinchZoom = (PinchZoomContainer);

;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/ImageDescriptionModal/ImageDescriptionModal.js




















var SCROLL_ACTION = {
    NEXT: "NEXT",
    PREV: "PREV"
};
var getImageDimensionsAccordingToAspectRatio = function(isMobile, aspectRatio) {
    if (isMobile) {
        var imageDimensionsObj = {
            height: "360px",
            width: "100vw"
        };
        if (aspectRatio > 100) {
            imageDimensionsObj.width = "100vw";
            imageDimensionsObj.height = "202px";
        }
        if (aspectRatio < 100) {
            imageDimensionsObj.width = "202px";
            imageDimensionsObj.height = "360px";
        }
        return imageDimensionsObj;
    }
    var imageDimensionsObj1 = {
        height: "600px",
        width: "600px"
    };
    if (aspectRatio > 100) {
        imageDimensionsObj1.width = "600px";
        imageDimensionsObj1.height = "338px";
    }
    if (aspectRatio < 100) {
        imageDimensionsObj1.width = "338px";
        imageDimensionsObj1.height = "600px";
    }
    return imageDimensionsObj1;
};
// const getPlayIconPosition = (aspectRatio, isCustomWebsite) => {
//   if (isCustomWebsite && aspectRatio > 100) return '4px 0px 0px 12px';
//   if (isCustomWebsite && aspectRatio < 100) return '12px 0px 0px 2px';
//   return '12px 0px 0px 12px';
// };
function ImageDescriptionModal(props) {
    var handleNextPrevIcon = function handleNextPrevIcon(clickType) {
        if (clickType === SCROLL_ACTION.NEXT) {
            if (mainImageIndex < (images === null || images === void 0 ? void 0 : images.length) - 1) {
                setMainImageIndex(function(prevIndex) {
                    return prevIndex + 1;
                });
            } else {
                setMainImageIndex(0);
            }
        } else {
            if (mainImageIndex > 0) {
                setMainImageIndex(function(prevIndex) {
                    return prevIndex - 1;
                });
            } else {
                setMainImageIndex((images === null || images === void 0 ? void 0 : images.length) - 1);
            }
        }
    };
    var handleLeftPanelImageClick = function handleLeftPanelImageClick(index) {
        setMainImageIndex(index);
    };
    var ref, ref1, ref2, ref3, ref4;
    var handleShowImageDescriptionModal = props.handleShowImageDescriptionModal, showImageDescModal = props.showImageDescModal, productData = props.productData, activeIdx = props.activeIdx, mainImageIndexFromPdp = props.mainImageIndexFromPdp;
    var isMobile = deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf;
    var ref5 = (0,react.useState)(0), mainImageIndex = ref5[0], setMainImageIndex = ref5[1];
    var selectedPanelToView = (0,react.useRef)();
    var isComponentMounted = (0,useIsComponentMounted/* default */.Z)();
    var theme = (0,es/* useSelector */.v9)(function(state) {
        return {
            theme: state.storeReducer.store.theme
        };
    }).theme;
    (0,react.useEffect)(function() {
        var ref;
        (ref = selectedPanelToView.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
            behavior: "smooth",
            block: "end",
            inline: "nearest"
        });
    }, [
        mainImageIndex
    ]);
    (0,react.useEffect)(function() {
        setMainImageIndex(mainImageIndexFromPdp);
    }, [
        mainImageIndexFromPdp,
        activeIdx
    ]);
    var customThemeFlag = isThemeCustomizableForStore();
    var imageDimensions = getImageDimensionsAccordingToAspectRatio(isMobile, theme === null || theme === void 0 ? void 0 : theme.product_aspect_ratio);
    var thumbnailImageDimensions = getThumbnailImageDimensions(theme === null || theme === void 0 ? void 0 : theme.product_aspect_ratio);
    // const playIconPosition = getPlayIconPosition(
    //   theme?.product_aspect_ratio,
    //   theme?.custom_theme_flag
    // );
    var images = hooks_useSetImagesDescriptionModal({
        productData: productData,
        activeIdx: activeIdx,
        showImageDescModal: showImageDescModal
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        visible: showImageDescModal,
        className: "bottom-modal imageDescriptionModal",
        animation: "slideUp",
        height: isMobile ? "100vh" : 200,
        onClose: handleShowImageDescriptionModal,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageViewContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageViewLeftSection, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SidePanelImages, {
                        sidePanelImages: images,
                        thumbnailImageDimensions: thumbnailImageDimensions,
                        mainImage: images[mainImageIndex],
                        returnIndexOnSelect: true,
                        handleSidePanelImage: function(index) {
                            return handleLeftPanelImageClick(index);
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ImageViewRightSection, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageViewRightSectionPrev, {
                            className: "tw-z-10",
                            onClick: function() {
                                handleNextPrevIcon(SCROLL_ACTION.PREV);
                            },
                            children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftArrowImageModalMobile, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageModalLeftArrow, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaContainer/* MediaContainer */.X, {
                            width: imageDimensions.width,
                            children: ((ref = images[mainImageIndex]) === null || ref === void 0 ? void 0 : ref.media_type) === constants/* MEDIA_TYPES.YOUTUBE_VIDEO */.w_.YOUTUBE_VIDEO ? showImageDescModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageDescriptionModal_YouTubeViewer, {
                                linkUrl: (ref1 = images[mainImageIndex]) === null || ref1 === void 0 ? void 0 : ref1.image_url
                            }) : ((ref2 = images[mainImageIndex]) === null || ref2 === void 0 ? void 0 : ref2.media_type) !== constants/* MEDIA_TYPES.VIDEO */.w_.VIDEO ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImagePinchZoom, {
                                imageDimensions: imageDimensions,
                                resetKey: mainImageIndex,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageViewRightSectionImage, {
                                    src: (ref3 = images[mainImageIndex]) === null || ref3 === void 0 ? void 0 : ref3.image_url,
                                    imageDimensions: imageDimensions,
                                    isCustomWebsite: customThemeFlag,
                                    style: {
                                        pointerEvents: "auto",
                                        userSelect: "none"
                                    }
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoViewRightSectionImage, {
                                videoDimensions: imageDimensions,
                                isCustomWebsite: customThemeFlag,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                    src: ((ref4 = images[mainImageIndex]) === null || ref4 === void 0 ? void 0 : ref4.image_url) || "",
                                    controls: true,
                                    className: "tw-h-full tw-w-full tw-object-contain"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageViewRightSectionNext, {
                            onClick: function() {
                                handleNextPrevIcon(SCROLL_ACTION.NEXT);
                            },
                            children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftArrowImageModalMobile, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageModalLeftArrow, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {
                    onClick: handleShowImageDescriptionModal,
                    children: isMobile && isComponentMounted ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageModalBackArrow, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIconGrey/* CloseIconGrey */.U, {})
                })
            ]
        })
    });
}
/* harmony default export */ var ImageDescriptionModal_ImageDescriptionModal = (ImageDescriptionModal);

;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/MoreInfoTable/MoreInfoTables.styles.js

function MoreInfoTables_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-top: 24px;\n  @media screen and (max-width: ",
        "px) {\n    margin-top: 24px;\n    margin-left: 16px;\n    margin-bottom: 36px;\n  }\n"
    ]);
    MoreInfoTables_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MoreInfoTables_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 8px;\n  @media screen and (max-width: ",
        "px) {\n    font-size: 14px;\n    font-weight: 600;\n  }\n"
    ]);
    MoreInfoTables_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MoreInfoTables_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  column-gap: 33px;\n"
    ]);
    MoreInfoTables_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function MoreInfoTables_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #e9e9e9;\n  width: 250px;\n  @media screen and (max-width: ",
        "px) {\n    width: 148px;\n  }\n"
    ]);
    MoreInfoTables_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function MoreInfoTables_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-overflow: ellipsis;\n  overflow: hidden;\n  color: #999999;\n  font-weight: 400;\n  font-size: 14px;\n  margin-bottom: 8px;\n  margin-top: 8px;\n  width: auto;\n\n  @media screen and (max-width: ",
        "px) {\n    font-size: 12px;\n    width: 40vw;\n  }\n"
    ]);
    MoreInfoTables_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function MoreInfoTables_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 10vw;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  color: #414141;\n  font-weight: 600;\n  font-size: 14px;\n  width: auto;\n\n  @media screen and (max-width: ",
        "px) {\n    width: 40vw;\n  }\n"
    ]);
    MoreInfoTables_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var MoreInfoTableContainer = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "MoreInfoTableContainer",
    componentId: "sc-83e5333-0"
})(MoreInfoTables_styles_templateObject(), constants/* MAX_MOBILE_WIDTH */.Cf);
var MoreInfoTableHeading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MoreInfoTableHeading",
    componentId: "sc-83e5333-1"
})(MoreInfoTables_styles_templateObject1(), constants/* MAX_MOBILE_WIDTH */.Cf);
var MoreInfoTableDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MoreInfoTableDescription",
    componentId: "sc-83e5333-2"
})(MoreInfoTables_styles_templateObject2());
var MoreInfoTableAttrElement = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MoreInfoTableAttrElement",
    componentId: "sc-83e5333-3"
})(MoreInfoTables_styles_templateObject3(), constants/* MAX_MOBILE_WIDTH */.Cf);
var MoreInfoTableAttrElementHeading = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "MoreInfoTableAttrElementHeading",
    componentId: "sc-83e5333-4"
})(MoreInfoTables_styles_templateObject4(), constants/* MAX_MOBILE_WIDTH */.Cf);
var MoreInfoTableAttrElementInfo = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "MoreInfoTableAttrElementInfo",
    componentId: "sc-83e5333-5"
})(MoreInfoTables_styles_templateObject5(), constants/* MAX_MOBILE_WIDTH */.Cf);

;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/MoreInfoTable/MoreInfoTable.js



function MoreInfoTable(props) {
    var renderTableAttrElement = function renderTableAttrElement(heading, attrValue) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MoreInfoTableAttrElement, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreInfoTableAttrElementHeading, {
                    children: heading
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreInfoTableAttrElementInfo, {
                    children: attrValue
                })
            ]
        });
    };
    var ref;
    var productData = props.productData;
    if (!(productData === null || productData === void 0 ? void 0 : productData.attributes)) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MoreInfoTableContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreInfoTableHeading, {
                children: "More info"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreInfoTableDescription, {
                children: !!(productData === null || productData === void 0 ? void 0 : (ref = productData.attributes) === null || ref === void 0 ? void 0 : ref.length) && (productData === null || productData === void 0 ? void 0 : productData.attributes.map(function(attr) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: renderTableAttrElement(attr === null || attr === void 0 ? void 0 : attr.name, attr === null || attr === void 0 ? void 0 : attr.value)
                    }, "Attribute-element-".concat(attr.name));
                }))
            })
        ]
    });
}
/* harmony default export */ var MoreInfoTable_MoreInfoTable = (MoreInfoTable);

;// CONCATENATED MODULE: ./src/hooks/useAddVariantIdOnPdp.tsx

function useAddVariantIdOnPdp(props) {
    var product = props.product, activeVariant = props.activeVariant, isMainProductLink = props.isMainProductLink;
    (0,react.useEffect)(function() {
        var ref;
        if (isMainProductLink === true) {
            return;
        }
        if (product === null || product === void 0 ? void 0 : (ref = product.variants) === null || ref === void 0 ? void 0 : ref.length) {
            if (history.pushState) {
                var ref1, ref2;
                var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?vid=".concat((ref1 = product.variants[activeVariant]) === null || ref1 === void 0 ? void 0 : ref1.variant_id);
                if ((ref2 = product.variants[activeVariant]) === null || ref2 === void 0 ? void 0 : ref2.variant_id) {
                    window.history.replaceState({
                        path: newurl
                    }, "", newurl);
                }
            }
        }
    }, [
        activeVariant
    ]);
}
/* harmony default export */ var hooks_useAddVariantIdOnPdp = (useAddVariantIdOnPdp);

// EXTERNAL MODULE: ./src/utils/getDiscountPercentage.js
var getDiscountPercentage = __webpack_require__(153716);
// EXTERNAL MODULE: ./src/utils/specificThemeRender.ts
var specificThemeRender = __webpack_require__(698616);
// EXTERNAL MODULE: ./src/utils/LocalStorageHelper.js
var LocalStorageHelper = __webpack_require__(644779);
// EXTERNAL MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/utils.js
var utils = __webpack_require__(708710);
// EXTERNAL MODULE: ./src/components/ProductCustomizationPopUp/index.js + 7 modules
var ProductCustomizationPopUp = __webpack_require__(924648);
// EXTERNAL MODULE: ./src/components/FullPageLoader/FullPageLoader.js
var FullPageLoader = __webpack_require__(315241);
// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/AllProductPagePromos/index.tsx + 1 modules
var AllProductPagePromos = __webpack_require__(42705);
// EXTERNAL MODULE: ./src/constants/promos.js
var promos = __webpack_require__(810445);
// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/SatisfiedBogoPromos/index.tsx + 1 modules
var SatisfiedBogoPromos = __webpack_require__(557333);
// EXTERNAL MODULE: ./src/components/QuntityUnavailableAlert/index.tsx
var QuntityUnavailableAlert = __webpack_require__(527913);
;// CONCATENATED MODULE: ./src/containers/ProductDescription/hooks/useAnchorTop.ts




function useAnchorTop(param) {
    var productId = param.productId, productName = param.productName;
    var isMobile = (0,useGetDeviceType/* useGetDeviceType */.n)().isMobile;
    (0,react.useEffect)(function() {
        // This is done as a fallback to stop any scroll anchor executed by Nextjs
        var bodyElement = document.getElementsByTagName("body")[0];
        if (bodyElement && (isMobile || deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf)) {
            bodyElement.classList.add("!tw-overflow-hidden");
            setTimeout(function() {
                bodyElement.classList.remove("!tw-overflow-hidden");
            }, 1100);
        }
    }, []);
    (0,react.useEffect)(function() {
        setTimeout(function() {
            window.scrollTo({
                left: 0,
                top: 0
            });
        }, 30);
    }, [
        productId,
        productName
    ]);
    return null;
}

;// CONCATENATED MODULE: ./src/components/PDItemCardLoader/index.js


var CardLoader = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "lazy-itemCard",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "lazy-itemCard--head animate"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "lazy-itemCard--body",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lazy-itemCard--name animate"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "lazy-itemCard--box",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "lazy-itemCard--amount animate"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "lazy-itemCard--cta animate"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PDItemCardLoader = (CardLoader);

// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(268037);
// EXTERNAL MODULE: ./src/components/DesignSystem/Card/index.tsx + 2 modules
var Card = __webpack_require__(950258);
// EXTERNAL MODULE: ./src/utils/returnCommonConfigData.js
var returnCommonConfigData = __webpack_require__(943090);
// EXTERNAL MODULE: ./src/components/DesignSystem/ProductItemWidget/index.js + 3 modules
var ProductItemWidget = __webpack_require__(707780);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ProductCard/index.ts + 11 modules
var ProductCard = __webpack_require__(632755);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts
var WidgetDndContext = __webpack_require__(474151);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ProductCard/utils.tsx + 1 modules
var ProductCard_utils = __webpack_require__(881241);
// EXTERNAL MODULE: ./src/constants/subscription.ts
var subscription = __webpack_require__(423653);
// EXTERNAL MODULE: ./src/utils/productUtils.ts
var productUtils = __webpack_require__(236913);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ProductListWrapper/utils.ts
var ProductListWrapper_utils = __webpack_require__(202386);
;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/SuggestedProducts/index.tsx

















function SuggestedProducts() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var router = (0,next_router.useRouter)();
    var ref6 = (0,react.useState)([]), availableSuggestions = ref6[0], setAvailableSuggestions = ref6[1];
    var isMobile = (0,useGetDeviceType/* useGetDeviceType */.n)().isMobile;
    var ref7 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), globalStyle = ref7.widgetContextState.globalStyle;
    var ref8 = (globalStyle === null || globalStyle === void 0 ? void 0 : globalStyle.productCard) || {
        infoList: [],
        isEnabled: false
    }, infoList = ref8.infoList, isProductCardEnabled = ref8.isEnabled;
    var showCustomProductCard = isProductCardEnabled && (infoList === null || infoList === void 0 ? void 0 : infoList.length) ? true : false;
    var ref9 = (0,redux/* useSelector */.v9)(function(state) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var similar_suggestions = state.catalogReducer.sharePDP.similar_suggestions;
        return {
            loader: state.commonReducer.loader,
            suggestions: state.catalogReducer.sharePDP.suggestions,
            similar_suggestions: similar_suggestions,
            theme: state.storeReducer.store.theme,
            category: similar_suggestions ? (ref = state.catalogReducer) === null || ref === void 0 ? void 0 : (ref1 = ref.sharePDP) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.suggestions) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.category : (ref4 = state.catalogReducer) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.categories) === null || ref5 === void 0 ? void 0 : ref5[0]
        };
    }), loader = ref9.loader, similar_suggestions = ref9.similar_suggestions, suggestions = ref9.suggestions, theme = ref9.theme, category = ref9.category;
    var storeInfo = (0,redux/* useSSRSelector */.kF)(function(state) {
        return {
            storeInfo: state.storeReducer.store
        };
    }).storeInfo;
    (0,react.useEffect)(function() {
        if (suggestions === null || suggestions === void 0 ? void 0 : suggestions.length) {
            setAvailableSuggestions(suggestions.filter(function(item) {
                return !!item.available;
            }));
        }
    }, [
        suggestions
    ]);
    var goToHomePage = function() {
        if ((storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.new_subscription_status) === subscription/* NEW_SUBSCRIPTIONS_STATUS.INACTIVE */.W0.INACTIVE && !storeInfo.premium) {
            router.push((0,routes.getRoute)(routes.PATH.PRODUCT, storeInfo.store_info.domain));
        } else {
            window.location.href = (0,routes.getRoute)("".concat(routes.PATH.SHOP, "?cid=").concat(category.id), storeInfo.store_info.domain);
        }
    };
    var onSuggestiveItemTap = function(item) {
        // window.scrollTo({ left: 0, top: 0 });
        var link = (0,routes.getRoute)((0,productUtils/* getProductPathFromUrl */.ts)(item === null || item === void 0 ? void 0 : item.link, false), storeInfo.store_info.domain);
        // router.replace(link);
        window.location.href = link;
    };
    var cardSelfDimensions = (0,ProductListWrapper_utils/* useProductCardDimensions */.lT)({
        imageWidth: isMobile ? checkRenderEnv/* IS_SERVER */.W6 ? 200 : document.documentElement.clientWidth * 0.4 : 300
    }).cardSelfDimensions;
    // different card based on whether custom website is enabled or not
    var conditionalCardRender = function(item, idx) {
        if (showCustomProductCard) {
            var layoutElement = infoList === null || infoList === void 0 ? void 0 : infoList.find(function(item) {
                return item.type === "layout";
            });
            var cardWrapperConfigs = (0,ProductCard_utils/* getCartWrapperConfigs */.Ui)(layoutElement === null || layoutElement === void 0 ? void 0 : layoutElement.config);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard.ProductCard, {
                onItemClick: onSuggestiveItemTap,
                productData: item,
                itemIndex: idx,
                configs: {
                    cardWrapperConfigs: cardWrapperConfigs,
                    isMobile: isMobile,
                    dimensions: {
                        cardHeight: cardSelfDimensions.cardHeight,
                        cardWidth: cardSelfDimensions.cardWidth
                    }
                }
            }, item.id);
        }
        return (theme === null || theme === void 0 ? void 0 : theme.custom_theme_flag) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductItemWidget/* ProductCardWidget1 */.e, {
            isPdp: true,
            data: item,
            onItemClick: function() {
                return onSuggestiveItemTap(item);
            },
            showButton: false,
            categoryConfig: (0,returnCommonConfigData/* returnCommonConfigData */.Z)({
                activeCategoryConfig: {
                    animation: "pop"
                }
            })
        }, item.id) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Card, {
            isPdp: true,
            data: item,
            onItemClick: function() {
                return onSuggestiveItemTap(item);
            },
            showButton: true
        }, item.id);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "suggestion__box tw-gap-[20px]",
                children: loader && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PDItemCardLoader, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PDItemCardLoader, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PDItemCardLoader, {})
                    ]
                })
            }),
            !!(availableSuggestions === null || availableSuggestions === void 0 ? void 0 : availableSuggestions.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "pdp__main--suggestion",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: similar_suggestions ? "More in category" : "Other Products in Store"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "suggestion__box tw-gap-[20px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "dn-ns db"
                            }),
                            !loader && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    availableSuggestions.map(function(item, idx) {
                                        return conditionalCardRender(item, idx);
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "suggestion__box--viewall",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            onClick: goToHomePage,
                                            style: {
                                                cursor: "pointer",
                                                border: "1px solid ".concat(storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color),
                                                backgroundColor: (storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.theme) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.colors) === null || ref3 === void 0 ? void 0 : ref3.primary_color) ? storeInfo === null || storeInfo === void 0 ? void 0 : (ref4 = storeInfo.theme) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.colors) === null || ref5 === void 0 ? void 0 : ref5.primary_color : "#ea5151"
                                            },
                                            children: "View all"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/hooks/useItemScheduler.ts + 2 modules
var useItemScheduler = __webpack_require__(310862);
// EXTERNAL MODULE: ./src/hooks/useStoreContactDetails.tsx
var useStoreContactDetails = __webpack_require__(299375);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(730381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./src/constants/schema.js
var BREADCRUMBS_PARTS = {
    home: "home",
    collection: "collection",
    category: "category"
};
var MAX_RATING_POINTS = 5;
var CURRENCY_NAME = "INR";
var COUNTRY_NAME = "IN";
var SCHEMA_TYPE = {
    Product: "Product",
    ProductGroup: "ProductGroup",
    Offer: "Offer",
    Brand: "Brand",
    Rating: "Rating",
    Review: "Review",
    Person: "Person",
    AggregateRating: "AggregateRating",
    MerchantReturnPolicy: "MerchantReturnPolicy",
    LIST_ITEM: "ListItem",
    BreadcrumbList: "BreadcrumbList"
};

;// CONCATENATED MODULE: ./src/constants/storePolicy.js
var STORE_POLICY_PAGE_TYPE = {
    TERMS_AND_CONDITIONS: 1,
    RETURN_AND_REFUND: 2,
    PRIVACY_POLICY: 3,
    SHIPPING_AND_PAYMENT: 4,
    INVOICE_DISCLAIMER: 5
};

;// CONCATENATED MODULE: ./src/containers/ProductDescription/Utils/getProductSchema.js






var getReturnRefundPolicy = function(data) {
    var pageData = data === null || data === void 0 ? void 0 : data.find(function(item) {
        return item.page_type === STORE_POLICY_PAGE_TYPE.RETURN_AND_REFUND;
    });
    return pageData ? pageData.additional_config_return_refund_policy : null;
};
var getVariantOption = function(variantOption, val) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = variantOption[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var ref;
            if ((item === null || item === void 0 ? void 0 : (ref = item.option_name) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === val) {
                return item === null || item === void 0 ? void 0 : item.variant_name;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
};
function getPriceValidUntil() {
    var currentDate = moment_default()();
    return currentDate.add(1, "year").format("YYYY-MM-DD");
}
var getProductSchema = function(props) {
    var ref, ref1, ref2, ref3;
    var product = props.product, storePolicy = props.storePolicy, storeUrl = props.storeUrl;
    var productVariantsData = product === null || product === void 0 ? void 0 : product.variants;
    var reviewData = product === null || product === void 0 ? void 0 : product.store_item_review_rating;
    var returnAndRefundPolicy = getReturnRefundPolicy(storePolicy);
    var getTopRatedReview = function(reviews) {
        var topRatedReview = (reviews === null || reviews === void 0 ? void 0 : reviews.length) && (reviews === null || reviews === void 0 ? void 0 : reviews.reduce(function(topReview, currentReview) {
            return (currentReview === null || currentReview === void 0 ? void 0 : currentReview.rating) > (topReview === null || topReview === void 0 ? void 0 : topReview.rating) ? currentReview : topReview;
        }, reviews[0]));
        return topRatedReview;
    };
    var getVariantsItemData = function(variantsItemData) {
        return variantsItemData === null || variantsItemData === void 0 ? void 0 : variantsItemData.map(function(item) {
            var ref, ref1;
            var isColorVariant = getVariantOption(item === null || item === void 0 ? void 0 : item.option_variant_names, "colour");
            var isSizeVariant = getVariantOption(item === null || item === void 0 ? void 0 : item.option_variant_names, "size");
            var variantUrl = "".concat(product === null || product === void 0 ? void 0 : product.link, "?vid=").concat(item === null || item === void 0 ? void 0 : item.variant_id);
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                "@type": SCHEMA_TYPE.Product
            }, (item === null || item === void 0 ? void 0 : item.sku_id) && {
                sku: item.sku_id
            }, (item === null || item === void 0 ? void 0 : item.gst) && {
                gtin14: item.gst
            }), {
                image: (item === null || item === void 0 ? void 0 : (ref = item.images) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.image_url) || (product === null || product === void 0 ? void 0 : product.image_url),
                name: "".concat(product === null || product === void 0 ? void 0 : product.name, " | ").concat(item === null || item === void 0 ? void 0 : item.variant_name)
            }), isColorVariant && {
                color: isColorVariant
            }, isSizeVariant && {
                size: isSizeVariant
            }), {
                offers: (0,_object_spread/* default */.Z)({
                    "@type": SCHEMA_TYPE.Offer,
                    url: variantUrl,
                    priceCurrency: CURRENCY_NAME,
                    price: item === null || item === void 0 ? void 0 : item.discounted_price,
                    itemCondition: "https://schema.org/NewCondition",
                    availability: (item === null || item === void 0 ? void 0 : item.available) ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
                    priceValidUntil: getPriceValidUntil()
                }, (returnAndRefundPolicy === null || returnAndRefundPolicy === void 0 ? void 0 : returnAndRefundPolicy.is_accepting_returns) && {
                    hasMerchantReturnPolicy: {
                        "@id": "".concat(storeUrl, "/policy")
                    }
                })
            });
        });
    };
    var topRatedReviewData = getTopRatedReview(reviewData === null || reviewData === void 0 ? void 0 : reviewData.review_rating);
    var isColorVariant = product === null || product === void 0 ? void 0 : (ref = product.options_show_type) === null || ref === void 0 ? void 0 : ref.hasOwnProperty("Colour");
    var isSizeVariant = product === null || product === void 0 ? void 0 : (ref1 = product.options_show_type) === null || ref1 === void 0 ? void 0 : ref1.hasOwnProperty("Size");
    var productSchema = [
        (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            "@context": "https://schema.org/",
            "@type": !!(product === null || product === void 0 ? void 0 : product.variants_count) ? SCHEMA_TYPE.ProductGroup : SCHEMA_TYPE.Product,
            name: product === null || product === void 0 ? void 0 : product.name,
            description: product === null || product === void 0 ? void 0 : product.description
        }, !(product === null || product === void 0 ? void 0 : product.variants_count) && {
            image: product === null || product === void 0 ? void 0 : product.image_url
        }), {
            url: product === null || product === void 0 ? void 0 : product.link
        }), (product === null || product === void 0 ? void 0 : product.brand_name) && {
            brand: {
                "@type": SCHEMA_TYPE.Brand,
                name: product === null || product === void 0 ? void 0 : product.brand_name
            }
        }, (reviewData === null || reviewData === void 0 ? void 0 : reviewData.ratings_count) && (topRatedReviewData === null || topRatedReviewData === void 0 ? void 0 : topRatedReviewData.full_name) && {
            review: [
                {
                    "@type": SCHEMA_TYPE.Review,
                    reviewRating: {
                        "@type": SCHEMA_TYPE.Rating,
                        ratingValue: topRatedReviewData === null || topRatedReviewData === void 0 ? void 0 : topRatedReviewData.rating
                    },
                    author: {
                        "@type": "Person",
                        name: topRatedReviewData === null || topRatedReviewData === void 0 ? void 0 : topRatedReviewData.full_name
                    }
                }, 
            ]
        }, (reviewData === null || reviewData === void 0 ? void 0 : reviewData.ratings_count) && {
            aggregateRating: {
                "@type": SCHEMA_TYPE.AggregateRating,
                ratingValue: reviewData === null || reviewData === void 0 ? void 0 : (ref2 = reviewData.review_rating) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.avg_rating,
                bestRating: MAX_RATING_POINTS,
                ratingCount: reviewData === null || reviewData === void 0 ? void 0 : reviewData.ratings_count
            }
        }, !(product === null || product === void 0 ? void 0 : product.variants_count) && {
            offers: (0,_object_spread/* default */.Z)({
                "@type": SCHEMA_TYPE.Offer,
                priceCurrency: CURRENCY_NAME,
                price: product === null || product === void 0 ? void 0 : product.discounted_price,
                itemCondition: "https://schema.org/NewCondition",
                availability: "https://schema.org/InStock",
                priceValidUntil: getPriceValidUntil()
            }, (returnAndRefundPolicy === null || returnAndRefundPolicy === void 0 ? void 0 : returnAndRefundPolicy.is_accepting_returns) && {
                hasMerchantReturnPolicy: {
                    "@id": "".concat(storeUrl, "/policy")
                }
            })
        }, (isColorVariant || isSizeVariant) && {
            variesBy: (0,_to_consumable_array/* default */.Z)(!!isColorVariant ? [
                "https://schema.org/Color"
            ] : []).concat((0,_to_consumable_array/* default */.Z)(!!isSizeVariant ? [
                "https://schema.org/Size"
            ] : []))
        }, (product === null || product === void 0 ? void 0 : product.variants_count) && {
            productGroupID: product === null || product === void 0 ? void 0 : product.id,
            hasVariant: getVariantsItemData(productVariantsData)
        }), 
    ];
    if (returnAndRefundPolicy && (returnAndRefundPolicy === null || returnAndRefundPolicy === void 0 ? void 0 : returnAndRefundPolicy.is_accepting_returns)) {
        var returnAndRefundPolicySchema = {
            "@context": "http://schema.org/",
            "@type": SCHEMA_TYPE.MerchantReturnPolicy,
            "@id": "".concat(storeUrl, "/policy"),
            applicableCountry: COUNTRY_NAME,
            returnPolicyCategory: "https://schema.org/MerchantReturnFiniteReturnWindow",
            merchantReturnDays: returnAndRefundPolicy === null || returnAndRefundPolicy === void 0 ? void 0 : returnAndRefundPolicy.day_count,
            returnMethod: "https://schema.org/ReturnByMail",
            returnFees: "https://schema.org/FreeReturn"
        };
        productSchema.push(returnAndRefundPolicySchema);
    }
    return productSchema;
};

;// CONCATENATED MODULE: ./src/containers/ProductDescription/Utils/getBreadcrumbSchema.js

var getBreadcrumbSchema = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = props || {}, product = ref6.product, storeUrl = ref6.storeUrl, collectionItems = ref6.collectionItems;
    if (!product || !storeUrl) return [];
    var breadCrumbParts = [
        BREADCRUMBS_PARTS.home,
        BREADCRUMBS_PARTS.collection,
        BREADCRUMBS_PARTS.category, 
    ];
    var categoryName = product === null || product === void 0 ? void 0 : (ref = product.category) === null || ref === void 0 ? void 0 : ref.name;
    var categoryId = product === null || product === void 0 ? void 0 : (ref1 = product.category) === null || ref1 === void 0 ? void 0 : ref1.id;
    var collectionURL = (product === null || product === void 0 ? void 0 : product.collections) ? "".concat(storeUrl, "/collections/").concat((product === null || product === void 0 ? void 0 : (ref2 = product.collections) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.id) || "0") : null;
    var categoryUrl = (product === null || product === void 0 ? void 0 : product.category) ? "".concat(storeUrl, "/collections/").concat((product === null || product === void 0 ? void 0 : (ref4 = product.collections) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : ref5.id) || "0", "?cid=").concat(categoryId) : null;
    var categoryUrl2 = "".concat(storeUrl, "/shop/").concat(categoryName, "?cid=").concat(categoryId);
    var getBreadcrumbSchemaPart = function(part) {
        var itemList = [
            {
                "@type": SCHEMA_TYPE.LIST_ITEM,
                position: 1,
                name: "Home",
                item: storeUrl
            }, 
        ];
        if (collectionURL && part === BREADCRUMBS_PARTS.collection) {
            var ref, ref1;
            itemList.push({
                "@type": SCHEMA_TYPE.LIST_ITEM,
                position: 2,
                name: (product === null || product === void 0 ? void 0 : (ref = product.collections) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.name) || "Other Collections",
                item: collectionURL
            });
        }
        if (categoryUrl && (part === BREADCRUMBS_PARTS.category || part === BREADCRUMBS_PARTS.collection)) {
            itemList.push({
                "@type": SCHEMA_TYPE.LIST_ITEM,
                position: itemList.length + 1,
                name: categoryName,
                item: part === BREADCRUMBS_PARTS.category ? categoryUrl2 : categoryUrl
            });
        }
        itemList.push({
            "@type": SCHEMA_TYPE.LIST_ITEM,
            position: itemList.length + 1,
            name: (product === null || product === void 0 ? void 0 : product.name) || "Product"
        });
        return itemList;
    };
    var breadCrumbSchema = breadCrumbParts.map(function(schema) {
        if (schema === BREADCRUMBS_PARTS.collection && !(collectionItems === null || collectionItems === void 0 ? void 0 : collectionItems.length)) return null;
        var itemList = getBreadcrumbSchemaPart(schema);
        return {
            "@context": "https://schema.org",
            "@type": SCHEMA_TYPE.BreadcrumbList,
            itemListElement: itemList
        };
    }).filter(function(schema) {
        return schema;
    });
    return breadCrumbSchema;
};

// EXTERNAL MODULE: ./src/components/Wishlist/WishlistHeaderMenuItem.tsx
var WishlistHeaderMenuItem = __webpack_require__(155039);
;// CONCATENATED MODULE: ./src/assets/svgExports/Tick.js

var Tick = function(param) {
    var _size = param.size, size = _size === void 0 ? 12 : _size;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "-1.5 -1.5 18.00 18.00",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                id: "SVGRepo_bgCarrier",
                "stroke-width": "0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                id: "SVGRepo_tracerCarrier",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                id: "SVGRepo_iconCarrier",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M14.7071 3.00001L5.50001 12.2071L0.292908 7.00001L1.00001 6.29291L5.50001 10.7929L14 2.29291L14.7071 3.00001Z",
                    fill: "#000000"
                })
            })
        ]
    });
};
/* harmony default export */ var svgExports_Tick = (Tick);

;// CONCATENATED MODULE: ./src/containers/ProductDescription/Components/WishlistShareButton/index.tsx





var WishlistShareButton = function(param) {
    var handleToggleWishlistClick = param.handleToggleWishlistClick, productData = param.productData, isItemWishlisted = param.isItemWishlisted;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-w-full tw-mt-[20px] tw-h-[68px] tw-flex tw-items-center tw-border-t tw-border-b tw-border-[#DEDEDE] tw-border-solid tw-font-inter tw-font-medium ".concat(checkClientDeviceType/* IS_DESKTOP */.yn ? "tw-gap-50" : "tw-gap-25 tw-flex-row-reverse"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: handleToggleWishlistClick,
                className: "tw-cursor-pointer tw-w-[180px]",
                children: isItemWishlisted ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex tw-gap-[5px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(svgExports_Tick, {
                            size: 25
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "tw-flex tw-items-center",
                            children: "Added to Wishlist"
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(WishlistHeaderMenuItem/* default */.Z, {
                    color: "black",
                    iconPosition: "left",
                    customTextClassName: "!tw-text-[16px] !tw-font-medium",
                    ctaText: "Add to Wishlist",
                    isActive: false
                })
            }),
            !checkClientDeviceType/* IS_DESKTOP */.yn && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-w-[1px] tw-h-[34px] tw-bg-[#DEDEDE]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-flex tw-items-center tw-cursor-pointer tw-text-[16px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareOptions, {
                    productData: productData,
                    showText: true,
                    customWrapperClass: checkClientDeviceType/* IS_DESKTOP */.yn ? "tw-gap-15" : "tw-gap-8 tw-mr-[25px]"
                })
            })
        ]
    });
};
/* harmony default export */ var Components_WishlistShareButton = (WishlistShareButton);

// EXTERNAL MODULE: ./src/hooks/useSetWishlistState.tsx
var useSetWishlistState = __webpack_require__(106531);
// EXTERNAL MODULE: ./src/constants/wishlist.js
var wishlist = __webpack_require__(298627);
// EXTERNAL MODULE: ./src/redux/actions/wishlist.ts
var actions_wishlist = __webpack_require__(847228);
;// CONCATENATED MODULE: ./src/containers/ProductDescription/index.tsx

















































































var AuthModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6956), __webpack_require__.e(4814), __webpack_require__.e(3973)]).then(__webpack_require__.bind(__webpack_require__, 493973));
});
var MIN_EMI_AMOUNT = 2500;
// Helper function to prepare data for ViewContent event
var prepareViewContentData = function(product, storeInfo, cost) {
    var ref, ref1;
    var skuId = product === null || product === void 0 ? void 0 : (ref = product.id) === null || ref === void 0 ? void 0 : ref.toString();
    var itemPrice = (cost === null || cost === void 0 ? void 0 : cost.discounted_price) || (product === null || product === void 0 ? void 0 : product.price);
    var currency = (storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.currency) === null || ref1 === void 0 ? void 0 : ref1.currency_symbol) || "INR";
    if (!skuId || !itemPrice) {
        console.warn("===ViewContent not fired: Missing SKU ID or price.");
        return null;
    }
    return {
        content_ids: [
            skuId
        ],
        contents: [
            {
                id: skuId,
                quantity: 1,
                item_price: itemPrice
            }
        ],
        content_type: "product",
        currency: currency,
        value: itemPrice
    };
};
// Helper function to prepare data for AddToCart event
var prepareAddToCartData = function(product, storeInfo, selectedVariant, cost) {
    var ref, ref1;
    var skuId = product === null || product === void 0 ? void 0 : (ref = product.id) === null || ref === void 0 ? void 0 : ref.toString();
    var itemPrice = (cost === null || cost === void 0 ? void 0 : cost.discounted_price) || (product === null || product === void 0 ? void 0 : product.price);
    var currency = (storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.currency) === null || ref1 === void 0 ? void 0 : ref1.currency_symbol) || "INR";
    var contentsArray;
    if (selectedVariant) {
        var ref2, ref3, ref4;
        skuId = (selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref2 = selectedVariant.variant_id) === null || ref2 === void 0 ? void 0 : ref2.toString()) || skuId;
        itemPrice = itemPrice || (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.price);
        contentsArray = [
            {
                id: (selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref3 = selectedVariant.variant_id) === null || ref3 === void 0 ? void 0 : ref3.toString()) || (product === null || product === void 0 ? void 0 : (ref4 = product.id) === null || ref4 === void 0 ? void 0 : ref4.toString()),
                quantity: 1,
                item_price: itemPrice
            }
        ];
    } else {
        var ref5;
        contentsArray = [
            {
                id: product === null || product === void 0 ? void 0 : (ref5 = product.id) === null || ref5 === void 0 ? void 0 : ref5.toString(),
                quantity: 1,
                item_price: itemPrice
            }
        ];
    }
    if (!skuId || !itemPrice) {
        console.warn("===AddToCart not fired: Missing SKU ID or price.");
        return null;
    }
    return {
        content_ids: [
            skuId
        ],
        contents: contentsArray,
        content_type: "product",
        currency: currency,
        value: itemPrice
    };
};
var ProductDescPage = function(param) {
    var product = param.product, catalogCategories = param.catalogCategories, catalogTags = param.catalogTags;
    var findActiveVariantIndex = function findActiveVariantIndex(product) {
        var variantIdFromUrl = (0,Utils_common/* getVariantIdFromUrl */.DA)();
        if (variantIdFromUrl) {
            return {
                activeVariantIndex: product.variants.findIndex(function(variant) {
                    return variantIdFromUrl === (variant === null || variant === void 0 ? void 0 : variant.variant_id);
                }),
                isMainProductLink: false
            };
        }
        if (variantInitColor) {
            return {
                activeVariantIndex: product.variants.findIndex(function(el) {
                    return el.status === constants/* ITEM_ACTIVE_STATUS.ACTIVE */.p4.ACTIVE && (el === null || el === void 0 ? void 0 : el.option_variant_names.find(function(variantOptions) {
                        return (variantOptions === null || variantOptions === void 0 ? void 0 : variantOptions.option_name) === constants/* VARIANT_OPTIONS.COLOR */.T_.COLOR && (variantOptions === null || variantOptions === void 0 ? void 0 : variantOptions.colour_code) === variantInitColor;
                    }));
                }),
                isMainProductLink: false
            };
        } else {
            return {
                activeVariantIndex: product.variants.findIndex(function(el) {
                    return el.status === constants/* ITEM_ACTIVE_STATUS.ACTIVE */.p4.ACTIVE;
                }),
                isMainProductLink: variantIdFromUrl ? false : true
            };
        }
    };
    var handleShowImageDescriptionModal = function handleShowImageDescriptionModal() {
        setShowImageDescModal(!showImageDescModal);
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30;
    var productId = product === null || product === void 0 ? void 0 : product.id;
    var productName = product === null || product === void 0 ? void 0 : product.name;
    var schedualerConstraints = product === null || product === void 0 ? void 0 : product.item_schedule;
    var showDetailedDescription = product === null || product === void 0 ? void 0 : product.description_detail;
    useAnchorTop({
        productId: productId,
        productName: productName
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var deviceType = (0,useGetDeviceType/* useGetDeviceType */.n)().deviceType;
    var isMobile = deviceType === "mobile";
    var ref31 = (0,es/* useSelector */.v9)(function(state) {
        var ref, ref1, ref2;
        return {
            cartData: state.cartReducer,
            loader: state.commonReducer.loader,
            suggestions: state.catalogReducer.sharePDP.suggestions,
            similar_suggestions: state.catalogReducer.sharePDP.similar_suggestions,
            theme: state.storeReducer.store.theme,
            allEmiOptions: state.emiReducer.allEmiOptions,
            paymentOffersList: state.promoReducer.paymentOffersList,
            userData: state.userReducer,
            reviewSettings: state.catalogReducer.reviewSettings,
            personalizedProduct: (ref = state.catalogReducer) === null || ref === void 0 ? void 0 : ref.personalizedProduct,
            scheduleInfo: state.commonReducer.scheduleInfo,
            storePolicy: (ref1 = state.storePolicyReducer) === null || ref1 === void 0 ? void 0 : ref1.data,
            collectionItems: (ref2 = state.catalogReducer) === null || ref2 === void 0 ? void 0 : ref2.collections
        };
    }), cartData = ref31.cartData, allEmiOptions = ref31.allEmiOptions, paymentOffersList = ref31.paymentOffersList, userData = ref31.userData, reviewSettings = ref31.reviewSettings, personalizedProduct = ref31.personalizedProduct, scheduleInfo = ref31.scheduleInfo, storePolicy = ref31.storePolicy, collectionItems = ref31.collectionItems;
    var ref32 = (0,react.useState)({
        itemCartIdx: -1,
        cartCount: 0,
        showFullImage: {
            show: false,
            currentIndex: 0
        },
        discountPercentage: 0,
        activeVariant: -1,
        OSName: null,
        ownerNumber: null,
        isRedirect: false,
        cost: {
            discounted_price: 0,
            price: 0,
            price_range: 0
        },
        viewDescription: false,
        selectedVariantId: -1,
        additionalRemark: [],
        showAuthModal: false,
        isMainProductLink: false,
        isItemWishlisted: false
    }), state = ref32[0], setState = ref32[1];
    var ref33 = (0,react.useState)(false), emiModalShow = ref33[0], setEmiModalShow = ref33[1];
    var ref34 = (0,react.useState)(false), variantOutOfStock = ref34[0], setVariantOutOfStock = ref34[1];
    var ref35 = (0,react.useState)(false), bankOfferModal = ref35[0], setBankOfferModal = ref35[1];
    var ref36 = (0,react.useState)(false), verifedBuyer = ref36[0], setVerifiedBuyer = ref36[1];
    var ref37 = (0,react.useState)(false), showImageDescModal = ref37[0], setShowImageDescModal = ref37[1];
    var ref38 = (0,react.useState)(""), variantInitColor = ref38[0], setVariantInitColor = ref38[1];
    var ref39 = (0,react.useState)(false), showSchedulerError = ref39[0], setShowSchedulerError = ref39[1];
    var ref40 = (0,react.useState)(false), itemWishlisted = ref40[0], setItemWishlisted = ref40[1];
    // it holds index value of image that is clicked from pdp to be opened in imageDescModal
    var ref41 = (0,react.useState)(0), mainImageIndexFromPdp = ref41[0], setMainImageIndexFromPdp = ref41[1];
    var isComponentMounted = (0,useIsComponentMounted/* default */.Z)();
    var storeInfo = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeInfo: state.storeReducer.store
        };
    }).storeInfo;
    var ref42 = (0,useItemScheduler/* default */.Z)(), setScheduleData = ref42.setScheduleData, changeSchedulingInfoAndSetCart = ref42.changeSchedulingInfoAndSetCart, addScheduleInfoToCart = ref42.addScheduleInfoToCart;
    (0,react.useEffect)(function() {
        var ref, ref1, ref2;
        var itemIndexInCart = cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : ref.findIndex(function(el) {
            return (el.id || el.item_id) === (product === null || product === void 0 ? void 0 : product.id);
        });
        if (cartData === null || cartData === void 0 ? void 0 : (ref1 = cartData.items) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[itemIndexInCart]) === null || ref2 === void 0 ? void 0 : ref2.schedule_info) {
            var ref3, ref4;
            setScheduleData(cartData === null || cartData === void 0 ? void 0 : (ref3 = cartData.items) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[itemIndexInCart]) === null || ref4 === void 0 ? void 0 : ref4.schedule_info);
        } else {
            setScheduleData(null);
        }
    }, [
        cartData,
        product === null || product === void 0 ? void 0 : product.id
    ]);
    var isB2bStore = (0,getStoreType/* getStoreType */.K)(storeInfo) === constants/* STORE_CUSTOMIZATION.B2B */.DO.B2B;
    var storeUrl = storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_url;
    var toggleEmiModal = function() {
        if (deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf) {
            router.push((0,routes.getRoute)(routes.PATH.emiOptions(state.cost.discounted_price), storeInfo.store_info.domain), undefined, {
                scroll: false
            });
        } else {
            setEmiModalShow(function(s) {
                return !s;
            });
        }
    };
    var toggleBankOfferModal = function() {
        setBankOfferModal(function(s) {
            return !s;
        });
    };
    var setWishlistState = (0,useSetWishlistState/* useSetWishlistState */.X)().setWishlistState;
    var ref43 = (0,useFeatureLocks/* useFeatureLocks */.r)(), crrFeatureStatus = ref43.crrFeatureStatus, notifyMeFeatureStatus = ref43.notifyMeFeatureStatus;
    var isCRRFeatureUnlocked = !(crrFeatureStatus === null || crrFeatureStatus === void 0 ? void 0 : crrFeatureStatus.isLocked);
    var isNotifyMeFeatureVisible = notifyMeFeatureStatus === null || notifyMeFeatureStatus === void 0 ? void 0 : notifyMeFeatureStatus.isVisible;
    var itemIndexInCart = (0,itemIndexFromCart/* itemIndexFromCart */.R)(cartData, product);
    var storePhone = (0,useStoreContactDetails/* default */.Z)().storePhone;
    var hasVariant = (product === null || product === void 0 ? void 0 : (ref = product.item_option_variants) === null || ref === void 0 ? void 0 : ref.length) && (product === null || product === void 0 ? void 0 : (ref1 = product.variants) === null || ref1 === void 0 ? void 0 : ref1.length);
    var ref44 = (0,useCartHandler/* useCartHandlers */.u)(), handleSetProductData = ref44.handleSetProductData, handleSetProductCustomizationCount = ref44.handleSetProductCustomizationCount;
    /**
   * call getAllEmiOptionsInfo api when
   * discounted_price is >= 2500
   */ (0,react.useEffect)(function() {
        var ref, ref1;
        if (((ref = state.cost) === null || ref === void 0 ? void 0 : ref.discounted_price) && ((ref1 = state.cost) === null || ref1 === void 0 ? void 0 : ref1.discounted_price) >= MIN_EMI_AMOUNT && (0,checkIfObjectExists/* checkIfObjectExists */.L)(storeInfo)) {
            var ref2;
            dispatch((0,emi/* getAllEmiOptions */.qg)({
                amount: (ref2 = state.cost) === null || ref2 === void 0 ? void 0 : ref2.discounted_price,
                store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id
            }));
        }
    }, [
        (ref2 = state.cost) === null || ref2 === void 0 ? void 0 : ref2.discounted_price,
        storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id
    ]);
    (0,react.useEffect)(function() {
        var urlParams = new URLSearchParams(window.location.search);
        var utmSource = urlParams.get("utm_source");
        var mb7SortAndFilterConfigTemp = LocalStorageHelper/* default.get */.Z.get(utils/* MB7_SORT_FILTER_TEMP_STORAGE_KEY */.FM);
        if (userData === null || userData === void 0 ? void 0 : userData.isLogin) {
            dispatch((0,actions_wishlist/* checkItemWishlistStatus */.Qd)({
                store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id,
                item_id: product === null || product === void 0 ? void 0 : product.id
            }, function(status) {
                setItemWishlisted(status);
            }));
        }
        if (utmSource && (localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("utm_source")) !== utmSource) {
            localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("utm_source", utmSource);
        }
        if (mb7SortAndFilterConfigTemp) {
            LocalStorageHelper/* default.delete */.Z["delete"](utils/* MB7_SORT_FILTER_TEMP_STORAGE_KEY */.FM);
            (0,utils/* setMB7SortAndFilterConfig */.lr)((0,_object_spread/* default */.Z)({}, mb7SortAndFilterConfigTemp));
        }
        storeItemClickedDetails(product === null || product === void 0 ? void 0 : product.id);
    }, []);
    (0,react.useEffect)(function() {
        if (cartData.items && cartData.items.length > 0) {
            setCartAsyncCall();
        }
    }, [
        cartData.amount,
        cartData.pay_amount
    ]);
    var setCartAsyncCall = function() {
        return new Promise(function() {
            dispatch((0,actions_cart/* setCart */.RV)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cartData), {
                order_type: cartData.order_type,
                store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id,
                user_phone: cartData.phone,
                cart_id: cartData.cart_id
            })));
        });
    };
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3, ref4;
        /** Save store info **/ if (storeInfo.store_id) {
            dispatch((0,actions_storeInfo/* saveStoreInfo */.nx)(storeInfo));
        }
        if ((storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id) && (product === null || product === void 0 ? void 0 : (ref = product.category) === null || ref === void 0 ? void 0 : ref.id) && (product === null || product === void 0 ? void 0 : product.id)) {
            var ref5;
            dispatch((0,catalog/* fetchSimilarCatalogItems */.MV)({
                store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id,
                category_id: product === null || product === void 0 ? void 0 : (ref5 = product.category) === null || ref5 === void 0 ? void 0 : ref5.id,
                item_id: product === null || product === void 0 ? void 0 : product.id
            }));
        }
        if (catalogCategories && (catalogCategories === null || catalogCategories === void 0 ? void 0 : catalogCategories.length) > 0) dispatch((0,catalog/* saveCatalogCategories */.FF)(catalogCategories));
        /** Save tags list */ if (catalogTags && (catalogTags === null || catalogTags === void 0 ? void 0 : catalogTags.length) > 0) {
            dispatch((0,catalog/* saveCatalogTags */.Vj)(catalogTags));
        }
        // store owner number and os type
        var OSName = (0,deviceInfo/* getDeviceInfo */.d)().OSName;
        /** find the first active variant index */ var ref6 = findActiveVariantIndex(product), activeVariantIndex = ref6.activeVariantIndex, isMainProductLink = ref6.isMainProductLink;
        if ((product === null || product === void 0 ? void 0 : (ref1 = product.variants) === null || ref1 === void 0 ? void 0 : ref1.length) && activeVariantIndex === -1) activeVariantIndex = 0;
        (product === null || product === void 0 ? void 0 : (ref2 = product.variants) === null || ref2 === void 0 ? void 0 : ref2.length) && activeVariantIndex != -1 && setVariantOutOfStock(!(product === null || product === void 0 ? void 0 : (ref3 = product.variants) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[activeVariantIndex]) === null || ref4 === void 0 ? void 0 : ref4.available));
        var ref7;
        setState(function(state) {
            var ref, ref1;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                OSName: OSName,
                ownerNumber: storePhone,
                activeVariant: activeVariantIndex,
                selectedVariantId: (ref7 = product === null || product === void 0 ? void 0 : (ref = product.variants) === null || ref === void 0 ? void 0 : (ref1 = ref[activeVariantIndex]) === null || ref1 === void 0 ? void 0 : ref1.variant_id) !== null && ref7 !== void 0 ? ref7 : -1,
                cost: (0,getItemAmountForPDP/* getItemAmountForPDP */.w)(product, (product === null || product === void 0 ? void 0 : product.variants_count) > 0 ? 0 : -1),
                isMainProductLink: isMainProductLink,
                isItemWishlisted: itemWishlisted
            });
        });
        if (userData === null || userData === void 0 ? void 0 : userData.isLogin) {
            var ref8;
            var data = {
                phone: (userData === null || userData === void 0 ? void 0 : (ref8 = userData.data) === null || ref8 === void 0 ? void 0 : ref8.phone) || "",
                item_id: product === null || product === void 0 ? void 0 : product.id,
                store_id: (storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id) || ""
            };
            if (data.phone === "") {
                var ref9;
                data.user_id = (userData === null || userData === void 0 ? void 0 : (ref9 = userData.data) === null || ref9 === void 0 ? void 0 : ref9.user_id) || "";
            }
            dispatch((0,catalog/* verifyBuyerForItem */.KB)(data, function(data) {
                return setVerifiedBuyer(data);
            }));
        }
        if (storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id) {
            dispatch((0,catalog/* getCustomerReviewSettings */.vV)(storeInfo.store_id));
        }
        // *** META PIXEL: ViewContent Implementation Start ***
        if ( true && window.fbq && storeInfo.store_id && (product === null || product === void 0 ? void 0 : product.id)) {
            var initialCost = (0,getItemAmountForPDP/* getItemAmountForPDP */.w)(product, (product === null || product === void 0 ? void 0 : product.variants_count) > 0 ? 0 : -1);
            var viewContentData = prepareViewContentData(product, storeInfo, initialCost);
            if (viewContentData) {
                window.fbq("track", "ViewContent", viewContentData);
                console.log("=== META PIXEL: ViewContent Event Fired for product page load ===");
                console.log("===ViewContent Data:", viewContentData);
            }
        }
    // *** META PIXEL: ViewContent Implementation End ***
    }, [
        variantInitColor,
        productId,
        productName,
        itemWishlisted
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if ((cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : ref.length) >= 0) {
            var itemCartIdx = cartData.items.findIndex(function(el) {
                return (el.id || el.item_id) === product.id;
            });
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    cartCount: cartData.items.length,
                    itemCartIdx: itemCartIdx
                });
            });
        }
    }, [
        cartData
    ]);
    (0,react.useEffect)(function() {
        if (state.cost.discounted_price !== state.cost.price) {
            var percent = (0,getDiscountPercentage/* getDiscountPercentage */.$)(state.cost.price, state.cost.discounted_price);
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    discountPercentage: percent
                });
            });
        }
    }, [
        state.cost
    ]);
    (0,react.useEffect)(function() {
        if (state.activeVariant > -1 && (product === null || product === void 0 ? void 0 : product.variants)) {
            var _cost = (0,getItemAmountForPDP/* getItemAmountForPDP */.w)(product, state.activeVariant);
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    cost: _cost,
                    discountPercentage: (0,getDiscountPercentage/* getDiscountPercentage */.$)(_cost.price, _cost.discounted_price)
                });
            });
        }
    }, [
        state.activeVariant,
        productId,
        productName
    ]);
    /**
   * useEffect to open a fullscreen
   * modal for mobile phones
   */ (0,react.useEffect)(function() {
        if (router.query.immersive_view) {
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    showFullImage: {
                        show: true,
                        currentIndex: Number(router.query.immersive_view)
                    }
                });
            });
        } else {
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    showFullImage: {
                        show: false,
                        currentIndex: 0
                    }
                });
            });
        }
    }, [
        router.query.immersive_view
    ]);
    (0,react.useEffect)(function() {
        hydrateAdditionalRemarks();
    }, [
        cartData
    ]);
    hooks_useAddVariantIdOnPdp({
        activeVariant: state.activeVariant,
        product: product,
        isMainProductLink: state.isMainProductLink
    });
    (0,react.useEffect)(function() {
        var urlArray = window.location.href.split("=");
        if ((urlArray === null || urlArray === void 0 ? void 0 : urlArray.length) === 2) setVariantInitColor(urlArray[(urlArray === null || urlArray === void 0 ? void 0 : urlArray.length) - 1]);
        handleSetProductData(product);
        dispatch((0,common/* saveDetailedItemById */.VY)(product));
    }, []);
    (0,react.useEffect)(function() {
        if (product === null || product === void 0 ? void 0 : product.product_personalization) {
            handleSetProductCustomizationCount(product);
        }
    }, [
        product === null || product === void 0 ? void 0 : product.product_personalization
    ]);
    var handleCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(type) {
            var count, ref, ref1, shouldFireAddToCart, selectedVariant, newCart, data, addToCartData, newState, data1, addToCartData1;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        count = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : null;
                        /** Check if variant present in this item */ if (!product.available) return [
                            2
                        ];
                        shouldFireAddToCart = type === "add" || type === "inc";
                        if (!(product.variants_count > 0)) return [
                            3,
                            4
                        ];
                        dispatch((0,common/* saveProductLoaderId */.XG)(product.id));
                        dispatch((0,common/* saveDetailedItemById */.VY)(product));
                        if (!(state.activeVariant === -1)) return [
                            3,
                            1
                        ];
                        switch(type){
                            case "add":
                                dispatch((0,common/* setVariantModalVisibility */.VZ)(true));
                                break;
                            case "inc":
                                dispatch((0,common/* setChooseAndRepeatModalVisibility */.uT)(true));
                                break;
                            case "dec":
                                dispatch((0,common/* setSelectedVariantModalVisibility */.rV)(true));
                                break;
                        }
                        return [
                            3,
                            3
                        ];
                    case 1:
                        selectedVariant = product.variants[state.activeVariant];
                        dispatch((0,common/* setVariantModalVisibility */.VZ)(false));
                        newCart = [];
                        type = type === "add" || type === "inc" ? "inc" : type;
                        newCart = (0,mutateVariantItemWithCartData/* mutateVariantItemWithCartData */.I)(type, product, product.variants[state.activeVariant], cartData, null, null, null, count);
                        addScheduleInfoToCart(newCart, product, scheduleInfo);
                        return [
                            4,
                            saveAdditionalRemark(newCart)
                        ];
                    case 2:
                        data = _state.sent();
                        dispatch((0,actions_cart/* saveCart */.FP)(data));
                        // *** META PIXEL: AddToCart Implementation for Variant Start ***
                        if ( true && window.fbq && shouldFireAddToCart) {
                            addToCartData = prepareAddToCartData(product, storeInfo, selectedVariant, state.cost);
                            if (addToCartData) {
                                window.fbq("track", "AddToCart", addToCartData);
                                console.log("=== META PIXEL: AddToCart Event Fired for variant item ===");
                                console.log("=== AddToCart Data:", addToCartData);
                            }
                        }
                        _state.label = 3;
                    case 3:
                        return [
                            3,
                            6
                        ];
                    case 4:
                        newState = (0,mutateItemObjectWithCartData/* mutateItemObjectWithCartData */.L)(type, product, cartData, null, null, null, count);
                        addScheduleInfoToCart(newState, product, scheduleInfo);
                        return [
                            4,
                            saveAdditionalRemark(newState)
                        ];
                    case 5:
                        data1 = _state.sent();
                        dispatch((0,actions_cart/* saveCart */.FP)(data1));
                        // *** META PIXEL: AddToCart Implementation for Non-Variant Start ***
                        if ( true && window.fbq && shouldFireAddToCart) {
                            addToCartData1 = prepareAddToCartData(product, storeInfo, null, state.cost);
                            if (addToCartData1) {
                                window.fbq("track", "AddToCart", addToCartData1);
                                console.log("=== META PIXEL: AddToCart Event Fired for non-variant item ===");
                                console.log("===AddToCart Data:", addToCartData1);
                            }
                        }
                        _state.label = 6;
                    case 6:
                        dispatch((0,logs/* pushEventsLog */.U)({
                            event_name: "Cx_ATC",
                            data: {
                                store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id,
                                domain: storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.domain,
                                page: window.location.href,
                                device: deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf ? "Mobile" : "Desktop",
                                cx_number: userData === null || userData === void 0 ? void 0 : (ref1 = userData.data) === null || ref1 === void 0 ? void 0 : ref1.phone
                            }
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCart(type) {
            return _ref.apply(this, arguments);
        };
    }();
    var onBuyNowClick = function() {
        var ref;
        setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isRedirect: true
            });
        });
        var itemIndex = (0,itemIndexFromCart/* itemIndexFromCart */.R)(cartData, product);
        if (itemIndex === -1) handleCart("add");
        var payload = {
            item_id: product === null || product === void 0 ? void 0 : product.id,
            status: wishlist/* ITEM_WISHLIST_STATE.ADD_TO_CART */.U.ADD_TO_CART
        };
        {
            (state === null || state === void 0 ? void 0 : state.isItemWishlisted) && setWishlistState(payload);
        }
        router.push((0,routes.getRoute)(routes.PATH.CART, storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.domain));
    };
    /**
   * utility function to get quantity and current item data of product
   * @return {*} { quantity: num; selectedItem: any }
   */ var returnItemData = function() {
        var itemData = {
            quantity: 0,
            selectedItem: null
        };
        if (itemIndexInCart >= 0) {
            var ref, ref1, ref2;
            if (cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : (ref1 = ref[itemIndexInCart]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.variants_selected) === null || ref2 === void 0 ? void 0 : ref2.length) {
                var selectedVariant = (0,selectedVariantFromVariantList/* selectedVariantFromVariantList */.m)(cartData, itemIndexInCart, state.selectedVariantId);
                var ref3;
                itemData = {
                    quantity: (ref3 = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.quantity) !== null && ref3 !== void 0 ? ref3 : 0,
                    selectedItem: selectedVariant ? selectedVariant : null
                };
            } else {
                var ref4, ref5, ref6;
                itemData = {
                    quantity: cartData === null || cartData === void 0 ? void 0 : (ref4 = cartData.items) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[itemIndexInCart]) === null || ref5 === void 0 ? void 0 : ref5.quantity,
                    selectedItem: cartData === null || cartData === void 0 ? void 0 : (ref6 = cartData.items) === null || ref6 === void 0 ? void 0 : ref6[itemIndexInCart]
                };
            }
        }
        return itemData;
    };
    var disabledAdditionComponent = function() {
        var selectedItem = returnItemData().selectedItem;
        if (selectedItem && !!Object.keys(selectedItem).length && selectedItem.managed_inventory) {
            return selectedItem.quantity < selectedItem.available_quantity;
        }
        return true;
    };
    var onVariantSelect = function(selectedInd, item) {
        setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                activeVariant: selectedInd,
                selectedVariantId: item.variant_id,
                isMainProductLink: false
            });
        });
        setVariantOutOfStock(!item.available);
    };
    var numberClickFunc = function(e) {
        if (!((state.OSName === "Android" || state.OSName === "iPhone") && deviceWidth/* deviceWidth */.o < constants/* MAX_MOBILE_WIDTH */.Cf)) {
            e.preventDefault();
        }
    };
    /**
   * toggle function for product
   * Discription
   */ var toggleViewDescription = function() {
        /**
     * if use  collapsing the discription than
     * scroll the screen to the top
     */ if (state.viewDescription && window) {
            window === null || window === void 0 ? void 0 : window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
        setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                viewDescription: !state.viewDescription
            });
        });
    };
    var checkForEmiOptionsShowcase = function() {
        var ref, ref1;
        return !!(storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.emi_flag) && ((ref1 = state.cost) === null || ref1 === void 0 ? void 0 : ref1.discounted_price) >= MIN_EMI_AMOUNT && (allEmiOptions === null || allEmiOptions === void 0 ? void 0 : allEmiOptions.min_emi_amount);
    };
    /** This saves the additional remarks text belonging to the current select product or variant
   * to local state where it can be edited */ var hydrateAdditionalRemarks = function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
        var value = (0,_to_consumable_array/* default */.Z)(state.additionalRemark);
        if (itemIndexInCart === -1) return;
        if (state.activeVariant !== -1 && ((ref = cartData.items) === null || ref === void 0 ? void 0 : (ref1 = ref.variants_selected) === null || ref1 === void 0 ? void 0 : ref1[state.activeVariant])) (cartData === null || cartData === void 0 ? void 0 : (ref2 = cartData.items) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[itemIndexInCart]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.variants_selected) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[state.activeVariant]) === null || ref5 === void 0 ? void 0 : ref5.additional_remark) && value.push({
            id: (ref6 = cartData.items) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[itemIndexInCart]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.variants_selected) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[state.activeVariant]) === null || ref9 === void 0 ? void 0 : ref9.variant_id,
            remark: (cartData === null || cartData === void 0 ? void 0 : (ref10 = cartData.items) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[itemIndexInCart]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.variants_selected) === null || ref12 === void 0 ? void 0 : (ref13 = ref12[state.activeVariant]) === null || ref13 === void 0 ? void 0 : ref13.additional_remark) || ""
        });
        else (cartData === null || cartData === void 0 ? void 0 : (ref14 = cartData.items) === null || ref14 === void 0 ? void 0 : (ref15 = ref14[itemIndexInCart]) === null || ref15 === void 0 ? void 0 : ref15.additional_remark) && value.push({
            id: cartData === null || cartData === void 0 ? void 0 : (ref16 = cartData.items) === null || ref16 === void 0 ? void 0 : (ref17 = ref16[itemIndexInCart]) === null || ref17 === void 0 ? void 0 : ref17.item_id,
            remark: (cartData === null || cartData === void 0 ? void 0 : (ref18 = cartData.items) === null || ref18 === void 0 ? void 0 : (ref19 = ref18[itemIndexInCart]) === null || ref19 === void 0 ? void 0 : ref19.additional_remark) || ""
        });
        value !== state.additionalRemark && setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                additionalRemark: value
            });
        });
    };
    var checkIsAdditionalRemarkDisabled = function() {
        var ref, ref1, ref2;
        return itemIndexInCart !== -1 && (state.activeVariant === -1 || state.activeVariant > -1 && ((ref = cartData.items) === null || ref === void 0 ? void 0 : (ref1 = ref[itemIndexInCart]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.variants_selected) === null || ref2 === void 0 ? void 0 : ref2.find(function(variant) {
            return variant.variant_id === product.variants[state.activeVariant].variant_id;
        })));
    };
    /** This takes additional remark text from input element & adds it to the local state along with the id (either product's/selected_variant's) it belong to
   * @param {*} remark - input value
   */ var handleAdditionalRemarksInput = function(remark) {
        var currentID = state.activeVariant > -1 ? product.variants[state.activeVariant].variant_id : product.id;
        var additionalRemark = (0,_to_consumable_array/* default */.Z)(state.additionalRemark);
        var isCurrentIdsRemarkAvailable = state.additionalRemark.findIndex(function(item) {
            return item.id == currentID;
        }) > -1;
        if (isCurrentIdsRemarkAvailable) {
            additionalRemark = additionalRemark.map(function(item) {
                return item.id === currentID ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                    remark: remark
                }) : item;
            });
        } else additionalRemark = (0,_to_consumable_array/* default */.Z)(state.additionalRemark).concat([
            {
                id: state.activeVariant > -1 ? product.variants[state.activeVariant].variant_id : product.id,
                isVariant: state.activeVariant > -1,
                remark: remark
            }, 
        ]);
        setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                additionalRemark: additionalRemark
            });
        });
    };
    /** This returns additional remark text belonging to the current product/variant selected
   * @return {string}
   */ var getAdditionalRemarkValue = function() {
        var ref;
        var currentID = state.activeVariant > -1 ? product.variants[state.activeVariant].variant_id : product.id;
        return ((ref = state.additionalRemark.find(function(item) {
            return item.id === currentID;
        })) === null || ref === void 0 ? void 0 : ref.remark) || "";
    };
    /** This adds additional remark to product/variants_selected before navigating to cart page
   * @param {*} cart - updated Cart object after Buy now click
   * @return {Promise}
   */ var saveAdditionalRemark = function(cart) {
        return new Promise(function(resolve) {
            var ref;
            var presentCart = cart || cartData;
            var itemIndexInCart = (0,itemIndexFromCart/* itemIndexFromCart */.R)(presentCart, product);
            // Return from here if no object with remark is present
            if (itemIndexInCart === -1 || state.additionalRemark.findIndex(function(item) {
                var ref;
                return ((ref = item.remark) === null || ref === void 0 ? void 0 : ref.trim()) !== "";
            }) === -1) {
                resolve(presentCart);
                return;
            }
            var newItems = presentCart === null || presentCart === void 0 ? void 0 : (ref = presentCart.items) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                if (item.item_id === product.id) {
                    var ref;
                    if (state.activeVariant === -1) return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                        additional_remark: ((ref = state.additionalRemark.find(function(remarkItem) {
                            return remarkItem.id === product.id;
                        })) === null || ref === void 0 ? void 0 : ref.remark) || ""
                    });
                    else return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                        variants_selected: item.variants_selected.map(function(variant) {
                            var presentItem = state.additionalRemark.find(function(remarkItem) {
                                return remarkItem.id === variant.variant_id;
                            });
                            if (presentItem) return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variant), {
                                additional_remark: presentItem.remark
                            });
                            else return variant;
                        })
                    });
                } else return item;
            });
            var newCartData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, presentCart), {
                items: newItems
            });
            dispatch((0,actions_cart/* setCart */.RV)(newCartData, function(data) {
                dispatch((0,actions_cart/* saveCart */.FP)(data));
                resolve(newCartData);
            }));
        });
    };
    var goToCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(cart) {
            var ref, payload;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        payload = {
                            item_id: product === null || product === void 0 ? void 0 : product.id,
                            status: wishlist/* ITEM_WISHLIST_STATE.ADD_TO_CART */.U.ADD_TO_CART
                        };
                        {
                            (state === null || state === void 0 ? void 0 : state.isItemWishlisted) && setWishlistState(payload);
                        }
                        return [
                            4,
                            saveAdditionalRemark(cart)
                        ];
                    case 1:
                        _state.sent();
                        router.push((0,routes.getRoute)(routes.PATH.CART, storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.domain));
                        return [
                            2
                        ];
                }
            });
        });
        return function goToCart(cart) {
            return _ref.apply(this, arguments);
        };
    }();
    var shouldReviewItem = function() {
        if (reviewSettings === null || reviewSettings === void 0 ? void 0 : reviewSettings.verified_buyer) return verifedBuyer;
        return true;
    };
    var scrollToReviewsSection = function() {
        if (!shouldReviewItem()) return;
        document.getElementById("reviews-section").scrollIntoView();
    };
    var commonCartCtaProps = {
        goToCart: goToCart,
        returnItemData: returnItemData,
        itemIndexInCart: itemIndexInCart,
        onBuyNowClick: onBuyNowClick,
        handleCart: handleCart,
        disabledAdditionComponent: disabledAdditionComponent,
        variantOutOfStock: variantOutOfStock,
        isPDPPage: true
    };
    var shouldApplyStylesAccordingToAspectRatio = function() {
        var ref, ref1;
        return (storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : ref.custom_theme_flag) && !isMobile && (storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.theme) === null || ref1 === void 0 ? void 0 : ref1.product_aspect_ratio) !== 100;
    };
    var getPdpMainDetailsStylesAccordingToImageAspectRatio = function() {
        var ref, ref1;
        var isCustomWebsite = storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.theme) === null || ref === void 0 ? void 0 : ref.custom_theme_flag;
        var aspect_ratio = storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.theme) === null || ref1 === void 0 ? void 0 : ref1.product_aspect_ratio;
        if (!isCustomWebsite || isMobile) return {};
        if (aspect_ratio < 100) {
            return {
                flex: "0 1 auto",
                paddingLeft: 65
            };
        }
        return {};
    };
    var renderDesktopCtaButtonAccordingToStoreType = function() {
        var ref, ref1, ref2;
        if (!(product === null || product === void 0 ? void 0 : (ref = product.variants) === null || ref === void 0 ? void 0 : ref.length) && isB2bStore) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(B2bRequestForQuoteDesktop, {
                openRfqFormModal: actions_storeInfo/* toggleRfqFormModal */.H4,
                toggleAuthModal: toggleAuthModal,
                product: product,
                storeInfo: storeInfo
            });
        }
        if (isNotifyMeFeatureVisible && (0,isNotifyProductEnabled/* isNotifyProductEnabled */.Z)() && !product.available && !(product === null || product === void 0 ? void 0 : (ref1 = product.variants) === null || ref1 === void 0 ? void 0 : ref1.length) && !isMobile) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotifyProduct/* default */.Z, {
                product: product
            });
        }
        return !(product === null || product === void 0 ? void 0 : (ref2 = product.variants) === null || ref2 === void 0 ? void 0 : ref2.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PdpCartCta_CartCtaDesktop, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonCartCtaProps), {
                product: product,
                schedualerConstraints: schedualerConstraints,
                scheduleInfo: scheduleInfo,
                setShowSchedulerError: setShowSchedulerError
            }))
        });
    };
    var renderMobileCtaButtonAccordingToStoreType = function() {
        if (isB2bStore) {
            var ref;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(B2bRequestForQuoteMobile, {
                openRfqFormModal: actions_storeInfo/* toggleRfqFormModal */.H4,
                toggleAuthModal: toggleAuthModal,
                product: product,
                storeInfo: storeInfo,
                activeVariant: product === null || product === void 0 ? void 0 : (ref = product.variants) === null || ref === void 0 ? void 0 : ref[state.activeVariant]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PdpCartCta_CartCtaMobile, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonCartCtaProps), {
            product: product,
            schedualerConstraints: schedualerConstraints,
            scheduleInfo: scheduleInfo,
            setShowSchedulerError: setShowSchedulerError
        }));
    };
    var toggleAuthModal = function() {
        if ((userData === null || userData === void 0 ? void 0 : userData.isLogin) && state.showAuthModal) {
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    showAuthModal: false
                });
            });
        } else if ((userData === null || userData === void 0 ? void 0 : userData.isLogin) && !state.showAuthModal) {
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    showAuthModal: false
                });
            });
        } else {
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    showAuthModal: !state.showAuthModal
                });
            });
        }
    };
    var handleToggleWishlistClick = function(e) {
        var ref;
        (ref = e.stopPropagation) === null || ref === void 0 ? void 0 : ref.call(e);
        var payload = {
            item_id: product === null || product === void 0 ? void 0 : product.id,
            status: (state === null || state === void 0 ? void 0 : state.isItemWishlisted) ? wishlist/* ITEM_WISHLIST_STATE.REMOVE_FROM_WISHLIST */.U.REMOVE_FROM_WISHLIST : wishlist/* ITEM_WISHLIST_STATE.ITEM_WISHLISTED */.U.ITEM_WISHLISTED
        };
        setWishlistState(payload, function(status) {
            if (status) {
                setState(function(prevState) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                        isItemWishlisted: !(prevState === null || prevState === void 0 ? void 0 : prevState.isItemWishlisted)
                    });
                });
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pre-pdp-page",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FullPageLoader/* FullPageLoader */.B, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(getProductSchema({
                        product: product,
                        storePolicy: storePolicy,
                        storeUrl: storeUrl
                    }))
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(getBreadcrumbSchema({
                        product: product,
                        storeUrl: storeUrl,
                        collectionItems: collectionItems
                    }))
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    (ref3 = (0,specificThemeRender/* specificThemeRender */.t)(storeInfo)) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.components) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.Header) === null || ref5 === void 0 ? void 0 : ref5.map(function(layout) {
                        return (0,themeImports/* getThemeComponent */.s)(layout.sub_type, layout.name, layout);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                        className: "pdp__main",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                className: "pdp__main--content",
                                children: [
                                    isComponentMounted && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: shouldApplyStylesAccordingToAspectRatio() ? "flexAuto" : "",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "pdp__main--content--leftContent",
                                            children: [
                                                isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileImageComponent_MobileImageComponent, {
                                                    productData: product,
                                                    handleShowImageDescriptionModal: handleShowImageDescriptionModal,
                                                    showImageDescModal: showImageDescModal,
                                                    activeIdx: state.activeVariant,
                                                    mainImageIndexFromPdp: mainImageIndexFromPdp,
                                                    setMainImageIndexFromPdp: setMainImageIndexFromPdp,
                                                    handleToggleWishlistClick: handleToggleWishlistClick,
                                                    isItemWishlisted: state === null || state === void 0 ? void 0 : state.isItemWishlisted
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopImageComponent_DesktopImageComponent, {
                                                    productData: product,
                                                    handleShowImageDescriptionModal: handleShowImageDescriptionModal,
                                                    activeIdx: state.activeVariant,
                                                    mainImageIndexFromPdp: mainImageIndexFromPdp,
                                                    setMainImageIndexFromPdp: setMainImageIndexFromPdp,
                                                    handleToggleWishlistClick: handleToggleWishlistClick,
                                                    isItemWishlisted: state === null || state === void 0 ? void 0 : state.isItemWishlisted
                                                }),
                                                (0,isStoreServiceBased/* isStoreServiceBased */.A)() && !isB2bStore && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "pdp__main--content--remarks-input-wrapper",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            className: "pdp__main--content--remarks-input-wrapper__input ".concat(!getAdditionalRemarkValue() ? "no-count-shown" : ""),
                                                            placeholder: "Additional Remarks, eg. Time slot, etc.",
                                                            onChange: function(e) {
                                                                return handleAdditionalRemarksInput(e.target.value);
                                                            },
                                                            value: getAdditionalRemarkValue(),
                                                            maxLength: 200,
                                                            disabled: checkIsAdditionalRemarkDisabled()
                                                        }),
                                                        getAdditionalRemarkValue() ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: "pdp__main--content--remarks-input-wrapper__text-counter",
                                                            children: [
                                                                getAdditionalRemarkValue().length,
                                                                "/200"
                                                            ]
                                                        }) : null
                                                    ]
                                                }),
                                                renderMobileCtaButtonAccordingToStoreType()
                                            ]
                                        })
                                    }),
                                    isComponentMounted && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                        style: getPdpMainDetailsStylesAccordingToImageAspectRatio(),
                                        className: "pdp__main--details",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "details__box",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                        className: "details__box--name tw-my-0",
                                                        children: product === null || product === void 0 ? void 0 : product.name
                                                    }),
                                                    product && product.name && /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                                                        className: "details__box--categoryname",
                                                        children: product === null || product === void 0 ? void 0 : product.brand_name
                                                    }),
                                                    (product === null || product === void 0 ? void 0 : (ref6 = product.store_item_review_rating) === null || ref6 === void 0 ? void 0 : ref6.review_rating) && (product === null || product === void 0 ? void 0 : (ref7 = product.store_item_review_rating) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.review_rating) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[0]) === null || ref9 === void 0 ? void 0 : ref9.avg_rating) && (reviewSettings === null || reviewSettings === void 0 ? void 0 : reviewSettings.status) && isCRRFeatureUnlocked ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "inline-flex items-center mt10px pv6px ph8px br2",
                                                        style: {
                                                            backgroundColor: "#f5f5f5"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingBox/* default */.Z, {
                                                                isVisible: product === null || product === void 0 ? void 0 : (ref10 = product.store_item_review_rating) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.review_rating) === null || ref11 === void 0 ? void 0 : (ref12 = ref11[0]) === null || ref12 === void 0 ? void 0 : ref12.avg_rating,
                                                                isPdp: true,
                                                                rating: (product === null || product === void 0 ? void 0 : (ref13 = product.store_item_review_rating) === null || ref13 === void 0 ? void 0 : ref13.review_rating) && ((ref15 = product === null || product === void 0 ? void 0 : (ref14 = product.store_item_review_rating) === null || ref14 === void 0 ? void 0 : ref14.review_rating[0]) === null || ref15 === void 0 ? void 0 : ref15.avg_rating),
                                                                isNewStyledRatingBox: true
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                className: "mv0 f14px fw4 black-color pl8px",
                                                                children: [
                                                                    product === null || product === void 0 ? void 0 : (ref16 = product.store_item_review_rating) === null || ref16 === void 0 ? void 0 : ref16.ratings_count,
                                                                    " Rating",
                                                                    (product === null || product === void 0 ? void 0 : (ref17 = product.store_item_review_rating) === null || ref17 === void 0 ? void 0 : ref17.ratings_count) > 1 ? "s" : ""
                                                                ]
                                                            })
                                                        ]
                                                    }) : null,
                                                    isB2bStore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(B2bProductPriceRange, {
                                                        storeInfo: storeInfo,
                                                        price_range: state.cost.price_range
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                                        className: "details__box--price",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "details__box--price-container",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        className: "details__box--price-value details__box--price-discounted",
                                                                        style: {
                                                                            color: storeInfo === null || storeInfo === void 0 ? void 0 : (ref18 = storeInfo.theme) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.colors) === null || ref19 === void 0 ? void 0 : ref19.primary_color
                                                                        },
                                                                        children: [
                                                                            "₹",
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                children: (ref20 = state.cost) === null || ref20 === void 0 ? void 0 : ref20.discounted_price
                                                                            })
                                                                        ]
                                                                    }),
                                                                    ((ref21 = state.cost) === null || ref21 === void 0 ? void 0 : ref21.price) !== ((ref22 = state.cost) === null || ref22 === void 0 ? void 0 : ref22.discounted_price) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        className: "details__box--price-value details__box--price-actual",
                                                                        children: [
                                                                            "₹",
                                                                            (ref23 = state.cost) === null || ref23 === void 0 ? void 0 : ref23.price
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            !!state.discountPercentage && !isB2bStore && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "details__box--price-value details__box--price-percentage",
                                                                children: [
                                                                    state.discountPercentage,
                                                                    "% OFF"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    (0,storeGSTStatus/* isStoreGstIncluded */.u)() && isComponentMounted && /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                                                        className: "details__box-gst-tax-inclusive",
                                                        children: "Inclusive of all taxes"
                                                    }),
                                                    (0,storeGSTStatus/* isStoreGstExcluded */.n)() && isComponentMounted && /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                                        className: "details__box-gst-tax-exclusive",
                                                        children: [
                                                            "+",
                                                            product === null || product === void 0 ? void 0 : (ref24 = product.tax) === null || ref24 === void 0 ? void 0 : ref24.gst,
                                                            "% GST Charges"
                                                        ]
                                                    }),
                                                    (0,isWishlistUnlockedAndActive/* isWishlistUnlockedAndActive */.r)() && /*#__PURE__*/ (0,jsx_runtime.jsx)(Components_WishlistShareButton, {
                                                        handleToggleWishlistClick: handleToggleWishlistClick,
                                                        productData: product,
                                                        isItemWishlisted: state === null || state === void 0 ? void 0 : state.isItemWishlisted
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                                        className: "details__box--additional-offer",
                                                        children: [
                                                            checkForEmiOptionsShowcase() && !isB2bStore ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "flex pre overflow-hidden",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                        children: "EMI"
                                                                    }),
                                                                    " starts at ",
                                                                    config/* CURRENCY_SYMBOL */.o,
                                                                    allEmiOptions === null || allEmiOptions === void 0 ? void 0 : allEmiOptions.min_emi_amount,
                                                                    "/month",
                                                                    " ",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        className: "flex flex-auto items-center",
                                                                        onClick: toggleEmiModal,
                                                                        children: [
                                                                            "Know More",
                                                                            " ",
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                alt: "Know More",
                                                                                src: "https://cdn.dotpe.in/longtail/themes/8073865/guPhsaIx.webp",
                                                                                width: "14px"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }) : null,
                                                            (paymentOffersList === null || paymentOffersList === void 0 ? void 0 : paymentOffersList.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "flex pre overflow-hidden",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                        children: "Bank Offer"
                                                                    }),
                                                                    " available",
                                                                    " ",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        className: "flex flex-auto items-center",
                                                                        onClick: toggleBankOfferModal,
                                                                        children: [
                                                                            "Know More",
                                                                            " ",
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                alt: "Know More",
                                                                                src: "https://cdn.dotpe.in/longtail/themes/8073865/guPhsaIx.webp",
                                                                                width: "14px"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }) : null
                                                        ]
                                                    }),
                                                    deviceWidth/* deviceWidth */.o > constants/* MAX_MOBILE_WIDTH */.Cf && (userData === null || userData === void 0 ? void 0 : userData.isLogin) && (reviewSettings === null || reviewSettings === void 0 ? void 0 : reviewSettings.status) && isCRRFeatureUnlocked ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "flex items-center pv8px pointer",
                                                                onClick: scrollToReviewsSection,
                                                                style: {
                                                                    color: shouldReviewItem() ? "#28292C" : "#E2E2E2"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        "data-tip": true,
                                                                        "data-for": "review-this-product",
                                                                        className: "fw6 f14px pr8px mv0",
                                                                        children: "Review this product"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        alt: "Review this product",
                                                                        src: shouldReviewItem() ? "/assets/images/right-arrow.svg" : "/assets/images/grey-right-arrow.svg",
                                                                        width: "16px",
                                                                        height: "8px"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                                                                id: "review-this-product",
                                                                place: "bottom",
                                                                multiline: true,
                                                                effect: "solid",
                                                                padding: "8px",
                                                                disable: shouldReviewItem(),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    className: "mv0 fw5 f12px",
                                                                    children: [
                                                                        "Only buyers of this item can submit reviews. If you have any",
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                        "concerns, please share them with us and we would look into it."
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }) : null,
                                                    !isB2bStore && !(product === null || product === void 0 ? void 0 : product.variants_count) && (0,checkForLimitedQuantity/* checkForLimitedQuantity */.U)(product) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                                        className: "highlighter-red-color f12px mt2",
                                                        children: [
                                                            "Hurry! Only ",
                                                            product === null || product === void 0 ? void 0 : product.available_quantity,
                                                            " units left!"
                                                        ]
                                                    }) : null,
                                                    (storeInfo === null || storeInfo === void 0 ? void 0 : (ref25 = storeInfo.services) === null || ref25 === void 0 ? void 0 : ref25.store_flag) === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                                        className: "details__box--store-closed",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "details__box--store-closed-icon",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoStoreInfoIcon/* NoStoreInfoIcon */.T, {})
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "details__box--store-closed-para",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    children: [
                                                                        "We are not accepting online orders right now.",
                                                                        " ",
                                                                        !!storePhone && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                            children: [
                                                                                "For queries, call us at",
                                                                                " ",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    href: "tel:".concat(storePhone),
                                                                                    onClick: numberClickFunc,
                                                                                    children: storePhone
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantDescription_VariantDescription, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                itemLowQty: product === null || product === void 0 ? void 0 : product.low_quantity,
                                                activeIdx: state.activeVariant,
                                                onVariantSelect: onVariantSelect
                                            }, commonCartCtaProps), {
                                                product: product,
                                                toggleAuthModal: toggleAuthModal,
                                                storeInfo: storeInfo,
                                                schedualerConstraints: schedualerConstraints,
                                                scheduleInfo: scheduleInfo,
                                                setScheduleInfo: function(data) {
                                                    setScheduleData(data);
                                                    changeSchedulingInfoAndSetCart(data, itemIndexInCart);
                                                },
                                                showSchedulerError: showSchedulerError,
                                                setShowSchedulerError: setShowSchedulerError
                                            })),
                                            !hasVariant && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductScheduler/* default */.Z, {
                                                schedualerConstraints: schedualerConstraints,
                                                showSchedulerError: showSchedulerError,
                                                setScheduleInfo: function(data) {
                                                    setShowSchedulerError(false);
                                                    setScheduleData(data);
                                                    changeSchedulingInfoAndSetCart(data, itemIndexInCart);
                                                },
                                                scheduleInfo: scheduleInfo,
                                                customClasses: !checkClientDeviceType/* IS_DESKTOP */.yn && (product === null || product === void 0 ? void 0 : (ref26 = product.variants) === null || ref26 === void 0 ? void 0 : ref26.length) ? "tw-pt-[20px]" : ""
                                            }),
                                            renderDesktopCtaButtonAccordingToStoreType(),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SatisfiedBogoPromos/* default */.Z, {
                                                // type={PROMO_APPLICABILITY_TYPES.PRODUCT}
                                                productId: product === null || product === void 0 ? void 0 : product.id
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AllProductPagePromos/* default */.Z, {
                                                type: promos/* PROMO_APPLICABILITY_TYPES.PRODUCT */.d.PRODUCT,
                                                productId: product === null || product === void 0 ? void 0 : product.id
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckItemDelivery/* default */.Z, {
                                                itemsPrice: (ref27 = state.cost) === null || ref27 === void 0 ? void 0 : ref27.discounted_price,
                                                item_name: product === null || product === void 0 ? void 0 : product.name,
                                                item_id: product === null || product === void 0 ? void 0 : product.id
                                            }),
                                            !!(product === null || product === void 0 ? void 0 : product.description) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "details__box mt24px ",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        className: "details__box--descTitle tw-my-0",
                                                        children: "Product Description"
                                                    }),
                                                    (product === null || product === void 0 ? void 0 : product.description.length) > 200 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "mt8px",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "details__box--descText",
                                                                dangerouslySetInnerHTML: {
                                                                    __html: product === null || product === void 0 ? void 0 : product.description.substr(0, 200)
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "details__box--descText ".concat(state.viewDescription ? "tw-visible" : "tw-hidden"),
                                                                dangerouslySetInnerHTML: {
                                                                    __html: product === null || product === void 0 ? void 0 : product.description.substr(200)
                                                                }
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "details__box--descText-utility",
                                                                onClick: toggleViewDescription,
                                                                children: [
                                                                    "...Read ",
                                                                    state.viewDescription ? "Less" : "More"
                                                                ]
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "details__box--descText",
                                                        dangerouslySetInnerHTML: {
                                                            __html: product === null || product === void 0 ? void 0 : product.description
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreInfoTable_MoreInfoTable, {
                                                productData: product
                                            })
                                        ]
                                    })
                                ]
                            }),
                            showDetailedDescription ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailedDescription/* default */.Z, {
                                className: "html-description",
                                detailedDescription: product === null || product === void 0 ? void 0 : product.description_detail
                            }) : null,
                            (reviewSettings === null || reviewSettings === void 0 ? void 0 : reviewSettings.status) && isCRRFeatureUnlocked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewsSection/* default */.Z, {
                                shouldReviewItem: shouldReviewItem,
                                product: product
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestedProducts, {})
                        ]
                    }),
                    (ref28 = (0,specificThemeRender/* specificThemeRender */.t)(storeInfo)) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.components) === null || ref29 === void 0 ? void 0 : (ref30 = ref29.Footer) === null || ref30 === void 0 ? void 0 : ref30.map(function(layout) {
                        return (0,themeImports/* getThemeComponent */.s)(layout.sub_type, layout.name, layout);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantModal["default"], {
                isRedirect: state.isRedirect
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantChooseRepeatModal["default"], {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantSelectedListModal["default"], {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageDescriptionModal_ImageDescriptionModal, {
                showImageDescModal: showImageDescModal,
                handleShowImageDescriptionModal: handleShowImageDescriptionModal,
                productData: product,
                activeIdx: state.activeVariant,
                mainImageIndexFromPdp: mainImageIndexFromPdp
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_EmiModal, {
                open: emiModalShow,
                onClose: toggleEmiModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BankOfferModal, {
                open: bankOfferModal,
                onClose: toggleBankOfferModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_toastify_esm/* ToastContainer */.Ix, {
                limit: 1
            }, "pdp-toasts"),
            state.showAuthModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal, {
                toggleModal: toggleAuthModal,
                isVisible: state.showAuthModal
            }),
            (personalizedProduct === null || personalizedProduct === void 0 ? void 0 : personalizedProduct.personalizationPopUp) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCustomizationPopUp/* ProductCustomizationPopUp */.X, {
                scheduleInfo: scheduleInfo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuntityUnavailableAlert/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var ProductDescription = (ProductDescPage);


/***/ }),

/***/ 780058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ useItemClick; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(147568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(197582);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
;// CONCATENATED MODULE: ./src/utils/storeProductClickedDetails.js

function storeProductClickedDetails() {
    var expiresAt = new Date(new Date().getTime() + 30000);
    var sessionObject = {
        expiresAt: expiresAt,
        itemClickedData: {
            CLICKED_ITEM_X_OFFSET: scrollX,
            CLICKED_ITEM_Y_OFFSET: scrollY
        }
    };
    sessionStorage.setItem(constants/* CLICKED_ITEM_OBJ */.uI, JSON.stringify(sessionObject));
}

// EXTERNAL MODULE: ./src/utils/canShowPDPSystem.js
var canShowPDPSystem = __webpack_require__(813051);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/utils/productUtils.ts
var productUtils = __webpack_require__(236913);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
// EXTERNAL MODULE: ./src/utils/isStoreB2B.js
var isStoreB2B = __webpack_require__(43935);
;// CONCATENATED MODULE: ./src/hooks/useItemClick.js










function useItemClick() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var storeData = (0,es/* useSelector */.v9)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var getProductRoute = function(product) {
        var ref;
        var productUrl = product === null || product === void 0 ? void 0 : product.link;
        var productRoute = (0,routes.getRoute)((0,productUtils/* getProductPathFromUrl */.ts)(productUrl, false), storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain);
        return productRoute;
    };
    /**
   * to go to product description page, special characters are not allowed.
   * using regex to remove all special characters with '-'
   * @param {*} item
   * @param {*} e
   */ var onItemClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
            var e, openInNewTab, ref, getRoute, productRoute, paramStr, productRouteWithParam;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : null, openInNewTab = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                        storeProductClickedDetails();
                        e && (e === null || e === void 0 ? void 0 : e.stopPropagation());
                        sessionStorage.setItem(constants/* CLICKED_ITEM_X_OFFSET */.AB, scrollX);
                        sessionStorage.setItem(constants/* CLICKED_ITEM_Y_OFFSET */.WR, scrollY);
                        return [
                            4,
                            Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 540190)).then(function(module) {
                                return module.getRoute;
                            })
                        ];
                    case 1:
                        getRoute = _state.sent();
                        return [
                            4,
                            getProductRoute(item, getRoute)
                        ];
                    case 2:
                        productRoute = _state.sent();
                        /** if color is there push with color in query params */ if (item === null || item === void 0 ? void 0 : item.color) {
                            paramStr = "?color=".concat(item === null || item === void 0 ? void 0 : item.color);
                            productRouteWithParam = productRoute + paramStr;
                            window.location.href = productRouteWithParam;
                        } else if (!(0,canShowPDPSystem/* canShowPDPSystem */.R)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.theme_class) && !(0,isStoreB2B/* isB2BStore */.h)()) {
                            dispatch((0,catalog/* savePDPData */.zP)({
                                visible: true,
                                product: item
                            }));
                        } else {
                            openInNewTab ? window.open(productRoute, "_blank") : window.location.href = productRoute;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onItemClick(item) {
            return _ref.apply(this, arguments);
        };
    }();
    var getLink = function(item, getRoute) {
        var ref;
        if (!item) {
            return;
        }
        var productRoute = getProductRoute(item, getRoute);
        var productLink = "";
        if (item === null || item === void 0 ? void 0 : item.color) {
            var paramStr = "?color=".concat(item === null || item === void 0 ? void 0 : item.color);
            productLink = productRoute + paramStr;
        } else if ((0,canShowPDPSystem/* canShowPDPSystem */.R)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.theme_class)) {
            productLink = productRoute;
        }
        return productLink || "";
    };
    return [
        onItemClick,
        getLink
    ];
}


/***/ }),

/***/ 577412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(331399);
/* harmony import */ var _containers_ProductDescription__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(227172);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(268037);
/* harmony import */ var src_containers_404Page__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(692687);
/**
 * Product Description Route
 */ 







var ProductDescPage = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20;
    (0,_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSetSSRStore */ .Vn)(props.ssrStore);
    var storeInfo = (0,_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect)(function() {
        window.scrollTo(0, 0);
    }, []);
    if (props === null || props === void 0 ? void 0 : props.notFound) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_containers_404Page__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        store: storeInfo,
        title: (props === null || props === void 0 ? void 0 : (ref = props.advCustomSeoDetails) === null || ref === void 0 ? void 0 : (ref1 = ref.title) === null || ref1 === void 0 ? void 0 : ref1.value) ? props === null || props === void 0 ? void 0 : (ref2 = props.advCustomSeoDetails) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.title) === null || ref3 === void 0 ? void 0 : ref3.value : "Order ".concat(props === null || props === void 0 ? void 0 : (ref4 = props.product) === null || ref4 === void 0 ? void 0 : ref4.name, " Online From ").concat(storeInfo === null || storeInfo === void 0 ? void 0 : (ref5 = storeInfo.store_info) === null || ref5 === void 0 ? void 0 : ref5.name).concat((storeInfo === null || storeInfo === void 0 ? void 0 : (ref6 = storeInfo.address) === null || ref6 === void 0 ? void 0 : ref6.visibility) === 1 && ((ref7 = storeInfo.address) === null || ref7 === void 0 ? void 0 : ref7.city) ? ",".concat((ref8 = storeInfo.address) === null || ref8 === void 0 ? void 0 : ref8.city) : ""),
        OGTitle: (props === null || props === void 0 ? void 0 : (ref9 = props.advCustomSeoDetails) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.og_title) === null || ref10 === void 0 ? void 0 : ref10.value) || null,
        OGDescription: (props === null || props === void 0 ? void 0 : (ref11 = props.advCustomSeoDetails) === null || ref11 === void 0 ? void 0 : ref11.og_description) || null,
        Icon: props === null || props === void 0 ? void 0 : (ref12 = props.product) === null || ref12 === void 0 ? void 0 : ref12.thumbnail_url,
        metaDescription: (props === null || props === void 0 ? void 0 : (ref13 = props.advCustomSeoDetails) === null || ref13 === void 0 ? void 0 : ref13.description) ? props === null || props === void 0 ? void 0 : (ref14 = props.advCustomSeoDetails) === null || ref14 === void 0 ? void 0 : ref14.description : "Order Online ".concat(props === null || props === void 0 ? void 0 : (ref15 = props.product) === null || ref15 === void 0 ? void 0 : ref15.name, " for Rs.").concat(props === null || props === void 0 ? void 0 : (ref16 = props.product) === null || ref16 === void 0 ? void 0 : ref16.price, ". Shop from ").concat(storeInfo === null || storeInfo === void 0 ? void 0 : (ref17 = storeInfo.store_info) === null || ref17 === void 0 ? void 0 : ref17.name, ",").concat((ref18 = storeInfo.address) === null || ref18 === void 0 ? void 0 : ref18.city, " | ").concat(props === null || props === void 0 ? void 0 : (ref19 = props.product) === null || ref19 === void 0 ? void 0 : ref19.description),
        isCustomDomain: props.isCustomDomain,
        canonicalTagUrl: props === null || props === void 0 ? void 0 : (ref20 = props.product) === null || ref20 === void 0 ? void 0 : ref20.link
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_ProductDescription__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props))
    }));
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ProductDescPage);


/***/ }),

/***/ 813051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ canShowPDPSystem; }
/* harmony export */ });
var canShowPDPSystem = function(themeVar) {
    switch(themeVar){
        case 1:
            return true;
        case 2:
            return true;
        case 3:
            return false;
        case 4:
            return false;
        default:
            return true;
    }
};


/***/ }),

/***/ 254051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ redirectToHomePage; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(540190);


var redirectToHomePage = function(path, domain) {
    next_router__WEBPACK_IMPORTED_MODULE_0___default().push((0,_routes__WEBPACK_IMPORTED_MODULE_1__.getRoute)(path, domain));
};


/***/ }),

/***/ 666466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ isStoreServiceBased; }
/* harmony export */ });
/* harmony import */ var _utils_getStoreType__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66871);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(913886);


function isStoreServiceBased() {
    return (0,_utils_getStoreType__WEBPACK_IMPORTED_MODULE_0__/* .getStoreType */ .K)() !== _constants__WEBPACK_IMPORTED_MODULE_1__/* .STORE_CUSTOMIZATION.ORDER_BASED */ .DO.ORDER_BASED;
}


/***/ }),

/***/ 291529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ isWishlistUnlockedAndActive; }
/* harmony export */ });
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(167261);
/* harmony import */ var src_constants_wishlist__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(298627);


function isWishlistUnlockedAndActive() {
    var ref, ref1, ref2, ref3;
    var stateData = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState();
    var isWishlistEnabled = stateData === null || stateData === void 0 ? void 0 : (ref = stateData.storeReducer) === null || ref === void 0 ? void 0 : (ref1 = ref.store) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.services) === null || ref2 === void 0 ? void 0 : ref2.wishlist_flag;
    var isWishlistSubscribed = (ref3 = stateData === null || stateData === void 0 ? void 0 : stateData.commonReducer.featureLocksData.featureLocks) === null || ref3 === void 0 ? void 0 : ref3.wishlist;
    return isWishlistEnabled === src_constants_wishlist__WEBPACK_IMPORTED_MODULE_1__/* .WISHLIST_FEATURE_STATUS.WISHLIST_ACTIVE */ .g.WISHLIST_ACTIVE && !(isWishlistSubscribed === null || isWishlistSubscribed === void 0 ? void 0 : isWishlistSubscribed.isLocked);
}


/***/ }),

/***/ 943090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ returnCommonConfigData; }
/* harmony export */ });
/**
 * common function to return config data for card configuration changes
 * @param {*} {activeCategoryConfig, productConfig}
 * @return {*} object - config
 */ var returnCommonConfigData = function(param) {
    var _activeCategoryConfig = param.activeCategoryConfig, activeCategoryConfig = _activeCategoryConfig === void 0 ? {} : _activeCategoryConfig, _productConfig = param.productConfig, productConfig = _productConfig === void 0 ? {} : _productConfig;
    if (activeCategoryConfig && Object.keys(activeCategoryConfig).length > 0) {
        return activeCategoryConfig;
    } else if (productConfig && Object.keys(productConfig).length > 0) {
        return productConfig;
    } else {
        return {};
    }
};


/***/ }),

/***/ 828631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ returnSpecificImageUrl; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(913886);
/* harmony import */ var _compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(940619);


/*
 returns either image_url or thumbnail_url,
 depending on the configuration of theme config 'product_image_quality_flag'
 */ function returnSpecificImageUrl(param) {
    var theme = param.theme, item = param.item;
    if (!theme || !(theme === null || theme === void 0 ? void 0 : theme.product_image_quality_flag)) return (0,_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getImageUrlFromCompressedImages */ .vb)(item === null || item === void 0 ? void 0 : item.compressed_images, item === null || item === void 0 ? void 0 : item.image_url, {
        maxImgSize: (0,_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getMaxImgSizeForComponent */ .N7)(_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__/* .componentTypeEnums.CARD */ .Xx.CARD)
    });
    return (theme === null || theme === void 0 ? void 0 : theme.product_image_quality_flag) === _constants__WEBPACK_IMPORTED_MODULE_0__/* .IMAGE_CONFIG_CONSTANT.THUMBNAIL_IMAGE */ .of.THUMBNAIL_IMAGE ? (item === null || item === void 0 ? void 0 : item.thumbnail_url) || (item === null || item === void 0 ? void 0 : item.image_url) : (0,_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getImageUrlFromCompressedImages */ .vb)(item === null || item === void 0 ? void 0 : item.compressed_images, item === null || item === void 0 ? void 0 : item.image_url, {
        maxImgSize: (0,_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__/* .getMaxImgSizeForComponent */ .N7)(_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_1__/* .componentTypeEnums.CARD */ .Xx.CARD)
    });
}


/***/ }),

/***/ 287243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ scrollOnPageLoad; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(913886);
/**
 * Checks whether sessionStorage has an item clicked data stored.
 * Then verifies whether the duration between clicked time and returning
 * back to home screen is > 30seconds. Then returns whether session storage
 * contains x and y coordinates of clicked item from PDP section.
 * If the session has those, then return the coordinates else return false.
 * This function is currently being used by Home component on page load.
 */ 
function scrollOnPageLoad() {
    var currTime = new Date();
    var sessionObject = JSON.parse(sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .CLICKED_ITEM_OBJ */ .uI));
    if (sessionObject) {
        var expirationTime = sessionObject === null || sessionObject === void 0 ? void 0 : sessionObject.expiresAt;
        if (expirationTime && Date.parse(currTime) < Date.parse(expirationTime)) {
            var ref, ref1;
            var y_offset = sessionObject === null || sessionObject === void 0 ? void 0 : (ref = sessionObject.itemClickedData) === null || ref === void 0 ? void 0 : ref.CLICKED_ITEM_Y_OFFSET;
            var x_offset = sessionObject === null || sessionObject === void 0 ? void 0 : (ref1 = sessionObject.itemClickedData) === null || ref1 === void 0 ? void 0 : ref1.CLICKED_ITEM_X_OFFSET;
            if (y_offset && y_offset !== 0) {
                return {
                    toScroll: true,
                    x_scroll: x_offset,
                    y_scroll: y_offset
                };
            }
        } else {
            sessionStorage.removeItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .CLICKED_ITEM_OBJ */ .uI);
        }
    }
    return {
        toScroll: false
    };
}


/***/ }),

/***/ 698616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ specificThemeRender; }
/* harmony export */ });
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(167261);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(186812);
/* harmony import */ var src_constants_subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(423653);



var specificThemeRender = function(storeData) {
    var isSubscriptionDemoPreview = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var mainTheme = (storeData === null || storeData === void 0 ? void 0 : storeData.theme) || {};
    var alternateTheme = (storeData === null || storeData === void 0 ? void 0 : storeData.store_premium_theme) || {};
    var isPremium = storeData === null || storeData === void 0 ? void 0 : storeData.premium;
    if (isSubscriptionDemoPreview || storeData.internal_admin_access === 1 || (storeData === null || storeData === void 0 ? void 0 : storeData.new_subscription_status) !== src_constants_subscription__WEBPACK_IMPORTED_MODULE_2__/* .NEW_SUBSCRIPTIONS_STATUS.INACTIVE */ .W0.INACTIVE) return mainTheme;
    var toggleMobileView = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().commonReducer.toggleMobileView;
    if (_utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__/* .deviceWidth */ .o > 998) {
        return isPremium || (mainTheme === null || mainTheme === void 0 ? void 0 : mainTheme.is_demo) === 1 || (mainTheme === null || mainTheme === void 0 ? void 0 : mainTheme.brand_website_flag) > 0 ? mainTheme : toggleMobileView ? mainTheme : alternateTheme;
    }
    return mainTheme;
};


/***/ }),

/***/ 870919:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"link_link__imOxT"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8388,1562,5675,5843,7856,9228,4429,437,5914,2878,1247,1033,1399,3978,2682,526,8557,9719,1788,6499,2287,1868,4505,2755,9748,9774,2888,179], function() { return __webpack_exec__(455695); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);